
(function () {
  "use strict";

  const root = document.getElementById("pp-collage-v1");
  if (!root || root.dataset.ready === "1") return;

  root.dataset.ready = "1";
  // The welcome sentence is redundant once the size selector follows the heading.
  // Remove only this specific introduction, preserving all other editor help text.
  const ppRedundantIntro = [...root.querySelectorAll(".ppc-head p")].find(p =>
    /Create a brand-new photo collage or continue with a design you have previously saved/i.test(p.textContent || "")
  );
  if (ppRedundantIntro) ppRedundantIntro.remove();
  // Move the existing Edit instructions to the top and remove the outdated note.
  const ppNotes = [...root.querySelectorAll(".ppc-note")];
  for (const note of ppNotes) {
    if ((note.textContent || "").trim().startsWith("Photo originals are not edited.")) note.remove();
  }
  const ppEditInstructions = ppNotes.find(note =>
    /Edit:\s*Click a photograph to crop/i.test((note.textContent || "").replace(/\s+/g, " "))
  );
  if (ppEditInstructions) {
    ppEditInstructions.classList.add("ppc-top-edit-instructions");
    ppEditInstructions.style.cssText =
      "display:block;box-sizing:border-box;width:100%;max-width:900px;" +
      "margin:12px auto 22px;padding:14px 17px;border-radius:13px;" +
      "background:#eff6ff;border:1px solid #c9dcff;color:#16345d;" +
      "font-size:14px;line-height:1.65;text-align:left;";
    const ppHeader = root.querySelector(".ppc-head");
    if (ppHeader) ppHeader.after(ppEditInstructions);
  }
  // V13.8: small, scoped visual improvements only.
  const pp138Style=document.createElement('style');
  pp138Style.textContent=`
    #pp-collage-v1 .ppc-v11-layouts {border-radius:18px!important;box-shadow:0 4px 18px rgba(21,57,96,.05)}
    #pp-collage-v1 .ppc-v11-layout-btn {transition:background .16s,border-color .16s,transform .16s}
    #pp-collage-v1 .ppc-v11-layout-btn:active {transform:scale(.985)}
    #pp-collage-v1 .ppc-v138-replace {display:inline-flex;align-items:center;justify-content:center;background:#eaf3ff;color:#174476;border:1px solid #a7c6ee;border-radius:10px;font-weight:750;padding:9px 13px;cursor:pointer;min-height:40px;margin:10px 0}
    #pp-collage-v1 .ppc-v138-replace:focus-visible {outline:3px solid #1265ee;outline-offset:2px}
    #pp-collage-v1 .ppc-v138-upload-progress {padding:10px 13px;border-radius:11px;background:#eef6ff;border:1px solid #c8dfff;font-size:13px;color:#163f70;line-height:1.5;margin:8px 0}
    #pp-collage-v1 .ppc-v138-upload-progress[hidden] {display:none!important}
    #pp-collage-v1 .ppc-v138-upload-progress progress {display:block;width:100%;height:8px;accent-color:#1769e0;margin-top:7px}
    @media(max-width:640px){#pp-collage-v1 .ppc-v11-layout-grid{gap:7px!important}#pp-collage-v1 .ppc-v11-layout-btn{min-height:110px!important}}
  `;
  document.head.appendChild(pp138Style);
  const pp165Style=document.createElement('style');
  pp165Style.textContent=`
    #pp-collage-v1 .ppc-review-photo-frame{position:relative!important}
    #pp-collage-v1 .ppc-v165-rotation-notice{position:absolute;top:7px;left:7px;z-index:3;
      padding:5px 9px;border-radius:8px;border:1px solid #e1b75b;background:#fff5d7;
      color:#6a4500;font-weight:750;font-size:12px;line-height:1.25;
      box-shadow:0 1px 5px rgba(0,0,0,.13);pointer-events:none}
  `;
  document.head.appendChild(pp165Style);



  // V14.9.53: Mobile Safari's dynamic viewport changes height as its address
  // bars expand/collapse during a scroll. Never derive the normal preview's
  // size from dvh: it creates a confusing zoom / clipping effect.
  const pp153StableMobilePreview = document.createElement('style');
  pp153StableMobilePreview.textContent = `
    @media (max-width:767px) {
      #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
      [data-editor] > .ppc-workspace > .ppc-canvas-stage {
        width:min(calc(100vw - 28px), calc(38svh * var(--ppc-stage-ratio, 1.5) + 16px))!important;
        max-width:calc(100vw - 28px)!important;
        height:auto!important;
        min-height:0!important;
        top:calc(78px + env(safe-area-inset-top, 0px))!important;
        padding:6px 10px 11px 6px!important;
        overflow:visible!important;
        transform:none!important;
        transition:none!important;
        contain:layout style!important;
      }
      #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
      .ppc-canvas-stage > [data-board] {
        display:block!important;
        width:100%!important;
        max-width:100%!important;
        height:auto!important;
        max-height:none!important;
        object-fit:contain!important;
        transform:none!important;
        transition:none!important;
        aspect-ratio:var(--ppc-stage-ratio, 1.5)!important;
      }
      #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
      .ppc-canvas-stage .ppc-wrap-reflection {display:none!important}
    }
  `;
  document.head.appendChild(pp153StableMobilePreview);
  // Reinsert after all legacy styles have loaded; retains highest cascade order.
  queueMicrotask(() => document.head.appendChild(pp153StableMobilePreview));

  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => [...root.querySelectorAll(selector)];
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  // V16: iOS WebKit benefits from lower simultaneous image decoding pressure.
  // Keep print originals and server-side artwork unchanged.
  const ppIsIOSWebKit = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const ppIsConstrainedMobile = ppIsIOSWebKit ||
    (window.matchMedia('(max-width: 767px)').matches &&
      Number(navigator.deviceMemory || 4) <= 2);


  // V14.9.11: Opaque backing for the sticky collage preview.
  // Only change the presentation frame, NEVER the [data-board] artwork:
  // customers' chosen gap colours, gradients and patterns must stay visible.
  const pp14911PreviewBacking = document.createElement('style');
  pp14911PreviewBacking.textContent = `
    #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
      [data-editor] > .ppc-workspace > .ppc-canvas-stage {
      background: #fff !important;
      background-color: #fff !important;
      background-image: none !important;
      isolation: isolate !important;
      opacity: 1 !important;
      backdrop-filter: none !important;
      -webkit-backdrop-filter: none !important;
    }
    @media (max-width: 767px) {
      #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
        [data-editor] > .ppc-workspace > .ppc-canvas-stage {
        border: 1px solid #e1e7ef !important;
        border-radius: 7px !important;
        box-shadow: 0 6px 20px rgba(22,33,49,.18) !important;
      }
    }
  `;
  document.head.appendChild(pp14911PreviewBacking);
  // V14.9.14: Screen-wide opaque backing for the MOBILE sticky preview.
  // This is outside the actual printed [data-board] and never becomes artwork.
  const pp1514MobileScreen = document.createElement('style');
  pp1514MobileScreen.textContent = `
    @media(max-width:767px){
      #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
      [data-editor] > .ppc-workspace > .ppc-canvas-stage{
        isolation:isolate!important;
        background:#fff!important;
        z-index:70!important;
      }
      #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
      [data-editor] > .ppc-workspace > .ppc-canvas-stage::before{
        content:''!important;
        position:absolute!important;
        left:50%!important;
        top:-14px!important;
        width:100vw!important;
        height:calc(100% + 30px)!important;
        transform:translateX(-50%)!important;
        background:#fff!important;
        opacity:1!important;
        z-index:-1!important;
        pointer-events:none!important;
        box-shadow:0 6px 12px rgba(20,30,55,.07)!important;
      }
    }
  `;
  document.head.appendChild(pp1514MobileScreen);


  // V12.2.2: accessible orientation shortcuts plus direct edit access in the photo strip.
  const thumbRotationCSS = document.createElement("style");
  thumbRotationCSS.textContent = `
    #pp-collage-v1 .ppc-thumb-turn-controls {display:grid;grid-template-columns:1fr 1.15fr 1fr;gap:3px;position:relative;z-index:3;justify-content:center;padding:3px 2px 5px;background:#fff;}
    #pp-collage-v1 .ppc-thumb-turn,
    #pp-collage-v1 .ppc-thumb-edit {min-height:30px;border:1px solid #c8daef;border-radius:7px;background:#eff6ff;color:#143960;font-weight:800;cursor:pointer;touch-action:manipulation;}
    #pp-collage-v1 .ppc-thumb-turn {font-size:18px;}
    #pp-collage-v1 .ppc-thumb-edit {font-size:12px;padding:0 6px;white-space:nowrap;}
    #pp-collage-v1 .ppc-thumb-turn:focus-visible,
    #pp-collage-v1 .ppc-thumb-edit:focus-visible {outline:3px solid #1365e8;outline-offset:1px;}
    #pp-collage-v1 .ppc-thumb-turn:disabled,
    #pp-collage-v1 .ppc-thumb-edit:disabled {opacity:.5;cursor:wait;}
    #pp-collage-v1 .ppc-thumb {position:relative;height:auto!important;min-height:0!important;overflow:visible!important;}
    #pp-collage-v1 .ppc-thumb-remove {position:absolute;top:6px;right:6px;z-index:5;width:24px;height:24px;border:0;border-radius:999px;background:rgba(17,24,39,.84);color:#fff;font-size:18px;line-height:1;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.18);padding:0;touch-action:manipulation;}
    #pp-collage-v1 .ppc-thumb-remove:hover {background:rgba(17,24,39,.94);}
    #pp-collage-v1 .ppc-thumb-remove:focus-visible {outline:3px solid #1365e8;outline-offset:2px;}
    @media (max-width: 640px) {
      #pp-collage-v1 .ppc-thumb-turn-controls {grid-template-columns:1fr;}
      #pp-collage-v1 .ppc-thumb-edit {min-height:28px;font-size:11px;}
    }
  `;
  document.head.appendChild(thumbRotationCSS);

  // V12.4.6: The finished collage itself is the photo editor. Hide the
  // redundant uploaded-photo thumbnail strip and its heading, without
  // removing photo data, review-stage controls, or crop functionality.
  const ppHideFinishedThumbsStyle = document.createElement('style');
  ppHideFinishedThumbsStyle.textContent = `
    #pp-collage-v1 [data-editor] > .ppc-workspace > .ppc-thumb-head,
    #pp-collage-v1 [data-editor] > .ppc-workspace > [data-thumbs] {
      display:none!important;
    }
  `;
  document.head.appendChild(ppHideFinishedThumbsStyle);

  // V12.4.4: Simplify the crop modal. These buttons are hidden in the UI,
  // while automatic border/screenshot trimming on upload remains enabled.
  // Keep the elements in the DOM because older theme markup may still refer
  // to their data attributes and event listeners.
  const ppCropSimplifiedStyle = document.createElement('style');
  ppCropSimplifiedStyle.textContent = `
    #pp-collage-v1 [data-trim-auto],
    #pp-collage-v1 [data-trim-keep],
    #pp-collage-v1 [data-select-all],
    #pp-collage-v1 [data-crop-reset],
    [data-crop-overlay] [data-trim-auto],
    [data-crop-overlay] [data-trim-keep],
    [data-crop-overlay] [data-select-all],
    [data-crop-overlay] [data-crop-reset] {display:none!important;}
  `;
  document.head.appendChild(ppCropSimplifiedStyle);
  // Also hide the controls directly in case older theme button rules win.
  for (const selector of ['[data-trim-auto]', '[data-trim-keep]', '[data-select-all]', '[data-crop-reset]']) {
    root.querySelectorAll(selector).forEach(button => {
      button.style.setProperty('display', 'none', 'important');
    });
  }

  // V10.2: Native iOS prompts are replaced with accessible in-page dialogs.
  const mobileUiCss = document.createElement('style');
  mobileUiCss.textContent = `
    #ppc-app-dialog {position:fixed;inset:0;z-index:2147483646;background:rgba(8,17,37,.75);display:flex;align-items:center;justify-content:center;padding:18px;box-sizing:border-box}
    #ppc-app-dialog[hidden] {display:none!important}
    #ppc-app-dialog .ppc-dialog-card {width:min(420px,100%);max-height:85dvh;overflow:auto;background:white;color:#101827;border-radius:20px;padding:24px;box-shadow:0 24px 80px #0005;font:inherit;box-sizing:border-box}
    #ppc-app-dialog input {width:100%;min-height:48px;border:1px solid #cbd5e1;border-radius:12px;padding:12px;font-size:16px;box-sizing:border-box}
    #ppc-app-dialog .ppc-dialog-buttons {display:flex;gap:10px;margin-top:20px;flex-wrap:wrap}
    #ppc-app-dialog button {flex:1;min-height:48px;border-radius:12px;border:1px solid #cbd5e1;background:#fff;color:#172033;font-size:15px;font-weight:700;padding:10px}
    #ppc-app-dialog button.ppc-primary {background:#1165e9;border-color:#1165e9;color:#fff}
    #ppc-app-toast {position:fixed;left:12px;right:12px;bottom:max(84px,env(safe-area-inset-bottom));margin:auto;max-width:480px;z-index:2147483647;background:#15243c;color:#fff;padding:14px 18px;border-radius:14px;box-shadow:0 8px 30px #0004;font-size:15px;line-height:1.4;display:none;box-sizing:border-box}
    #ppc-app-toast.ppc-visible {display:block}
    /* V10.4: Mobile welcome-screen action cards; scoped to the collage widget. */
    @media(max-width:780px){
      #pp-collage-v1 .ppc-head {margin:12px 10px 22px!important;padding:0 6px!important;}
      #pp-collage-v1 .ppc-head h2 {font-size:clamp(24px,7vw,33px)!important;line-height:1.16!important;overflow-wrap:break-word!important;}
      #pp-collage-v1 .ppc-head p {font-size:14px!important;line-height:1.5!important;padding:0 5px!important;}
      #pp-collage-v1 .ppc-start {display:grid!important;grid-template-columns:minmax(0,1fr)!important;gap:14px!important;width:100%!important;max-width:100%!important;margin:0 auto 24px!important;padding:0 14px!important;box-sizing:border-box!important;}
      #pp-collage-v1 .ppc-start[hidden] {display:none!important;}
      #pp-collage-v1 .ppc-start .ppc-card {display:flex!important;flex-direction:column!important;align-items:flex-start!important;justify-content:center!important;gap:7px!important;position:relative!important;width:100%!important;min-width:0!important;max-width:100%!important;min-height:118px!important;margin:0!important;padding:19px 20px!important;border-radius:17px!important;box-sizing:border-box!important;text-align:left!important;white-space:normal!important;overflow-wrap:anywhere!important;text-transform:none!important;line-height:1.35!important;letter-spacing:normal!important;box-shadow:0 5px 16px rgba(20,35,65,.1)!important;}
      #pp-collage-v1 .ppc-start .ppc-card:first-child {background:#135fe6!important;border:2px solid #135fe6!important;color:#fff!important;}
      #pp-collage-v1 .ppc-start .ppc-card:last-child {background:#f0f5ff!important;border:2px solid #b9cff9!important;color:#15345f!important;}
      #pp-collage-v1 .ppc-start .ppc-card strong {display:block!important;width:100%!important;margin:0!important;font-size:clamp(18px,5vw,22px)!important;font-weight:800!important;line-height:1.3!important;color:inherit!important;white-space:normal!important;overflow-wrap:anywhere!important;}
      #pp-collage-v1 .ppc-start .ppc-card span {display:block!important;max-width:100%!important;margin:0!important;font-size:14px!important;font-weight:500!important;line-height:1.5!important;white-space:normal!important;overflow-wrap:anywhere!important;color:inherit!important;opacity:.93!important;}
      #pp-collage-v1 .ppc-start .ppc-card:focus-visible {outline:3px solid #fcad21!important;outline-offset:3px!important;}
    }
    /* V10.3: Only display the five save/basket/design actions in the finished collage editor. */
    #pp-collage-v1.ppc-review-mode .ppc-save-controls {display:none!important}
    /* V11.1.4: Uploaded photos are already in the finished editor. Hide only the extra upload control here; keep it in photo review. */
    #pp-collage-v1:not(.ppc-review-mode) [data-editor] .ppc-upload {display:none!important}
    @media(max-width:767px){
      #pp-collage-v1 [data-ppc-photo],#pp-collage-v1 [data-ppc-photo] * {touch-action:none!important;-webkit-user-select:none!important;user-select:none!important;-webkit-touch-callout:none}
      #pp-collage-v1 [data-ppc-photo] {cursor:grab;}
      #pp-collage-v1 [data-crop-stage],#pp-collage-v1 [data-crop-selection] {touch-action:none!important}
      #pp-collage-v1 [data-editor] button {white-space:normal;overflow-wrap:anywhere}
      #pp-collage-v1 [data-editor] [data-ppc-save-design] {width:100%;}
      #ppc-v5-product-picker [role=dialog] {padding:20px!important}
      #ppc-v5-product-picker [role=dialog] button {font-size:16px!important;min-height:48px;max-width:100%}
    }
  `;
  document.head.appendChild(mobileUiCss);
  // V11.1.6: One real, interactive preview on mobile (not a duplicate).
  // Preserve the actual [data-board] DOM, dimensions, children and events,
  // so crop, swap, saved-thumbnail and Shopify print workflows use one board.
  const mobilePreviewOrderStyle = document.createElement('style');
  mobilePreviewOrderStyle.textContent = `
    @media (max-width: 767px) {
      #pp-collage-v1:not(.ppc-review-mode) [data-editor]:not([hidden]) {
        display:flex!important;flex-direction:column!important;
        align-items:stretch!important;gap:12px!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace {
        display:contents!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace > .ppc-workspace-head {
        order:-30!important;width:100%!important;margin:0!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace > [data-ppc-error] {
        order:-29!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace > .ppc-canvas-stage {
        order:-28!important;
        position:sticky!important;
        top:calc(8px + env(safe-area-inset-top, 0px))!important;
        z-index:35!important;
        max-width:100%!important;
        margin:0 auto 8px!important;
        /* Sticky wrapper retains the real clickable collage board inside.
           No CSS depth is added to [data-board], so saved thumbnails remain clean. */
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-v11-layouts {order:0!important;}
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-panel {order:1!important;}
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace > .ppc-thumb-head {order:3!important;}
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace > [data-thumbs] {order:4!important;}
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace > .ppc-note {order:5!important;}
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-save-controls {order:6!important;}
    }
  `;
  document.head.appendChild(mobilePreviewOrderStyle);

  // V11.1.7: Realistic visual canvas mockup, with the ORIGINAL editable
  // collage node kept intact for tap-to-crop, drag/swap, thumbnails and printing.
  // The stage is purely presentation: artwork is never modified or exported with
  // the frame, side depth, border, or showroom lighting.
  const ppcCanvasBoard = $('[data-board]');
  if (ppcCanvasBoard && !ppcCanvasBoard.closest('.ppc-canvas-stage')) {
    const stage = document.createElement('div');
    stage.className = 'ppc-canvas-stage';
    stage.setAttribute('aria-label', 'Interactive collage preview');
    ppcCanvasBoard.parentNode.insertBefore(stage, ppcCanvasBoard);
    stage.appendChild(ppcCanvasBoard);
  }

  // V15: Full-screen mobile preview. The original interactive board stays in place.
  const ppFullStyle = document.createElement('style');
  ppFullStyle.textContent = `
    #pp-collage-v1 .ppc-v15-expand {position:absolute;z-index:95;right:5px;top:5px;border:1px solid #a8b8ca;border-radius:999px;background:#fff;color:#173755;font:700 13px inherit;padding:9px 12px;min-height:40px;cursor:pointer;box-shadow:0 2px 10px #0002}
    #pp-collage-v1 .ppc-v15-expand:focus-visible {outline:3px solid #1265ee;outline-offset:2px}
    @media(max-width:767px) {
      #pp-collage-v1.ppc-v15-full-preview [data-editor] > .ppc-workspace > .ppc-canvas-stage {
        position:fixed!important;inset:0!important;top:0!important;left:0!important;
        width:100vw!important;height:100dvh!important;max-width:none!important;min-height:0!important;
        padding:calc(64px + env(safe-area-inset-top,0px)) 9px calc(22px + env(safe-area-inset-bottom,0px))!important;
        margin:0!important;background:#f1f4f8!important;border:0!important;border-radius:0!important;
        z-index:2147483000!important;display:flex!important;align-items:center!important;justify-content:center!important;
        box-sizing:border-box!important;overflow:hidden!important;box-shadow:none!important;
      }
      #pp-collage-v1.ppc-v15-full-preview .ppc-canvas-stage > [data-board] {
        width:min(calc(100vw - 18px), calc((100dvh - 120px) * var(--ppc-stage-ratio,1.5)))!important;
        max-width:100%!important;height:auto!important;max-height:calc(100dvh - 120px)!important;
        aspect-ratio:var(--ppc-stage-ratio,1.5)!important;flex:none!important;
      }
      #pp-collage-v1.ppc-v15-full-preview .ppc-canvas-stage::before,
      #pp-collage-v1.ppc-v15-full-preview .ppc-canvas-stage::after {display:none!important}
      #pp-collage-v1.ppc-v15-full-preview .ppc-canvas-stage .ppc-v15-expand {top:calc(10px + env(safe-area-inset-top,0px));right:12px}
      #pp-collage-v1.ppc-v15-full-preview .ppc-canvas-stage .ppc-wrap-edge {display:none!important}
    }
  `;
  document.head.appendChild(ppFullStyle);
  const ppStage = ppcCanvasBoard?.closest('.ppc-canvas-stage');
  if (ppStage) {
    const expand = document.createElement('button');
    expand.type='button'; expand.className='ppc-v15-expand';
    expand.textContent='⛶ Expand'; expand.setAttribute('aria-label','Expand collage preview');
    expand.setAttribute('aria-pressed','false');
    ppStage.appendChild(expand);
    const changeFull=(enabled)=>{
      root.classList.toggle('ppc-v15-full-preview',enabled);
      expand.textContent=enabled?'✕ Close preview':'⛶ Expand';
      expand.setAttribute('aria-pressed',String(enabled));
      expand.setAttribute('aria-label',enabled?'Close full-screen preview':'Expand collage preview');
    };
    expand.addEventListener('click',()=>changeFull(!root.classList.contains('ppc-v15-full-preview')));
    document.addEventListener('keydown',e=>{
      if(e.key==='Escape' && root.classList.contains('ppc-v15-full-preview')) changeFull(false);
    });
    const viewport=window.matchMedia('(max-width:767px)');
    const closeOnDesktop=()=>{if(!viewport.matches)changeFull(false)};
    if(viewport.addEventListener)viewport.addEventListener('change',closeOnDesktop);
    else viewport.addListener(closeOnDesktop);
  }

  // V11.2.0: Visual mirror/soft-focus wrap for the 18mm canvas mockup.
  // Edge reflections are generated from the SAME rendered face. They are
  // decorative, cannot intercept editing gestures, and are never printed.
  if (ppcCanvasBoard) {
    const canvasStage = ppcCanvasBoard.closest('.ppc-canvas-stage');
    if (canvasStage && !canvasStage.querySelector('.ppc-wrap-right')) {
      const rightEdge = document.createElement('div');
      const bottomEdge = document.createElement('div');
      rightEdge.className = 'ppc-wrap-edge ppc-wrap-right';
      bottomEdge.className = 'ppc-wrap-edge ppc-wrap-bottom';
      rightEdge.setAttribute('aria-hidden', 'true');
      bottomEdge.setAttribute('aria-hidden', 'true');
      canvasStage.append(rightEdge, bottomEdge);

      let wrapUpdateQueued = false;
      function refreshMockupWrap() {
        wrapUpdateQueued = false;
        if (!ppcCanvasBoard.isConnected) return;
        const w = ppcCanvasBoard.clientWidth;
        const h = ppcCanvasBoard.clientHeight;
        if (w < 2 || h < 2) return;

        // V14.9.53: On phones avoid cloning every photograph twice for the
        // decorative canvas edges. The original interactive preview and
        // production wrap are unchanged; this is presentation only.
        if (window.matchMedia('(max-width: 767px)').matches) {
          if (rightEdge.childNodes.length) rightEdge.replaceChildren();
          if (bottomEdge.childNodes.length) bottomEdge.replaceChildren();
          return;
        }

        function reflectedFace(axis) {
          const copy = ppcCanvasBoard.cloneNode(true);
          copy.removeAttribute('id');
          copy.removeAttribute('data-board');
          copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          copy.setAttribute('aria-hidden', 'true');
          copy.classList.add('ppc-wrap-reflection');
          copy.style.cssText =
            'position:absolute!important;left:0!important;top:0!important;' +
            'width:' + w + 'px!important;height:' + h + 'px!important;' +
            'max-width:none!important;min-width:0!important;' +
            'margin:0!important;padding:0!important;' +
            'aspect-ratio:auto!important;pointer-events:none!important;' +
            'box-shadow:none!important;transform-origin:center center!important;' +
            'transform:' + (axis === 'x' ? 'scaleX(-1)' : 'scaleY(-1)') + '!important;';
          return copy;
        }

        rightEdge.replaceChildren(reflectedFace('x'));
        bottomEdge.replaceChildren(reflectedFace('y'));
      }
      function queueWrapRefresh() {
        if (wrapUpdateQueued) return;
        wrapUpdateQueued = true;
        requestAnimationFrame(refreshMockupWrap);
      }
      const wrapObserver = new MutationObserver(queueWrapRefresh);
      wrapObserver.observe(ppcCanvasBoard, {
        childList:true, attributes:true, characterData:true, subtree:true
      });
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(queueWrapRefresh).observe(ppcCanvasBoard);
      } else {
        window.addEventListener('resize', queueWrapRefresh, {passive:true});
      }
      queueWrapRefresh();
    }
  }

  const ppcCanvasStyle = document.createElement('style');
  ppcCanvasStyle.textContent = `
    #pp-collage-v1 .ppc-canvas-stage {
      position:relative;
      display:block;
      isolation:isolate;
      box-sizing:border-box;
      /* Canvas scales to the SELECTED print proportions; no empty oversize mockup. */
      width:min(100%, calc(68dvh * var(--ppc-stage-ratio, 1.5) + 26px));
      max-width:100%;
      padding:10px 16px 17px 10px;
      margin:8px auto 20px;
      border-radius:3px;
      background:linear-gradient(135deg,#f9fafc,#d8dfe8);
      box-shadow:0 17px 30px rgba(22,33,49,.19),0 4px 8px rgba(22,33,49,.12);
    }
    /* V11.2.0 reflected artwork along the visible canvas edges. The reflection
       is clipped to the narrow right/bottom returns, then gently blurred. */
    #pp-collage-v1 .ppc-canvas-stage .ppc-wrap-edge {
      position:absolute;
      overflow:hidden;
      pointer-events:none!important;
      z-index:1;
      isolation:isolate;
      background:#9ea8b4;
    }
    #pp-collage-v1 .ppc-canvas-stage .ppc-wrap-right {
      right:5px;top:11px;bottom:17px;width:11px;
      transform:skewY(12deg);transform-origin:top left;
      box-shadow:2px 1px 5px rgba(0,0,0,.17);
    }
    #pp-collage-v1 .ppc-canvas-stage .ppc-wrap-bottom {
      left:11px;right:16px;bottom:6px;height:10px;
      transform:skewX(12deg);
      box-shadow:1px 2px 4px rgba(0,0,0,.13);
    }
    #pp-collage-v1 .ppc-canvas-stage .ppc-wrap-reflection {
      filter:blur(2px) saturate(.83) brightness(.78);
      pointer-events:none!important;
      overflow:hidden!important;
    }
    #pp-collage-v1 .ppc-canvas-stage .ppc-wrap-reflection * {
      pointer-events:none!important;
    }
    /* Right and lower canvas returns, resembling a stretched 18mm canvas. */
    #pp-collage-v1 .ppc-canvas-stage::before {
      content:'';
      position:absolute;
      pointer-events:none;
      right:5px;
      top:11px;
      bottom:17px;
      width:11px;
      transform:skewY(12deg);
      transform-origin:top left;
      background:linear-gradient(90deg,#d6dae0,#9aa1aa,#6c747d);
      box-shadow:3px 1px 5px rgba(0,0,0,.12);
      z-index:0;
    }
    #pp-collage-v1 .ppc-canvas-stage::after {
      content:'';
      position:absolute;
      pointer-events:none;
      left:11px;
      right:16px;
      bottom:6px;
      height:10px;
      transform:skewX(12deg);
      background:linear-gradient(180deg,#c1c9d2,#8d98a5);
      z-index:0;
    }
    #pp-collage-v1 .ppc-canvas-stage > [data-board] {
      position:relative!important;
      z-index:2;
      box-shadow:0 2px 4px rgba(0,0,0,.14);
      margin:0!important;
      width:100%!important;
      max-width:100%!important;
      height:auto!important;
      aspect-ratio:var(--ppc-stage-ratio, 3/2)!important;
      overflow:hidden!important;
      box-sizing:border-box!important;
      /* Keep the artwork interactive and exactly matching the canvas size. */
    }
    /* Keep the artwork controls high enough in the viewport on phones. */
    @media(max-width:767px) {
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace > .ppc-canvas-stage {
        width:min(100%, calc(38svh * var(--ppc-stage-ratio, 1.5) + 16px))!important;
        max-width:100%!important;
        padding:6px 10px 11px 6px;
        margin:0 auto 8px!important;
        border-radius:3px;
        box-shadow:0 7px 20px rgba(22,33,49,.18);
      }
      #pp-collage-v1 .ppc-canvas-stage .ppc-wrap-right {right:3px;top:7px;bottom:11px;width:6px}
      #pp-collage-v1 .ppc-canvas-stage .ppc-wrap-bottom {left:7px;right:10px;bottom:3px;height:6px}
      #pp-collage-v1 .ppc-canvas-stage::before {right:3px;top:7px;bottom:11px;width:6px}
      #pp-collage-v1 .ppc-canvas-stage::after {left:7px;right:10px;bottom:3px;height:6px}
    }
    /* Desktop: the design choices and editing controls stay LEFT,
       while the one genuine live preview starts at the TOP RIGHT. */
    @media(min-width:768px) {
      #pp-collage-v1:not(.ppc-review-mode) [data-editor]:not([hidden]) {
        display:grid!important;
        grid-template-columns:minmax(270px,340px) minmax(0,1fr)!important;
        grid-auto-rows:min-content!important;
        align-items:start!important;
        gap:18px 22px!important;
        width:100%!important;
        max-width:100%!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-v11-layouts {
        grid-column:1!important;
        grid-row:1!important;
        width:100%!important;
        max-width:100%!important;
        margin:0!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-panel {
        grid-column:1!important;
        grid-row:2!important;
        width:100%!important;
        max-width:100%!important;
        margin:0!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace {
        display:block!important;
        grid-column:2!important;
        grid-row:1 / span 5!important;
        width:100%!important;
        min-width:0!important;
        max-width:100%!important;
        margin:0!important;
        align-self:start!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-save-controls {
        grid-column:1!important;
        grid-row:3!important;
        width:100%!important;
      }
      /* The help copy remains available in the controls on mobile. The
         original line is not allowed to create a blank desktop grid row. */
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-photo-move-help {
        display:none!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace > .ppc-workspace-head {
        margin-top:0!important;
      }
    }
  `;
  document.head.appendChild(ppcCanvasStyle);
  // V14.6: Neutral canvas return eliminates the stray repeated-photo strip.
  const ppV146ReturnStyle=document.createElement('style');
  ppV146ReturnStyle.textContent='#pp-collage-v1 .ppc-wrap-edge .ppc-wrap-reflection{display:none!important} #pp-collage-v1 .ppc-wrap-edge{background:linear-gradient(140deg,#dce2e9,#8d99a6)!important}';
  document.head.appendChild(ppV146ReturnStyle);

  // V11.2.2: Keep the DESKTOP collage below Shopify's sticky header.
  // The real [data-board] remains interactive; this only positions its mockup stage.
  const desktopCanvasHeaderStyle = document.createElement('style');
  desktopCanvasHeaderStyle.textContent = `
    @media(min-width:768px) {
      #pp-collage-v1:not(.ppc-review-mode) [data-editor]:not([hidden]) >
      .ppc-workspace > .ppc-canvas-stage {
        position: sticky !important;
        top: var(--ppc-desktop-header-clearance, 185px) !important;
        z-index: 2 !important;
        /* Keep even tall portrait prints within the visible screen space. */
        width: min(100%, calc(max(180px, 100dvh - var(--ppc-desktop-header-clearance, 185px) - 40px) * var(--ppc-stage-ratio, 1.5) + 26px)) !important;
        max-width: 100% !important;
        margin-top: 0 !important;
      }
    }
  `;
  document.head.appendChild(desktopCanvasHeaderStyle);

  // V14.9.59: Square-format canvases should fill more of the available
  // viewport, especially on phones. Presentation-only: print ratio, crops,
  // photograph order and exported artwork are unaffected.
  const pp159SquarePreviewStyle = document.createElement('style');
  pp159SquarePreviewStyle.textContent = `
    @media(max-width:767px){
      #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
      [data-editor] > .ppc-workspace > .ppc-canvas-stage.ppc-v159-square-stage{
        width:min(calc(100vw - 28px),calc(43svh + 16px))!important;
        max-width:calc(100vw - 28px)!important;
      }
    }
    @media(min-width:768px){
      #pp-collage-v1:not(.ppc-review-mode):not(.ppc-v14-full)
      [data-editor]:not([hidden]) > .ppc-workspace > .ppc-canvas-stage.ppc-v159-square-stage{
        width:min(100%,calc(max(180px,100vh - var(--ppc-desktop-header-clearance,185px) - 24px) + 26px))!important;
      }
    }
  `;
  document.head.appendChild(pp159SquarePreviewStyle);

  // Shopify themes vary in header height; only count a header if it overlays
  // the top of the viewport. A non-sticky header is never given an offset.
  let desktopHeaderPending = false;
  function updateDesktopHeaderClearance() {
    desktopHeaderPending = false;
    if (window.innerWidth < 768) return;
    const selectors = [
      '#shopify-section-header',
      '.shopify-section-header-sticky',
      '.shopify-section-group-header-group',
      'sticky-header',
      '.header-wrapper',
      '#shopify-section-sections--header',
      'header[role="banner"]'
    ];
    let bottom = 0;
    for (const selector of selectors) {
      for (const node of document.querySelectorAll(selector)) {
        if (root.contains(node)) continue;
        const rect = node.getBoundingClientRect();
        if (rect.height < 24 || rect.height > 320 || rect.bottom <= 0 || rect.top > 10) continue;
        let sticky = false;
        for (let parent = node; parent && parent !== document.body; parent = parent.parentElement) {
          const pos = window.getComputedStyle(parent).position;
          if (pos === 'fixed' || pos === 'sticky') { sticky = true; break; }
        }
        // Some themes use a fixed positioned parent around their header.
        if (sticky) bottom = Math.max(bottom, rect.bottom);
      }
    }
    const clearance = Math.max(80, Math.min(340, Math.ceil(bottom + 26)));
    root.style.setProperty('--ppc-desktop-header-clearance', clearance + 'px');
  }
  function requestDesktopHeaderClearance() {
    if (desktopHeaderPending) return;
    desktopHeaderPending = true;
    requestAnimationFrame(updateDesktopHeaderClearance);
  }
  document.addEventListener('scroll', requestDesktopHeaderClearance, {passive:true});
  window.addEventListener('resize', requestDesktopHeaderClearance, {passive:true});
  requestDesktopHeaderClearance();

  // V11.1.2: Desktop photo-review grid. Keep mobile two-column review unchanged.
  const desktopReviewCss = document.createElement('style');
  desktopReviewCss.textContent = `
    @media (min-width: 781px) {
      #pp-collage-v1 [data-orientation]:not([hidden]),
      #pp-collage-v1 [data-crop-review]:not([hidden]) {
        width: min(1100px, calc(100vw - 100px)) !important;
        max-width: none !important;
        min-width: 0 !important;
        grid-column: 1 / -1 !important;
        box-sizing: border-box !important;
      }
      #pp-collage-v1 [data-orientation-gallery],
      #pp-collage-v1 [data-crop-review-gallery] {
        display: grid !important;
        grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)) !important;
        align-items: start !important;
        gap: 16px !important;
        width: 100% !important;
        max-width: none !important;
      }
      #pp-collage-v1 [data-orientation-gallery] .ppc-orientation-item,
      #pp-collage-v1 [data-crop-review-gallery] .ppc-orientation-item {
        width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
        box-sizing: border-box !important;
      }
      #pp-collage-v1 [data-orientation-gallery] .ppc-orientation-item img,
      #pp-collage-v1 [data-crop-review-gallery] .ppc-orientation-item img {
        width: 100% !important;
        max-width: 100% !important;
        height: 170px !important;
        object-fit: contain !important;
        display: block !important;
      }
      #pp-collage-v1 .ppc-orientation-buttons {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        gap: 6px !important;
      }
      #pp-collage-v1 .ppc-orientation-buttons button {
        min-width: 0 !important;
        width: 100% !important;
        white-space: normal !important;
      }
    }
  `;
  document.head.appendChild(desktopReviewCss);

  const appToast = document.createElement('div');
  appToast.id='ppc-app-toast'; appToast.setAttribute('role','status');
  document.body.appendChild(appToast);
  let appToastTimeout;
  function alert(message) {
    appToast.textContent=String(message);
    appToast.classList.add('ppc-visible');
    clearTimeout(appToastTimeout);
    appToastTimeout=setTimeout(()=>appToast.classList.remove('ppc-visible'),6500);
  }
  function ppDialog({heading,message='',initial='',ask=false,destructive=false}) {
    return new Promise(resolve=>{
      const overlay=document.createElement('div');
      overlay.id='ppc-app-dialog';
      overlay.innerHTML='<div class="ppc-dialog-card" role="dialog" aria-modal="true"><h2 style="margin:0 0 10px;font-size:22px"></h2><p style="white-space:pre-wrap;margin:0 0 16px;color:#475569;line-height:1.4"></p><form><label style="display:block"></label><div class="ppc-dialog-buttons"><button type="button" data-cancel>Cancel</button><button type="submit" class="ppc-primary" data-ok>Save</button></div></form></div>';
      overlay.querySelector('h2').textContent=heading;
      const description=overlay.querySelector('p'); description.textContent=message;description.hidden=!message;
      const form=overlay.querySelector('form');
      const label=overlay.querySelector('label');
      let field=null;
      if(ask){field=document.createElement('input');field.type='text';field.maxLength=120;field.value=initial;field.required=true;field.setAttribute('aria-label',heading);label.appendChild(field);}else label.hidden=true;
      overlay.querySelector('[data-ok]').textContent=ask?'Save':destructive?'Remove':'Continue';
      const originalFocus=document.activeElement;
      function close(value){overlay.remove();if(originalFocus?.isConnected)originalFocus.focus();resolve(value);}
      overlay.querySelector('[data-cancel]').addEventListener('click',()=>close(ask?null:false));
      overlay.addEventListener('click',e=>{if(e.target===overlay)close(ask?null:false)});
      form.addEventListener('submit',e=>{e.preventDefault();close(ask?field.value:true)});
      overlay.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();close(ask?null:false)}});
      document.body.appendChild(overlay);
      requestAnimationFrame(()=> (field||overlay.querySelector('[data-ok]')).focus());
    });
  }


  const state = {
    photos: [],
    original: [],
    seen: new Set(),
    reviewStep: "rotate",
    reviewMode: true,
    uploadBusy: false,
    swapSelected: null,
    activeCrop: null,
    cropSelection: null,
    cropPointer: null,
    returnFocus: null,
    dragging: null,
    suppressClick: false
  };

  function make(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }

  function status(message) {
    const el = $("[data-status]");
    if (el) el.textContent = message;
  }

  function showError(error, context) {
    console.error("Perham Collage:", context, error);
    const el = $("[data-ppc-error]");
    if (el) {
      el.style.display = "block";
      el.textContent =
        "Collage error (" + context + "): " +
        String(error?.message || error);
    }
  }

  function safeRender() {
    // V14.1: V14 controls only belong to the finished collage editing stage.
    root.classList.toggle('ppc-v14-ready', !state.reviewMode && state.photos.length > 0);
    try {
      render();
    } catch (error) {
      showError(error, "preview");
    }
  }

  // V12.2: Per-photo, non-destructive enhancement settings.
  function ppNormalAdjust(raw) {
    const o=raw && typeof raw==='object'?raw:{};
    const bounded=(v,lo,hi)=>{
      const n=Number(v);
      return Number.isFinite(n)?clamp(n,lo,hi):100;
    };
    return {brightness:bounded(o.brightness,50,150),contrast:bounded(o.contrast,50,150),saturation:bounded(o.saturation,0,200)};
  }
  function ppPhotoFilter(photo) {
    const a=ppNormalAdjust(photo.adjustments);
    return `brightness(${a.brightness}%) contrast(${a.contrast}%) saturate(${a.saturation}%)`;
  }

  function displaySrc(photo) {
    return photo.userCropUrl || photo.previewUrl || photo.url;
  }

  function baseSrc(photo) {
    return photo.previewUrl || photo.url;
  }

  function release(photo) {
    if (photo.url) URL.revokeObjectURL(photo.url);
    if (photo.previewUrl) URL.revokeObjectURL(photo.previewUrl);
    if (photo.userCropUrl) URL.revokeObjectURL(photo.userCropUrl);
  }

  // V12.3 — bounded, in-session history. Stores lightweight edit metadata,
  // never extra copies of uploaded originals. Safe for the 512 MB worker.
  const ppHistoryUndo=[], ppHistoryRedo=[];
  const ppHistoryLimit=25;
  let ppRestoringHistory=false;
  let ppHistoryBusy=false;
  let ppUndoButton,ppRedoButton;
  function ppSnapshot(){
    return {
      photos:[...state.photos], original:[...state.original],
      layout:typeof v11Arrangement==='string'?v11Arrangement:'balanced',
      gap:String($('[data-gap]')?.value||'0'),
      adjustments:state.photos.map(photo=>({
        photo,rotation:photo.rotation||0,
        trim:photo.trimRect?{...photo.trimRect}:null,
        crop:photo.userCropRect?{...photo.userCropRect}:null,
        adjustments:ppNormalAdjust(photo.adjustments)
      }))
    };
  }
  function ppRefreshHistoryButtons(){
    if(ppUndoButton){ppUndoButton.disabled=ppHistoryBusy||!ppHistoryUndo.length;ppUndoButton.title=ppHistoryUndo.length?'Undo last change':'Nothing to undo';}
    if(ppRedoButton){ppRedoButton.disabled=ppHistoryBusy||!ppHistoryRedo.length;ppRedoButton.title=ppHistoryRedo.length?'Redo last undone change':'Nothing to redo';}
  }
  function ppRemember(){
    if(ppRestoringHistory||ppHistoryBusy||!state.photos.length)return;
    ppHistoryUndo.push(ppSnapshot());
    if(ppHistoryUndo.length>ppHistoryLimit)ppHistoryUndo.shift();
    ppHistoryRedo.length=0;
    ppRefreshHistoryButtons();
  }
  function ppClearHistory(){ppHistoryUndo.length=0;ppHistoryRedo.length=0;ppRefreshHistoryButtons();}
  async function ppRestoreCrop(photo,rect){
    if(photo.userCropUrl){URL.revokeObjectURL(photo.userCropUrl);photo.userCropUrl=null;}
    if(!rect){photo.userCropRect=null;return;}
    const image=await loadImage(baseSrc(photo));
    const sw=Math.max(1,image.naturalWidth*rect.w),sh=Math.max(1,image.naturalHeight*rect.h);
    const scale=Math.min(1,2400/Math.max(sw,sh));
    const canvas=document.createElement('canvas');
    canvas.width=Math.max(1,Math.round(sw*scale));
    canvas.height=Math.max(1,Math.round(sh*scale));
    canvas.getContext('2d').drawImage(image,image.naturalWidth*rect.x,image.naturalHeight*rect.y,sw,sh,0,0,canvas.width,canvas.height);
    photo.userCropUrl=await canvasURL(canvas);
    photo.userCropRect={...rect};
    photo.aspect=canvas.width/canvas.height;
  }
  async function ppRestoreSnapshot(snapshot){
    // Rebuild from original local File bytes, then reapply saved trim/crop.
    // Rotations/adjustments remain the same metadata as production saving.
    const previous=[...state.photos];
    state.photos=[...snapshot.photos];state.original=[...snapshot.original];
    state.seen=new Set(state.original.map(p=>p.fingerprint).filter(Boolean));
    for(const record of snapshot.adjustments){
      const photo=record.photo;
      photo.rotation=record.rotation;
      photo.trimRect=record.trim?{...record.trim}:null;
      photo.adjustments=ppNormalAdjust(record.adjustments);
      await rebuildPreview(photo,false);
      await ppRestoreCrop(photo,record.crop);
    }
    v11Arrangement=snapshot.layout;
    if($('[data-gap]'))$('[data-gap]').value=snapshot.gap;
    v11RefreshButtons();
    state.swapSelected=null;
    safeRender();
  }
  async function ppTravelHistory(backward){
    if(ppHistoryBusy||state.activeCrop||!$('[data-editor]')||$('[data-editor]').hidden)return;
    const source=backward?ppHistoryUndo:ppHistoryRedo;
    const target=backward?ppHistoryRedo:ppHistoryUndo;
    if(!source.length)return;
    ppHistoryBusy=true;ppRestoringHistory=true;ppRefreshHistoryButtons();
    const destination=source.pop(),current=ppSnapshot();
    try{
      await ppRestoreSnapshot(destination);
      target.push(current);
      if(target.length>ppHistoryLimit)target.shift();
      status(backward?'Last edit undone.':'Edit restored.');
    }catch(err){
      source.push(destination);
      showError(err,'undo/redo');
    }finally{ppRestoringHistory=false;ppHistoryBusy=false;ppRefreshHistoryButtons();}
  }
  // V12.4.7: Undo/Redo controls removed from the customer interface.
  // Existing edit-history internals are retained to avoid changing photo processing.

  function showReview(step = "rotate") {
    state.reviewMode = true;
    state.reviewStep = step;
    root.classList.add("ppc-review-mode");

    $("[data-orientation]").hidden = step !== "rotate";
    $("[data-crop-review]").hidden = step !== "crop";

    if (step === "rotate") renderOrientation();
    else renderCropReview();
  }

  // V14.9.22 — review-path face-scan repair; detect faces locally, using MediaPipe on capable browsers.
  // Model/runtime files are fetched from a pinned public CDN, but user photos
  // are processed in the customer's browser, not uploaded to that provider.
  // Browser-native FaceDetector is a secondary fallback. An absent/unreliable
  // detection always means show the WHOLE photograph; never centre-crop blind.
  const PP_FACE_RUNTIME = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.22';
  const PP_FACE_MODEL = 'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_full_range/float16/1/blaze_face_full_range.tflite';
  let ppFaceRuntimePromise = null;
  let ppNativeFaceDetector = null;
  try {
    if (typeof FaceDetector !== 'undefined') {
      ppNativeFaceDetector = new FaceDetector({fastMode:false,maxDetectedFaces:40});
    }
  } catch (_) {}
  function ppLoadFaceRuntime() {
    if (!ppFaceRuntimePromise) {
      ppFaceRuntimePromise = (async () => {
        const mp = await import(PP_FACE_RUNTIME + '/+esm');
        const files = await mp.FilesetResolver.forVisionTasks(PP_FACE_RUNTIME + '/wasm');
        return await mp.FaceDetector.createFromOptions(files, {
          baseOptions:{modelAssetPath:PP_FACE_MODEL, delegate:'CPU'},
          runningMode:'IMAGE', minDetectionConfidence:0.35,
          minSuppressionThreshold:0.25
        });
      })().catch(error => {
        console.warn('On-device face detector unavailable',error);
        ppFaceRuntimePromise=null;
        return null;
      });
    }
    return ppFaceRuntimePromise;
  }
  function ppFaceUnion(boxes,width,height) {
    const good = boxes.filter(b=>b && [b.x,b.y,b.w,b.h].every(Number.isFinite) && b.w>0 && b.h>0);
    if (!good.length || !(width>0 && height>0)) return null;
    // Allow extra margins around the highest adults and lowest children.
    const minX=Math.min(...good.map(b=>b.x))/width;
    const minY=Math.min(...good.map(b=>b.y))/height;
    const maxX=Math.max(...good.map(b=>b.x+b.w))/width;
    const maxY=Math.max(...good.map(b=>b.y+b.h))/height;
    const x=clamp(minX-.06,0,1),y=clamp(minY-.12,0,1);
    const right=clamp(maxX+.06,0,1),bottom=clamp(maxY+.15,0,1);
    return right>x && bottom>y ? {x,y,w:right-x,h:bottom-y} : null;
  }
  async function ppScanFaces(photo) {
    if (!photo || photo.userCropRect) return;
    if (photo.ppFaceScanned) return;
    photo.ppFaceScanned = true;
    photo.ppFaceBounds = null;
    photo.ppFaceStatus = 'checking';
    try {
      const img=await loadImage(baseSrc(photo));
      const width=img.naturalWidth,height=img.naturalHeight;
      if (!(width>0 && height>0)) return;
      // Limit memory use on phones while retaining enough detail for smaller faces.
      const scale=Math.min(1, 1800/Math.max(width,height));
      const canvas=document.createElement('canvas');
      canvas.width=Math.max(1,Math.round(width*scale));
      canvas.height=Math.max(1,Math.round(height*scale));
      canvas.getContext('2d',{willReadFrequently:true}).drawImage(img,0,0,canvas.width,canvas.height);
      let bounds=[];
      const detector=await ppLoadFaceRuntime();
      if (detector) {
        const result=detector.detect(canvas);
        bounds=(result?.detections||[]).map(d=>({
          x:d.boundingBox?.originX,y:d.boundingBox?.originY,
          w:d.boundingBox?.width,h:d.boundingBox?.height
        }));
      }
      if (!bounds.length && ppNativeFaceDetector) {
        const result=await ppNativeFaceDetector.detect(canvas);
        bounds=result.map(d=>({x:d.boundingBox.x,y:d.boundingBox.y,
          w:d.boundingBox.width,h:d.boundingBox.height}));
      }
      // Coordinates are normalized to the rotated/trimmed preview, which is
      // what the production backend uses before making the automatic crop.
      photo.ppFaceBounds=ppFaceUnion(bounds,canvas.width,canvas.height);
      photo.ppFaceStatus=photo.ppFaceBounds ? 'faces-found' : (detector || ppNativeFaceDetector ? 'no-faces-found' : 'detector-unavailable');
    } catch(error) {
      console.warn('Unable to check faces; preserving whole photo',error);
      photo.ppFaceBounds=null;
      photo.ppFaceStatus='scan-error';
    }
  }
  // V14.9.64 — stronger on-device orientation analysis. Score all four
  // rotations by face confidence, agreement across faces, and (where the
  // detector provides keypoints) upright eye-to-mouth geometry.
  // Never mutate uploaded originals; uncertain pictures stay as they are.
  async function ppCheckUprightOrientation(photo) {
    if (!photo || !state.photos.includes(photo) || photo.userCropRect || photo._orientationChecked) return false;
    photo._orientationChecked = true;
    photo._orientationAssessment='unchecked';
    photo._orientationDiagnostic='Local orientation scan pending';
    const previousRotation = photo.rotation || 0;
    try {
      const detector = await ppLoadFaceRuntime();
      if (!detector && !ppNativeFaceDetector) return false;
      const image = await loadImage(photo.previewUrl || photo.url);
      const longest = Math.max(image.naturalWidth,image.naturalHeight);
      if (!longest) return false;
      const canvas=document.createElement('canvas');
      const ctx=canvas.getContext('2d',{willReadFrequently:true});
      if (!ctx) return false;
      const isMobile=window.matchMedia('(max-width:900px)').matches;
      // A second, larger pass is reserved for photos where no recognisable
      // face was found. Normal uploads avoid the extra CPU work.
      async function evaluate(maxEdge) {
        const scale=Math.min(1,maxEdge/longest);
        const w=Math.max(1,Math.round(image.naturalWidth*scale));
        const h=Math.max(1,Math.round(image.naturalHeight*scale));
        const results=[];
        for (const degrees of [0,90,180,270]) {
          const sideways=degrees===90 || degrees===270;
          canvas.width=sideways?h:w;
          canvas.height=sideways?w:h;
          ctx.setTransform(1,0,0,1,0,0);
          ctx.clearRect(0,0,canvas.width,canvas.height);
          ctx.translate(canvas.width/2,canvas.height/2);
          ctx.rotate(degrees*Math.PI/180);
          ctx.drawImage(image,-w/2,-h/2,w,h);
          const faces=[];
          if (detector) {
            for (const detection of detector.detect(canvas)?.detections || []) {
              const confidence=Number(detection.categories?.[0]?.score ?? detection.score ?? 0);
              if (!Number.isFinite(confidence) || confidence < .33) continue;
              const box=detection.boundingBox || {};
              const area=(Number(box.width)||0)*(Number(box.height)||0)/(canvas.width*canvas.height);
              // BlazeFace keypoint order: right eye, left eye, nose, mouth,
              // right ear, left ear. Some runtimes omit keypoints entirely.
              const points=detection.keypoints || [];
              let alignment=0;
              if(points.length>=4){
                const eyeY=(Number(points[0]?.y)+Number(points[1]?.y))/2;
                const mouthY=Number(points[3]?.y);
                const leftX=Number(points[0]?.x),rightX=Number(points[1]?.x);
                if([eyeY,mouthY,leftX,rightX].every(Number.isFinite)){
                  // Keypoints may be normalized or pixel coordinates;
                  // compare differences in their native units.
                  const separation=(mouthY-eyeY)/(Math.max(Math.abs(leftX-rightX),.01));
                  alignment=separation>.12 ? .15 : separation<-.12 ? -.3 : 0;
                }
              }
              faces.push({confidence,area,alignment});
            }
          }
          // Native detector is a genuine fallback, including when MediaPipe
          // loaded successfully but failed to find faces in this direction.
          if (!faces.length && ppNativeFaceDetector) {
            try {
              const found=await ppNativeFaceDetector.detect(canvas);
              for(const d of found){
                const score=Number(d.score ?? .65);
                if(!Number.isFinite(score)||score<.35)continue;
                faces.push({confidence:score,area:0,alignment:0});
              }
            } catch(_){}
          }
          faces.sort((x,y)=>y.confidence-x.confidence);
          const chosen=faces.slice(0,8);
          const score=chosen.reduce((sum,f)=>sum+f.confidence+f.alignment+Math.min(.07,Math.sqrt(Math.max(0,f.area))*.16),0);
          results.push({degrees,count:chosen.length,score,bestFace:chosen[0]?.confidence || 0,
            eyeEvidence:chosen.some(f=>f.alignment>.1)});
          if(isMobile)await new Promise(r=>setTimeout(r,0));
        }
        return results.sort((x,y)=>y.score-x.score);
      }
      let results=await evaluate(900);
      // Small group faces can disappear in the first pass; retry only if
      // none of the orientations has usable detections.
      if(results[0].count===0 && longest>900) results=await evaluate(1400);
      photo._orientationScores=results.map(r=>({degrees:r.degrees,count:r.count,score:Number(r.score.toFixed(3))}));
      const best=results[0],runner=results[1];
      const margin=best.score-runner.score;
      const enough=best.count>0 && best.bestFace>=.50 && best.score>=.55;
      // One face needs a clear lead; multiple consistent faces can provide
      // stronger combined evidence without using a single weak false positive.
      const clear=runner.count===0
        ? best.score>=.60 && best.bestFace>=.57
        : margin>=Math.max(.28,runner.score*.30) &&
          (best.count>=2 || best.eyeEvidence || best.bestFace>=.80);
      const flip180=best.degrees===180;
      const safe=enough && clear && (!flip180 || best.bestFace>=.70 &&
        (runner.count===0 || margin>=.45));
      if(!safe || photo.rotation!==previousRotation ||
          !state.photos.includes(photo) || photo.userCropRect){
        photo._orientationDiagnostic='Local detector inconclusive';
        return false;
      }
      photo._orientationAssessment='confirmed';
      photo._orientationDiagnostic='Local face landmarks';
      if(best.degrees===0)return false;
      photo.rotation=(previousRotation+best.degrees)%360;
      try {await rebuildPreview(photo,false)}
      catch(error){photo.rotation=previousRotation;throw error}
      photo._autoOrientationDegrees=best.degrees;
      photo.ppFaceBounds=null;
      photo.ppFaceStatus='unchecked';
      return true;
    }catch(error){
      console.warn('Smart orientation check skipped for this photo',error);
      return false;
    }
  }
  // V14.9.65: Optional vision second opinion when the local face check
  // cannot establish an upright direction. This only sends a small JPEG through
  // our authenticated Shopify app proxy; original photos remain local/private.
  // V14.9.70: one small contact sheet per photo allows the vision model to
  // compare all four possibilities in ONE request. No expensive serial local
  // face scans and no extra AI verification call.
  async function ppOrientationSecondOpinion(photo) {
    if (!photo || !state.photos.includes(photo) || photo.userCropRect) return false;
    const originalRotation=photo.rotation||0;
    photo._orientationAssessment='unchecked';
    photo._orientationDiagnostic='AI check started';
    try {
      const image=await loadImage(photo.previewUrl || photo.url);
      // Four clearly labelled views of the exact current preview. Rotate the
      // *already displayed* photo, since EXIF/crops may have been applied.
      const sheet=document.createElement('canvas');
      const tile=344, gap=10;
      sheet.width=(tile+gap)*2+gap;
      sheet.height=(tile+gap)*2+gap;
      const ctx=sheet.getContext('2d');
      if(!ctx)return false;
      ctx.fillStyle='#f0f2f6';ctx.fillRect(0,0,sheet.width,sheet.height);
      for(let index=0;index<4;index++){
        const deg=[0,90,180,270][index];
        const x=gap+(index%2)*(tile+gap),y=gap+Math.floor(index/2)*(tile+gap);
        ctx.fillStyle='#fff';ctx.fillRect(x,y,tile,tile);
        ctx.save();ctx.beginPath();ctx.rect(x+5,y+31,tile-10,tile-36);ctx.clip();
        const cw=tile-14,ch=tile-45;
        const sideways=deg===90||deg===270;
        const iw=sideways?image.naturalHeight:image.naturalWidth;
        const ih=sideways?image.naturalWidth:image.naturalHeight;
        const scale=Math.min(cw/iw,ch/ih);
        ctx.translate(x+tile/2,y+31+ch/2);ctx.rotate(deg*Math.PI/180);
        ctx.drawImage(image,-image.naturalWidth*scale/2,-image.naturalHeight*scale/2,image.naturalWidth*scale,image.naturalHeight*scale);
        ctx.restore();
        ctx.fillStyle='#17294c';ctx.font='bold 21px sans-serif';
        ctx.fillText(['A = 0°','B = 90°','C = 180°','D = 270°'][index],x+12,y+24);
      }
      const jpeg=sheet.toDataURL('image/jpeg',.73);
      if(jpeg.length>530000)return false;
      // Do not let one stalled request hold the entire upload indefinitely.
      const controller=new AbortController();
      const timer=setTimeout(()=>controller.abort(),10500);
      let answer;
      try {answer=await collageRequest('/orientation/check',{
        method:'POST',signal:controller.signal,
        body:JSON.stringify({jpeg,layout:'quadrants'})
      });} finally {clearTimeout(timer);}
      if(answer.status!=='ok'||![0,90,180,270].includes(Number(answer.degrees))){
        photo._orientationDiagnostic='AI check: '+String(answer.status || 'no-result');
        return false;
      }
      answer.degrees=Number(answer.degrees);
      photo._orientationDiagnostic='AI chose '+answer.degrees+'° ('+answer.confidence+')';
      if(!state.photos.includes(photo)||photo.rotation!==originalRotation||photo.userCropRect)return false;
      if(answer.confidence!=='high'){
        if(answer.degrees!==0){photo._orientationAssessment='suspected';photo._orientationDiagnostic='AI suspects '+answer.degrees+'° but confidence is '+answer.confidence;}
        return false;
      }
      photo._orientationAssessment='confirmed';
      photo._orientationDiagnostic='AI compared four labelled views';
      if(answer.degrees===0)return false;
      photo.rotation=(originalRotation+answer.degrees)%360;
      try{await rebuildPreview(photo,false)}catch(error){photo.rotation=originalRotation;photo._orientationAssessment='unchecked';throw error;}
      photo._autoOrientationDegrees=answer.degrees;
      photo.ppFaceBounds=null;photo.ppFaceStatus='unchecked';photo.ppFaceScanned=false;
      return true;
    }catch(error){
      photo._orientationAssessment='unchecked';
      photo._orientationDiagnostic='Orientation check unavailable: '+(error?.name || 'request failed');
      return false;
    }
  }

  function ppSmartFit(photo,tileRatio,preserveWholeCrop){
    if ($('[data-fit]').value==='contain') return {fit:'contain'};
    // The user explicitly chose Fill Spaces. Manual crops and featured cells
    // may also fill their spaces; preserve the cropped image as the input.
    // Only known, unavoidably clipped face groups force full-photo fitting.
    if (photo.userCropRect || preserveWholeCrop) return {fit:'cover',px:50,py:0};
    const b=photo.ppFaceBounds, a=Math.max(.001,photo.aspect||1);
    if (!Number.isFinite(tileRatio) || tileRatio<=0) return {fit:'cover',px:50,py:0};
    const cropW=Math.min(1,tileRatio/a), cropH=Math.min(1,a/tileRatio);
    // Prefer the TOP of the original photo: crop away the bottom, not heads.
    // When detection is missing, this is a deterministic top-aligned fallback.
    if (!b) return {fit:'cover',px:50,py:0};
    // Detected groups too tall/wide to fit safely must not be clipped.
    if(b.w>cropW-.025 || b.h>cropH-.025) return {fit:'contain'};
    const left=clamp(b.x+b.w/2-cropW/2,0,1-cropW);
    // Place crop as HIGH as possible while keeping the bottom of all faces
    // (plus a little margin) in-frame. This favours heads over lower scenery.
    const top=clamp(b.y+b.h+0.025-cropH,0,1-cropH);
    return {fit:'cover',px:cropW>=.999?50:100*left/(1-cropW),py:cropH>=.999?0:100*top/(1-cropH)};
  }
  // V14.9.38: Accessible blocking progress screen for the face-scan transition.
  const ppScanOverlay = document.createElement('div');
  ppScanOverlay.id = 'ppc-safe-framing-progress';
  ppScanOverlay.hidden = true;
  ppScanOverlay.setAttribute('role', 'status');
  ppScanOverlay.setAttribute('aria-live', 'polite');
  ppScanOverlay.setAttribute('aria-label', 'Checking photographs');
  ppScanOverlay.innerHTML = '<div class="ppc-safe-progress-card"><div class="ppc-safe-spinner" aria-hidden="true"></div><h2>Carefully making your collage</h2><p data-ppc-safe-progress>Preparing photos for your collage…</p><small>We’re checking the framing. This can take a little longer with lots of photos.</small></div>';
  document.body.appendChild(ppScanOverlay);
  const ppScanCss = document.createElement('style');
  ppScanCss.textContent = `
    #ppc-safe-framing-progress[hidden]{display:none!important}
    #ppc-safe-framing-progress{position:fixed;inset:0;z-index:2147483646;background:rgba(13,24,44,.77);display:flex;align-items:center;justify-content:center;padding:18px;box-sizing:border-box}
    #ppc-safe-framing-progress .ppc-safe-progress-card{box-sizing:border-box;width:min(420px,100%);padding:32px 25px;background:#fff;color:#142840;border-radius:18px;box-shadow:0 15px 55px #0004;text-align:center}
    #ppc-safe-framing-progress h2{font-size:23px;line-height:1.2;font-weight:800;margin:16px 0 10px}
    #ppc-safe-framing-progress p{font-size:15px;line-height:1.45;margin:0 0 12px}
    #ppc-safe-framing-progress small{display:block;color:#536780;font-size:13px;line-height:1.5}
    #ppc-safe-framing-progress .ppc-safe-spinner{width:43px;height:43px;border:5px solid #dbeafe;border-top-color:#1262bd;border-radius:50%;margin:auto;animation:ppc-safe-spin .75s linear infinite}
    @keyframes ppc-safe-spin{to{transform:rotate(360deg)}}
    @media(prefers-reduced-motion:reduce){#ppc-safe-framing-progress .ppc-safe-spinner{animation-duration:2s}}
    /* Keep desktop preview below the moving Hyper header, even on long control panels. */
    @media(min-width:768px){
      #pp-collage-v1:not(.ppc-review-mode) [data-editor]:not([hidden]) > .ppc-workspace > .ppc-canvas-stage{
        top:var(--ppc-desktop-header-clearance,185px)!important;
        z-index:1!important;
      }
      #pp-collage-v1:not(.ppc-review-mode) [data-editor] > .ppc-workspace{
        padding-bottom:65px!important;
      }
    }
    #pp-collage-v1:not(.ppc-review-mode) [data-editor] .ppc-workspace .ppc-note{
      position:relative!important;clear:both!important;display:block!important;
      overflow:visible!important;white-space:normal!important;line-height:1.55!important;
      min-height:30px!important;padding:12px 5px 16px!important;margin-bottom:20px!important;
    }
    #pp-collage-v1:not(.ppc-review-mode) [data-editor]{padding-bottom:38px!important;overflow:visible!important;}
    @media(max-width:767px){#pp-collage-v1:not(.ppc-review-mode) [data-editor] .ppc-workspace .ppc-note{padding-bottom:24px!important;}}
  `;
  document.head.appendChild(ppScanCss);
  function ppScanProgressStart(){
    ppScanOverlay.hidden = false;
    ppScanOverlay.querySelector('[data-ppc-safe-progress]').textContent = 'Starting safe-framing check…';
  }
  function ppScanProgressUpdate(done,total){
    ppScanOverlay.querySelector('[data-ppc-safe-progress]').textContent = `Checking photograph ${done} of ${total}…`;
  }
  function ppScanProgressEnd(){ ppScanOverlay.hidden = true; }
  // V14.9.43: After the review step, return to the START of the
  // personalisation choices, not the previous scroll position near checkout.
  function ppScrollToPersonalisation(){
    const jump = () => {
      const target = root.querySelector('[data-editor] > .ppc-v11-layouts') ||
        root.querySelector('[data-editor] > .ppc-panel') ||
        root.querySelector('[data-editor]');
      if (!target || root.classList.contains('ppc-review-mode')) return;
      const header = document.querySelector('header.header, .shopify-section-header-sticky, #shopify-section-header, .header-wrapper');
      const clearance = Math.max(90, Math.min(180, (header?.getBoundingClientRect().height || 75) + 18));
      const y = Math.max(0, window.scrollY + target.getBoundingClientRect().top - clearance);
      window.scrollTo({top:y,behavior:'instant'});
    };
    // Wait for the layout and mobile sticky preview to settle after render.
    requestAnimationFrame(() => requestAnimationFrame(jump));
    // Images and the sticky preview can settle after the initial frame.
    setTimeout(jump, 180);
    setTimeout(jump, 520);
  }

  // V14.9.48: short, dismissible mobile gesture guide shown on entering the editor.
  let ppTouchTipShown = false;
  let ppTouchTipTimer = null;
  function ppShowTouchTip() {
    if (ppTouchTipShown || !window.matchMedia('(max-width: 767px) and (pointer: coarse)').matches) return;
    ppTouchTipShown = true;
    const tip = document.createElement('aside');
    tip.className = 'ppc-v14947-touch-tip';
    tip.setAttribute('role', 'status');
    tip.setAttribute('aria-label', 'How to edit your collage');
    tip.innerHTML = `<button type="button" class="ppc-v14947-dismiss" aria-label="Dismiss touch instructions">×</button>
      <strong>Edit photos directly in your collage</strong>
      <span><b>Tap</b> a photo to crop or rotate it</span>
      <span><b>Drag</b> a photo straight onto another to swap (no hold needed)</span>
      <span><b>Swipe outside the collage</b> to scroll the page</span>`;
    const cssId = 'ppc-v14947-tip-style';
    if (!document.getElementById(cssId)) {
      const style = document.createElement('style');
      style.id = cssId;
      style.textContent = `
        .ppc-v14947-touch-tip{position:fixed!important;z-index:2147483300!important;bottom:max(20px,env(safe-area-inset-bottom))!important;left:12px!important;right:12px!important;max-width:400px!important;margin:0 auto!important;box-sizing:border-box!important;background:#123b70!important;color:white!important;border-radius:15px!important;box-shadow:0 8px 28px rgba(0,0,0,.22)!important;padding:14px 44px 14px 16px!important;font-size:13px!important;line-height:1.45!important;display:flex!important;flex-direction:column!important;gap:5px!important;pointer-events:auto!important;}
        .ppc-v14947-touch-tip strong{font-size:15px!important;color:#fff!important}
        .ppc-v14947-touch-tip span,.ppc-v14947-touch-tip b{color:#fff!important}
        .ppc-v14947-dismiss{position:absolute!important;right:9px!important;top:7px!important;border:0!important;background:transparent!important;color:white!important;font-size:27px!important;line-height:1!important;width:36px!important;height:36px!important;cursor:pointer!important}
        @media(min-width:768px){.ppc-v14947-touch-tip{display:none!important}}
      `;
      document.head.appendChild(style);
    }
    document.body.appendChild(tip);
    const dismiss = () => { clearTimeout(ppTouchTipTimer);tip.remove(); };
    tip.querySelector('button').addEventListener('click', dismiss);
    ppTouchTipTimer = setTimeout(dismiss, 6500);
  }

  async function finishRotation() {
    if (state.uploadBusy) {
      status("Please wait for your photos to finish uploading.");
      return;
    }

    if (!state.photos.length) {
      status("Please add some photographs first.");
      return;
    }

    if (!ppCheckPhotoLimit()) return;
    if (ppMobilePrep.hidden) ppScanProgressStart();
    else ppMobilePrepUpdate('Finishing touches — protecting faces…',0,state.photos.length);
    try {
      status('Checking your photographs for safe framing…');
      const ppFaceStarted = performance.now();
      const faceList=[...state.photos];
      let scanned=0, nextFace=0;
      // Two bounded workers share the model. Do not rescan previously checked photos.
      await Promise.all(Array.from({length:Math.min(2,faceList.length)},async()=>{
        while(nextFace<faceList.length){
          const photo=faceList[nextFace++];
          await ppScanFaces(photo);
          scanned++;
          if(ppMobilePrep.hidden)ppScanProgressUpdate(scanned,faceList.length);
          else ppMobilePrepUpdate('Finishing touches — protecting faces…',scanned,faceList.length);
        }
      }));
    console.info('[Perham Collage] Face preparation', {
      photoCount: state.photos.length,
      elapsedMs: Math.round(performance.now() - ppFaceStarted)
    });
    root.dispatchEvent(new Event('pp-faces-scanned'));
    state.reviewMode = false;
    root.classList.remove("ppc-review-mode");

    $("[data-orientation]").hidden = true;
    $("[data-crop-review]").hidden = true;

    safeRender();
    ppScrollToPersonalisation();
    ppShowTouchTip();
    status("Your collage is ready. Tap any photograph to adjust its crop.");
    } finally { ppScanProgressEnd(); }
  }

  async function finishCropReview() {
    if (state.uploadBusy || !state.photos.length || state.faceScanBusy) return;
    if (!ppCheckPhotoLimit()) return;
    state.faceScanBusy = true;
    ppScanProgressStart();
    status('Checking faces in every photograph…');
    try {
      // Critical: both review paths must scan. This screen was previously
      // bypassing ppScanFaces, leaving every photo with a centre-crop.
      const faceList=[...state.photos];
      let scanned=0,nextFace=0;
      await Promise.all(Array.from({length:Math.min(2,faceList.length)},async()=>{
        while(nextFace<faceList.length){
          const photo=faceList[nextFace++];
          await ppScanFaces(photo);
          ppScanProgressUpdate(++scanned,faceList.length);
        }
      }));
      root.dispatchEvent(new Event('pp-faces-scanned'));
      state.reviewMode = false;
      root.classList.remove("ppc-review-mode");
      $("[data-orientation]").hidden = true;
      $("[data-crop-review]").hidden = true;
      safeRender();
      ppScrollToPersonalisation();
      ppShowTouchTip();
      const checked=state.photos.filter(p=>p.ppFaceBounds).length;
      status('Collage ready. Face-aware cropping active on '+checked+' of '+state.photos.length+' photos. Review any remaining photos for cut-off heads.');
    } finally {
      ppScanProgressEnd();
      state.faceScanBusy = false;
    }
  }

  async function loadImage(src) {
    const img = new Image();
    img.src = src;
    await img.decode();
    return img;
  }

  async function canvasURL(canvas) {
    const blob = await new Promise(resolve =>
      canvas.toBlob(resolve, "image/png")
    );

    if (!blob) throw new Error("Unable to process photograph.");
    return URL.createObjectURL(blob);
  }

  async function rebuildPreview(photo, renderAfter = true) {
    const sequence = photo.sequence = (photo.sequence || 0) + 1;
    const image = await loadImage(photo.url);

    const trim = photo.trimRect || {
      x: 0, y: 0, w: 1, h: 1
    };

    const sx = image.naturalWidth * trim.x;
    const sy = image.naturalHeight * trim.y;
    const sw = image.naturalWidth * trim.w;
    const sh = image.naturalHeight * trim.h;

    const previewMaxEdge = ppIsConstrainedMobile ? 2000 : 2400;
    const scale = Math.min(1, previewMaxEdge / Math.max(sw, sh));
    const drawW = Math.max(1, Math.round(sw * scale));
    const drawH = Math.max(1, Math.round(sh * scale));

    const rotation = photo.rotation || 0;
    const sideways = rotation === 90 || rotation === 270;

    const canvas = document.createElement("canvas");
    canvas.width = sideways ? drawH : drawW;
    canvas.height = sideways ? drawW : drawH;

    const ctx = canvas.getContext("2d");
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(rotation * Math.PI / 180);
    ctx.drawImage(
      image, sx, sy, sw, sh,
      -drawW / 2, -drawH / 2, drawW, drawH
    );

    const url = await canvasURL(canvas);

    if (sequence !== photo.sequence) {
      URL.revokeObjectURL(url);
      return;
    }

    if (photo.previewUrl) URL.revokeObjectURL(photo.previewUrl);
    photo.previewUrl = url;

    if (photo.userCropUrl) {
      URL.revokeObjectURL(photo.userCropUrl);
      photo.userCropUrl = null;
    }

    photo.userCropRect = null;
    photo.aspect = canvas.width / canvas.height;
    // Cropping/rotating changes coordinates: discard now-stale detections.
    photo.ppFaceBounds = null;
    photo.ppFaceScanned = false;

    if (state.activeCrop === photo) refreshCrop();
    if (renderAfter) safeRender();
  }

  async function rotatePhoto(photo, degrees) {
    const previous = photo.rotation || 0;
    ppRemember();
    photo.rotation = (previous + degrees + 360) % 360;
    photo._orientationChecked = true;
    photo._orientationAssessment='confirmed';
    photo._orientationDiagnostic='Manually checked by customer';

    try {
      await rebuildPreview(photo);
    } catch (error) {
      photo.rotation = previous;
      showError(error, "rotation");
    }
  }

  // V14.9.37: remove from either photo review stage, not just collage thumbnails.
  function ppReviewDeleteButton(photo) {
    const button = make('button','ppc-review-delete','Remove');
    button.type = 'button';
    button.setAttribute('aria-label','Remove '+photo.name);
    button.addEventListener('click',async event=>{
      event.preventDefault();event.stopPropagation();
      if (state.uploadBusy || state.faceScanBusy) return;
      ppRemember();
      state.photos=state.photos.filter(p=>p!==photo);
      state.original=state.original.filter(p=>p!==photo);
      if(photo.fingerprint)state.seen.delete(photo.fingerprint);
      // Don't revoke local URLs here: saved in-session undo references may still use them.
      if(state.reviewStep==='rotate')renderOrientation();
      else renderCropReview();
      ppPhotoLimitNoticeUpdate();
      ppDraftSchedule();
      status('Photograph removed. '+state.photos.length+' remaining.');
    });
    return button;
  }

  function renderOrientation() {
    if (!state.reviewMode || state.reviewStep !== "rotate") return;

    const gallery = $("[data-orientation-gallery]");
    gallery.replaceChildren();

    $("[data-review-count]").textContent =
      state.photos.length + " photographs selected";

    for (const photo of state.photos) {
      const card = make("div", "ppc-orientation-item");
      const frame = make("div", "ppc-review-photo-frame");
      const image = make("img");
      image.decoding = "async";
      image.loading = "lazy";
      image.src = displaySrc(photo);
      image.alt = photo.name;
      image.style.setProperty('filter', ppPhotoFilter(photo), 'important');
      frame.appendChild(image);
      if (photo._orientationAssessment==='suspected') {
        const notice=make('div','ppc-v165-rotation-notice','↻ Check rotation');
        notice.title='Automatic checking was uncertain. Please use Turn Left or Turn Right if this photograph is sideways.';
        notice.setAttribute('aria-label',notice.title);
        frame.appendChild(notice);
      }

      const buttons = make("div", "ppc-orientation-buttons");

      for (const control of [
        { label: "↶ Turn Left", degrees: -90, type: "rotate" },
        { label: "Edit", type: "edit" },
        { label: "↷ Turn Right", degrees: 90, type: "rotate" }
      ]) {
        const button = make("button", null, control.label);
        button.type = "button";

        if (control.type === "edit") {
          button.addEventListener("click", () => openCrop(photo, frame || card));
        } else {
          button.addEventListener("click", async () => {
            button.disabled = true;
            await rotatePhoto(photo, control.degrees);
            image.src = displaySrc(photo);
            button.disabled = false;
          });
        }

        buttons.appendChild(button);
      }

      card.append(frame, buttons, ppReviewDeleteButton(photo));
      gallery.appendChild(card);
    }
  }

  function renderCropReview() {
    if (!state.reviewMode || state.reviewStep !== "crop") return;

    const gallery = $("[data-crop-review-gallery]");
    gallery.replaceChildren();

    $("[data-crop-review-count]").textContent =
      state.photos.length + " photographs";

    for (const photo of state.photos) {
      const card = make("div", "ppc-orientation-item");
      const frame = make("div", "ppc-review-photo-frame");
      const image = make("img");

      image.decoding = "async";
      image.loading = "lazy";
      image.src = displaySrc(photo);
      image.alt = photo.name;
      image.style.setProperty('filter', ppPhotoFilter(photo), 'important');
      frame.appendChild(image);

      const button = make("button", "ppc-review-adjust", "Adjust Photo");
      button.type = "button";
      button.addEventListener("click", () => openCrop(photo, frame));

      card.append(frame, button, ppReviewDeleteButton(photo));
      gallery.appendChild(card);
    }
  }

  function detectSolidBorders(image) {
    const scale = Math.min(
      1, 420 / Math.max(image.naturalWidth, image.naturalHeight)
    );

    const w = Math.max(2, Math.round(image.naturalWidth * scale));
    const h = Math.max(2, Math.round(image.naturalHeight * scale));

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;

    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(image, 0, 0, w, h);

    const data = ctx.getImageData(0, 0, w, h).data;

    function solid(direction, position, L, T, R, B) {
      const length =
        direction === "top" || direction === "bottom"
          ? R - L : B - T;

      const count = Math.min(64, Math.max(8, length));
      let matches = 0;
      let valid = 0;

      for (let i = 0; i < count; i++) {
        const t = (i + .5) / count;

        const x = direction === "left" || direction === "right"
          ? position : Math.min(R - 1, L + Math.floor(t * (R - L)));

        const y = direction === "top" || direction === "bottom"
          ? position : Math.min(B - 1, T + Math.floor(t * (B - T)));

        const index = (y * w + x) * 4;
        const r = data[index], g = data[index + 1];
        const b = data[index + 2], a = data[index + 3];

        if (a < 180) continue;
        valid++;

        const hi = Math.max(r, g, b);
        const lo = Math.min(r, g, b);

        if (hi - lo < 19 && (hi < 37 || lo > 222)) matches++;
      }

      return valid >= count * .85 &&
        matches / Math.max(1, valid) > .985;
    }

    let L = 0, T = 0, R = w, B = h;

    const maxX = Math.floor(w * .28);
    const maxY = Math.floor(h * .28);

    while (T < maxY && solid("top", T, L, T, R, B)) T++;
    while (B > h - maxY && B > T + 4 &&
      solid("bottom", B - 1, L, T, R, B)) B--;

    while (L < maxX && solid("left", L, L, T, R, B)) L++;
    while (R > w - maxX && R > L + 4 &&
      solid("right", R - 1, L, T, R, B)) R--;

    if (R - L < w * .43 || B - T < h * .43) return null;
    if (Math.max(L, w - R, T, h - B) < 2) return null;

    return { x: L / w, y: T / h, w: (R - L) / w, h: (B - T) / h };
  }

  function detectScreenshotCrop(image) {
    const scale = Math.min(1, 520 / Math.max(image.naturalWidth, image.naturalHeight));
    const w = Math.max(2, Math.round(image.naturalWidth * scale));
    const h = Math.max(2, Math.round(image.naturalHeight * scale));

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;

    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(image, 0, 0, w, h);
    const data = ctx.getImageData(0, 0, w, h).data;

    const sampleStepX = Math.max(1, Math.floor(w / 110));
    const sampleStepY = Math.max(1, Math.floor(h / 140));

    function sampleRow(y) {
      let n = 0, sum = 0, sumSq = 0, neutral = 0;
      let prevLum = null, edge = 0, edgeCount = 0;

      for (let x = 0; x < w; x += sampleStepX) {
        const i = (y * w + x) * 4;
        const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
        if (a < 180) continue;
        const hi = Math.max(r, g, b);
        const lo = Math.min(r, g, b);
        const lum = (r + g + b) / 3;
        n++;
        sum += lum;
        sumSq += lum * lum;
        if (hi - lo < 20 && (lum > 188 || lum < 78)) neutral++;
        if (prevLum !== null) {
          edge += Math.abs(lum - prevLum);
          edgeCount++;
        }
        prevLum = lum;
      }

      if (!n) return { score: 0, neutral: 1, variance: 0 };
      const mean = sum / n;
      const variance = Math.sqrt(Math.max(0, sumSq / n - mean * mean));
      const neutralFrac = neutral / n;
      const edgeAvg = edgeCount ? edge / edgeCount : 0;
      const score = variance + edgeAvg * 1.45 + (1 - neutralFrac) * 24;
      return { score, neutral: neutralFrac, variance };
    }

    function sampleCol(x, top, bottom) {
      let n = 0, sum = 0, sumSq = 0, neutral = 0;
      let prevLum = null, edge = 0, edgeCount = 0;

      for (let y = top; y < bottom; y += sampleStepY) {
        const i = (y * w + x) * 4;
        const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
        if (a < 180) continue;
        const hi = Math.max(r, g, b);
        const lo = Math.min(r, g, b);
        const lum = (r + g + b) / 3;
        n++;
        sum += lum;
        sumSq += lum * lum;
        if (hi - lo < 20 && (lum > 188 || lum < 78)) neutral++;
        if (prevLum !== null) {
          edge += Math.abs(lum - prevLum);
          edgeCount++;
        }
        prevLum = lum;
      }

      if (!n) return { score: 0, neutral: 1, variance: 0 };
      const mean = sum / n;
      const variance = Math.sqrt(Math.max(0, sumSq / n - mean * mean));
      const neutralFrac = neutral / n;
      const edgeAvg = edgeCount ? edge / edgeCount : 0;
      const score = variance + edgeAvg * 1.45 + (1 - neutralFrac) * 24;
      return { score, neutral: neutralFrac, variance };
    }

    const rowScores = new Array(h);
    for (let y = 0; y < h; y++) rowScores[y] = sampleRow(y);

    const rowThreshold = Math.max(16, Math.min(38,
      rowScores.reduce((s, row) => s + row.score, 0) / Math.max(1, rowScores.length) * 0.92
    ));

    const minRun = Math.max(22, Math.floor(h * 0.16));
    let best = null;
    let start = -1;
    let strength = 0;

    for (let y = 0; y <= h; y++) {
      const active = y < h && rowScores[y].score >= rowThreshold;
      if (active) {
        if (start < 0) { start = y; strength = 0; }
        strength += rowScores[y].score;
      } else if (start >= 0) {
        const len = y - start;
        if (len >= minRun) {
          const center = (start + y) / 2;
          const centreBias = 1 - Math.min(1, Math.abs(center - h / 2) / (h / 2));
          const rank = strength * (0.82 + centreBias * 0.18);
          if (!best || rank > best.rank) best = { top: start, bottom: y, rank };
        }
        start = -1;
      }
    }

    if (!best) return null;

    let top = best.top;
    let bottom = best.bottom;
    while (top > 1) {
      const row = rowScores[top - 1];
      if (row.score >= rowThreshold * 0.72 || row.neutral < 0.68) top--;
      else break;
    }
    while (bottom < h - 1) {
      const row = rowScores[bottom];
      if (row.score >= rowThreshold * 0.72 || row.neutral < 0.68) bottom++;
      else break;
    }

    const colScores = new Array(w);
    for (let x = 0; x < w; x++) colScores[x] = sampleCol(x, top, bottom);

    const colThreshold = Math.max(15, Math.min(34,
      colScores.reduce((s, col) => s + col.score, 0) / Math.max(1, colScores.length) * 0.9
    ));

    const minColRun = Math.max(22, Math.floor(w * 0.18));
    best = null;
    start = -1;
    strength = 0;

    for (let x = 0; x <= w; x++) {
      const active = x < w && colScores[x].score >= colThreshold;
      if (active) {
        if (start < 0) { start = x; strength = 0; }
        strength += colScores[x].score;
      } else if (start >= 0) {
        const len = x - start;
        if (len >= minColRun) {
          const center = (start + x) / 2;
          const centreBias = 1 - Math.min(1, Math.abs(center - w / 2) / (w / 2));
          const rank = strength * (0.84 + centreBias * 0.16);
          if (!best || rank > best.rank) best = { left: start, right: x, rank };
        }
        start = -1;
      }
    }

    if (!best) return null;

    let left = best.left;
    let right = best.right;
    while (left > 1) {
      const col = colScores[left - 1];
      if (col.score >= colThreshold * 0.72 || col.neutral < 0.68) left--;
      else break;
    }
    while (right < w - 1) {
      const col = colScores[right];
      if (col.score >= colThreshold * 0.72 || col.neutral < 0.68) right++;
      else break;
    }

    const marginTop = top;
    const marginBottom = h - bottom;
    const marginLeft = left;
    const marginRight = w - right;
    const totalMargin = marginTop + marginBottom + marginLeft + marginRight;
    const contentW = right - left;
    const contentH = bottom - top;

    const screenshotLike =
      totalMargin >= Math.max(18, Math.round(Math.min(w, h) * 0.10)) &&
      contentW >= w * 0.45 &&
      contentH >= h * 0.28 &&
      (marginTop >= h * 0.04 || marginBottom >= h * 0.04 ||
        marginLeft >= w * 0.04 || marginRight >= w * 0.04);

    if (!screenshotLike) return null;

    return { x: left / w, y: top / h, w: contentW / w, h: contentH / h };
  }

  function rectArea(rect) {
    return rect ? Math.max(0, rect.w) * Math.max(0, rect.h) : 0;
  }

  function detectAutoTrimRect(image) {
    const solidRect = detectSolidBorders(image);
    const screenshotRect = detectScreenshotCrop(image);

    if (solidRect && screenshotRect) {
      return rectArea(screenshotRect) < rectArea(solidRect) * 0.97 ? screenshotRect : solidRect;
    }
    return screenshotRect || solidRect || null;
  }

  async function autoTrim(photo) {
    try {
      const image = await loadImage(photo.url);
      const rect = detectAutoTrimRect(image);

      if (!rect) return false;

      const changed = !photo.trimRect ||
        Math.abs((photo.trimRect.x || 0) - rect.x) > 0.002 ||
        Math.abs((photo.trimRect.y || 0) - rect.y) > 0.002 ||
        Math.abs((photo.trimRect.w || 0) - rect.w) > 0.002 ||
        Math.abs((photo.trimRect.h || 0) - rect.h) > 0.002;

      if (!changed) return false;

      photo.trimRect = rect;
      await rebuildPreview(photo);
      return true;
    } catch (error) {
      console.warn("Border detection skipped", error);
      return false;
    }
  }

  // V14.9.40: Keep customers informed while on-device previews and
  // screenshot-border detection run; originals still upload in background.
  const ppMobilePrep = document.createElement('div');
  ppMobilePrep.id = 'ppc-mobile-prepare';
  ppMobilePrep.hidden = true;
  ppMobilePrep.setAttribute('role','status');
  ppMobilePrep.setAttribute('aria-live','polite');
  ppMobilePrep.innerHTML = `<div class="ppc-mobile-prepare-card">
    <div class="ppc-mobile-prepare-spinner" aria-hidden="true"></div>
    <h2>Carefully making your collage</h2>
    <p data-ppc-prepare-stage>Loading photos…</p>
    <progress data-ppc-prepare-bar max="100" value="0"></progress>
    <small data-ppc-prepare-count>Just a moment</small>
    <small>Your originals are saved at their original quality.</small>
  </div>`;
  document.body.appendChild(ppMobilePrep);
  const ppMobilePrepCss=document.createElement('style');
  ppMobilePrepCss.textContent=`
    #ppc-mobile-prepare[hidden]{display:none!important}
    #ppc-mobile-prepare{position:fixed;inset:0;z-index:2147483646;background:rgba(12,25,45,.82);display:flex;justify-content:center;align-items:center;padding:18px;box-sizing:border-box}
    #ppc-mobile-prepare .ppc-mobile-prepare-card{width:min(410px,100%);box-sizing:border-box;padding:29px 22px;border-radius:19px;background:#fff;text-align:center;color:#142c49;box-shadow:0 18px 48px #0003}
    #ppc-mobile-prepare h2{font-size:23px;line-height:1.2;font-weight:800;margin:15px 0 10px}
    #ppc-mobile-prepare p{font-size:16px;font-weight:650;margin:0 0 15px}
    #ppc-mobile-prepare progress{width:100%;height:11px;accent-color:#1765e5;margin-bottom:10px}
    #ppc-mobile-prepare small{display:block;line-height:1.5;color:#5c6880;margin-top:7px;font-size:13px}
    #ppc-mobile-prepare .ppc-mobile-prepare-spinner{height:46px;width:46px;border:5px solid #dceaff;border-top-color:#1465dc;border-radius:50%;margin:auto;animation:ppc-prep-spin .8s linear infinite}
    @keyframes ppc-prep-spin{to{transform:rotate(360deg)}}
    @media(prefers-reduced-motion:reduce){#ppc-mobile-prepare .ppc-mobile-prepare-spinner{animation-duration:2s}}
  `;
  document.head.appendChild(ppMobilePrepCss);
  function ppMobilePrepUpdate(stage,done,total){
    if(!ppMobilePrep.hidden){
      ppMobilePrep.querySelector('[data-ppc-prepare-stage]').textContent=stage;
      ppMobilePrep.querySelector('[data-ppc-prepare-count]').textContent=`${done} of ${total} photographs`;
      ppMobilePrep.querySelector('[data-ppc-prepare-bar]').value=total?Math.min(100,Math.round(100*done/total)):0;
    }
  }
  async function addFiles(files) {
    if (state.uploadBusy) return;

    // Do not discard customer's selected photographs. Let them decide which to remove.
    state.uploadBusy = true;
    // V14.9.42: show the preparation screen before expensive decoding.
    // Safari may not paint a just-unhidden overlay until the next frame.
    // V14.9.70: block skipping orientation/preparation on ALL screen sizes.
    const showMobilePrepare = true;
    if (showMobilePrepare) {
      ppMobilePrep.hidden = false;
      ppMobilePrep.style.setProperty('display', 'flex', 'important');
      ppMobilePrepUpdate('Preparing photo previews…', 0, files.length);
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    }
    try {
    showReview("rotate");

    const totalFiles=files.length;
    let processedFiles=0;
    pp138ShowReadProgress(0,totalFiles);
    let added = 0, repeats = 0, unsupported = 0;
    let reachedPhotoLimit = false;
    const newPhotos = [];

    status("Reading photographs...");

    try {
      for (const file of files) {
        processedFiles++;
        pp138ShowReadProgress(processedFiles,totalFiles);
        ppMobilePrepUpdate('Checking photo quality and preparing previews…',processedFiles,totalFiles);
        if (showMobilePrepare && processedFiles % 3 === 0) {
          await new Promise(resolve => requestAnimationFrame(resolve));
        }
        if (!file.type.startsWith("image/")) {
          unsupported++;
          continue;
        }

        const fingerprint =
          [file.name, file.size, file.lastModified].join("::");

        if (state.seen.has(fingerprint)) {
          repeats++;
          continue;
        }

        const url = URL.createObjectURL(file);

        try {
          const image = await loadImage(url);

          const photo = {
            name: file.name,
            file: file,
            url,
            fingerprint,
            rotation: 0,
            aspect: image.naturalWidth / image.naturalHeight,
            originalWidth: image.naturalWidth,
            originalHeight: image.naturalHeight,
            qualityDimensionsVerified: true,
            previewUrl: null,
            userCropUrl: null,
            userCropRect: null,
            trimRect: null,
            sequence: 0
          };

          state.photos.push(photo);
          state.original.push(photo);
          state.seen.add(fingerprint);
          newPhotos.push(photo);
          added++;
          // Start uploading privately while the customer reviews photographs.
          // Uploading does not alter rotation/crop metadata or printing originals.
          uploadPhotoInBackground(photo);

          if (added === 1 || added % 10 === 0) {
            // Render visible review cards only when someone needs the review UI.
            if (state.photos.length > ppPhotoLimitFor()) renderOrientation();
            status("Loaded " + added + " photographs...");
            await new Promise(resolve => requestAnimationFrame(resolve));
          }
        } catch (error) {
          URL.revokeObjectURL(url);
          unsupported++;
        }
      }
    } finally {
      state.uploadBusy = false;
      pp138ProgressText.textContent='Prepared '+added+' photos. Originals are uploading securely in the background.';
      pp138ProgressBar.value=100;
      renderOrientation();
      reachedPhotoLimit = state.photos.length > ppPhotoLimitFor();
      ppPhotoLimitNoticeUpdate();
      status(
        "Ready: " + added + " photographs added. " +
        repeats + " repeats skipped. " +
        unsupported + " unreadable." +
        (reachedPhotoLimit ? " We recommend using fewer photos for the clearest canvas, but you can proceed anyway." : "")
      );
    }

    // V14.9.78: Bounded preparation pipeline. As soon as a screenshot trim
    // completes for one photo, its AI orientation can begin; we no longer
    // wait for every photo to finish trimming before starting AI checks.
    // This preserves the exact AI model, original files and rotation mapping.
    let autoTrimmed = 0;
    let uprightFixed = 0;
    let checkedCount = 0;
    let ppTrimTotalMs = 0;
    let ppOrientationTotalMs = 0;
    let nextIndex = 0;
    const checkList = newPhotos.filter(photo => state.photos.includes(photo));
    const workerCount = Math.min(ppIsConstrainedMobile ? 2 : 4, checkList.length);
    const pp78Started = performance.now();
    await Promise.all(Array.from({length: workerCount}, async () => {
      while (nextIndex < checkList.length) {
        const photo = checkList[nextIndex++];
        if (!state.photos.includes(photo)) continue;
        // Border detection needs to finish before constructing the orientation
        // contact sheet, otherwise the AI and the final preview may disagree.
        const trimStarted = performance.now();
        const trimmed = await autoTrim(photo);
        ppTrimTotalMs += performance.now() - trimStarted;
        if (trimmed) autoTrimmed++;
        const orientationStarted = performance.now();
        const changed = await ppOrientationSecondOpinion(photo);
        ppOrientationTotalMs += performance.now() - orientationStarted;
        if (changed) uprightFixed++;
        checkedCount++;
        ppMobilePrepUpdate('Detecting screenshots and checking orientation…', checkedCount, checkList.length);
        // Gallery is behind the full-screen preparation overlay; do not rebuild
        // all thumbnails for every check. Render only when review is needed.
        if (checkedCount % 4 === 0) {
          await new Promise(resolve => requestAnimationFrame(resolve));
        }
      }
    }));
    console.info('[Perham Collage] Photo preparation pipeline', {
      photoCount: checkList.length,
      elapsedMs: Math.round(performance.now() - pp78Started),
      screenshotTrims: autoTrimmed,
      rotationsApplied: uprightFixed,
      cumulativeTrimMs: Math.round(ppTrimTotalMs),
      cumulativeOrientationMs: Math.round(ppOrientationTotalMs),
      note: 'Stage totals include overlapping worker time; they are not wall-clock totals.'
    });
    const orientationReport={checked:checkList.length,rotated:uprightFixed,
      confirmed:checkList.filter(p=>p._orientationAssessment==='confirmed').length,
      uncertain:checkList.filter(p=>p._orientationAssessment==='suspected').length,
      unavailable:checkList.filter(p=>p._orientationAssessment==='unchecked').length};
    console.info('[Perham Collage] Orientation check summary',orientationReport);
    if (uprightFixed) status(uprightFixed+' photograph'+(uprightFixed===1?' was':'s were')+
      ' automatically rotated. You can adjust any photo in the collage editor.');

    if (autoTrimmed) {
      status(autoTrimmed === 1
        ? "1 screenshot or bordered image was trimmed automatically. You can still edit it if needed."
        : autoTrimmed + " screenshots or bordered images were trimmed automatically. You can still edit them if needed.");
    }
    ppMobilePrepUpdate('Finishing touches…',newPhotos.length,newPhotos.length);
    ppDraftSchedule();
    // V14.9.70 — customers go directly to the collage after processing.
    // When processing is finished and capacity is valid, open the editor
    // automatically even if an orientation assessment was inconclusive.
    // Rotate Left/Right remain available on collage tiles and inside the crop editor.
    const ppCanOpenCollage = added > 0 && state.reviewMode &&
      state.photos.length > 0 && state.photos.length <= 100;
    if (ppCanOpenCollage) {
      if (state.photos.length > ppPhotoLimitFor()) {
        // V14.9.75: offer the size recommendation BEFORE auto-entering the collage.
        // Close preparation first so the customer can actually use the dialog.
        ppMobilePrep.hidden = true;
        ppMobilePrep.style.removeProperty('display');
        ppShowOverLimitChoice();
      } else {
        ppMobilePrepUpdate('Carefully making your collage…',newPhotos.length,newPhotos.length);
        await finishRotation();
      }
    } else if (added > 0 && state.reviewMode) {
      // Too many photographs: don't discard them or bypass capacity rules.
      renderOrientation();
      if (state.photos.length > ppPhotoLimitFor()) {
        status('For the clearest canvas, consider removing photographs or choosing a larger size. You can proceed anyway.');
        setTimeout(ppShowOverLimitChoice, 0);
      } else {
        status('Photographs are ready. Continue to your collage.');
      }
    }
    } finally {
      ppMobilePrep.hidden = true;
      ppMobilePrep.style.removeProperty('display');
    }
  }

  // V10 mobile layout and touch crop usability.
  // Scoped to collage root so it cannot affect Shopify theme pages.
  const mobileStyle = document.createElement('style');
  mobileStyle.textContent = `
    #pp-collage-v1 [data-crop-stage],
    #pp-collage-v1 [data-crop-stage] * { touch-action: none !important; }
    #pp-collage-v1 [data-crop-overlay] { overscroll-behavior: contain; }
    #pp-collage-v1 [data-crop-selection] { box-sizing: border-box; }
    @media(max-width: 767px) {
      #pp-collage-v1 { max-width: 100%; overflow-x: clip; }
      #pp-collage-v1, #pp-collage-v1 * { box-sizing: border-box; }
      #pp-collage-v1 [data-editor], #pp-collage-v1 [data-editor] .ppc-panel,
      #pp-collage-v1 [data-crop-review], #pp-collage-v1 [data-orientation] {
        width: 100%; max-width: 100%; min-width: 0;
      }
      #pp-collage-v1 [data-editor]:not([hidden]) { display: block; }
      #pp-collage-v1 [data-editor] > * { max-width: 100%; min-width: 0; }
      #pp-collage-v1 button, #pp-collage-v1 select, #pp-collage-v1 input {
        min-height: 44px; font-size: 16px;
      }
      #pp-collage-v1 [data-orientation-gallery],
      #pp-collage-v1 [data-crop-review-gallery] {
        display: grid; grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px; width: 100%;
      }
      #pp-collage-v1 .ppc-orientation-item { min-width: 0; }
      #pp-collage-v1 .ppc-orientation-item img { width: 100%; object-fit: contain; }
      #pp-collage-v1 [data-crop-overlay]:not([hidden]) {
        position: fixed !important; inset: 0 !important; z-index: 2147483645 !important;
        overflow-y: auto !important; padding: 12px !important;
        background: rgba(0,0,0,.92) !important;
      }
      #pp-collage-v1 [data-crop-stage] {
        width: 100% !important; max-width: 100% !important;
        height: min(62dvh, 550px) !important; min-height: 260px;
        user-select: none; -webkit-user-select: none;
      }
      #pp-collage-v1 [data-crop-done], #pp-collage-v1 [data-crop-close] {
        min-height: 48px; }
    }
  `;
  document.head.appendChild(mobileStyle);
  // Make the drag instruction explicit for touchscreen users.
  const photoMoveHelp=document.createElement('p');
  photoMoveHelp.className='ppc-photo-move-help';
  photoMoveHelp.style.cssText='font-size:13px;line-height:1.4;color:#334155;background:#eff6ff;border-radius:12px;padding:10px 12px;margin:10px 0;';
  photoMoveHelp.textContent='Tap a photo to crop it. Drag one photo onto another to swap immediately. On mobile, swipe beside the collage to scroll the page.';
  const previewHelp=$('[data-editor]');
  if(previewHelp)previewHelp.prepend(photoMoveHelp);
  // Show these instructions only during actual collage arrangement.
  const ppHelpStyles=document.createElement('style');
  ppHelpStyles.textContent='#pp-collage-v1.ppc-review-mode .ppc-photo-move-help{display:none!important}#pp-collage-v1 .ppc-review-delete{display:block;width:100%;min-height:44px;margin-top:8px;border:1px solid #dc2626;border-radius:9px;background:#fff;color:#b91c1c;font-weight:700;cursor:pointer}';
  ppHelpStyles.textContent += `
    #pp-collage-v1 .ppc-review-delete {
      display:flex!important;align-items:center!important;justify-content:center!important;
      width:100%!important;min-height:44px!important;height:auto!important;
      padding:9px 5px!important;margin:9px 0 0!important;
      font-size:13px!important;line-height:1.2!important;white-space:nowrap!important;
      overflow:hidden!important;text-overflow:ellipsis!important;word-break:normal!important;
    }
    @media(max-width:767px){
      #pp-collage-v1 .ppc-orientation-item {padding:8px!important;min-width:0!important;overflow:hidden!important}
      #pp-collage-v1 .ppc-orientation-buttons {display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:4px!important}
      #pp-collage-v1 .ppc-orientation-buttons button {min-width:0!important;padding:7px 2px!important;font-size:12px!important;line-height:1.25!important;white-space:normal!important}
      #pp-collage-v1 .ppc-review-delete {font-size:13px!important}
    }
  `;
  document.head.appendChild(ppHelpStyles);
  // Remove the legacy browser-only disclaimer. Permanent My Designs saving exists.
  function ppRemoveLegacyTestNotice(){
    for(const el of root.querySelectorAll('p,small,span,div')){
      if(el.children.length)continue;
      const t=(el.textContent||'').trim();
      if(t.includes('Testing only: Photographs remain in this browser.') && t.includes('Permanent saving will be added with My Designs'))el.remove();
    }
  }
  ppRemoveLegacyTestNotice();
  new MutationObserver(ppRemoveLegacyTestNotice).observe(root,{childList:true,subtree:true});
  const resizeCropObserver = new ResizeObserver(() => {
    if (state.activeCrop) requestAnimationFrame(refreshSelection);
  });
  const mobileCropStage = $('[data-crop-stage]');
  if (mobileCropStage) resizeCropObserver.observe(mobileCropStage);

  // Photo cropping — V14.9.28 touch-friendly rectangle selection, same saved crop for print

  let cropSelection = { x: 0, y: 0, w: 1, h: 1 };

  function cropBounds() {
    const stage = $("[data-crop-stage]");
    const image = $("[data-crop-image]");
    const rect = stage.getBoundingClientRect();

    const nw = image.naturalWidth || 1;
    const nh = image.naturalHeight || 1;
    const scale = Math.min((rect.width - 4) / nw, (rect.height - 4) / nh);

    const width = nw * scale;
    const height = nh * scale;

    return {
      left: (rect.width - width) / 2,
      top: (rect.height - height) / 2,
      width,
      height
    };
  }

  function refreshSelection() {
    const el = $("[data-crop-selection]");
    const b = cropBounds();

    el.style.left = b.left + cropSelection.x * b.width + "px";
    el.style.top = b.top + cropSelection.y * b.height + "px";
    el.style.width = cropSelection.w * b.width + "px";
    el.style.height = cropSelection.h * b.height + "px";
  }

  // V14.9.24 — generously sized and reliable mobile crop resize targets.
  // These are purely controls: the normalized crop data/print pipeline is unchanged.
  const ppCropHandleStyle = document.createElement('style');
  ppCropHandleStyle.textContent = `
    #pp-collage-v1 [data-crop-selection] { overflow: visible !important; }
    #pp-collage-v1 [data-crop-selection] [data-handle] {
      position: absolute !important;
      box-sizing: border-box !important;
      width: 26px !important; height: 26px !important;
      padding: 0 !important; margin: 0 !important;
      background: transparent !important; border: 0 !important;
      transform: translate(-50%,-50%) !important;
      z-index: 40 !important; touch-action: none !important;
      user-select: none !important; -webkit-user-select: none !important;
      display: block !important;
    }
    #pp-collage-v1 [data-crop-selection] [data-handle]::after {
      content: '' !important; position: absolute !important;
      width: 12px !important; height: 12px !important;
      left: 50% !important; top: 50% !important;
      transform: translate(-50%,-50%) !important;
      border-radius: 50% !important; background: #fff !important;
      border: 2px solid #1265ee !important;
      box-shadow: 0 1px 5px rgba(0,0,0,.45) !important;
      pointer-events: none !important;
    }
    #pp-collage-v1 [data-crop-selection] [data-handle="nw"] {left:0!important;top:0!important;cursor:nwse-resize!important}
    #pp-collage-v1 [data-crop-selection] [data-handle="n"] {left:50%!important;top:0!important;cursor:ns-resize!important}
    #pp-collage-v1 [data-crop-selection] [data-handle="ne"] {left:100%!important;top:0!important;cursor:nesw-resize!important}
    #pp-collage-v1 [data-crop-selection] [data-handle="e"] {left:100%!important;top:50%!important;cursor:ew-resize!important}
    #pp-collage-v1 [data-crop-selection] [data-handle="se"] {left:100%!important;top:100%!important;cursor:nwse-resize!important}
    #pp-collage-v1 [data-crop-selection] [data-handle="s"] {left:50%!important;top:100%!important;cursor:ns-resize!important}
    #pp-collage-v1 [data-crop-selection] [data-handle="sw"] {left:0!important;top:100%!important;cursor:nesw-resize!important}
    #pp-collage-v1 [data-crop-selection] [data-handle="w"] {left:0!important;top:50%!important;cursor:ew-resize!important}
    @media (pointer:coarse), (max-width:767px) {
      #pp-collage-v1 [data-crop-selection] [data-handle] {
        width: 46px !important; height: 46px !important;
      }
      #pp-collage-v1 [data-crop-selection] [data-handle]::after {
        width: 20px !important; height: 20px !important;
        border-width: 3px !important;
      }
    }
  `;
  document.head.appendChild(ppCropHandleStyle);
  const ppCropSelectionEl = $('[data-crop-selection]');
  if (ppCropSelectionEl) {
    for (const dir of ['nw','n','ne','e','se','s','sw','w']) {
      if (ppCropSelectionEl.querySelector(`[data-handle="${dir}"]`)) continue;
      const grip = document.createElement('span');
      grip.dataset.handle = dir;
      grip.setAttribute('aria-label', `Resize crop ${dir}`);
      ppCropSelectionEl.appendChild(grip);
    }
  }

  // V13.2: zoom uses the existing normalized crop rectangle. The backend
  // already applies that exact rectangle to the original high-resolution file.
  const ppPositionStyle=document.createElement('style');
  ppPositionStyle.textContent=`
    #pp-collage-v1 .ppc-position-tools{display:grid;grid-template-columns:1fr auto;gap:8px 12px;align-items:center;background:#eef5ff;border:1px solid #c7ddfb;padding:12px;border-radius:12px;margin:12px 0;color:#173b67}
    #pp-collage-v1 .ppc-position-tools label{font-weight:800;font-size:14px}
    #pp-collage-v1 .ppc-position-tools output{font-weight:800;font-variant-numeric:tabular-nums}
    #pp-collage-v1 .ppc-position-tools input{grid-column:1 / -1;min-width:0;width:100%;accent-color:#1265ee}
    #pp-collage-v1 .ppc-position-tools small{grid-column:1 / -1;line-height:1.4}
    #pp-collage-v1 .ppc-position-reset{grid-column:1 / -1;background:white;border:1px solid #9fbae0;border-radius:9px;padding:9px 14px;min-height:42px;font-weight:700;cursor:pointer}
    @media(max-width:767px){
      #pp-collage-v1 [data-crop-overlay]:not([hidden]){padding:env(safe-area-inset-top, 8px) 8px env(safe-area-inset-bottom, 8px)!important;overflow:auto!important;align-items:flex-start!important;overscroll-behavior:contain}
      #pp-collage-v1 [data-crop-overlay]:not([hidden]) > *{width:100%!important;max-width:100%!important;max-height:none!important;margin:0 auto!important;border-radius:12px!important}
      #pp-collage-v1 [data-crop-stage]{height:clamp(290px,54dvh,690px)!important;min-height:280px!important}
      #pp-collage-v1 .ppc-position-tools{margin:8px 0}
    }
  `;
  document.head.appendChild(ppPositionStyle);
  const ppPositionTools=document.createElement('div');
  ppPositionTools.className='ppc-position-tools';
  // V14.9.28: Crop by drawing/dragging a rectangle; no zoom slider.
  ppPositionStyle.textContent += '#pp-collage-v1 .ppc-position-tools{display:none!important;}';
  ppPositionTools.innerHTML='<label for="ppc-position-zoom">Zoom photograph</label><output id="ppc-position-percent" for="ppc-position-zoom">100%</output><input id="ppc-position-zoom" type="range" min="100" max="300" step="5" value="100" aria-label="Photo zoom percentage"><small>Drag the highlighted selection to position your photograph. The area inside the box is what will be used on the canvas.</small><button type="button" class="ppc-position-reset">Reset position and zoom</button>';
  const ppPositionZoom=ppPositionTools.querySelector('input');
  const ppPositionPercent=ppPositionTools.querySelector('output');
  const ppPositionReset=ppPositionTools.querySelector('button');
  const ppCropDone=$('[data-crop-done]');
  // A single clear control is easier than the broken zoom slider.
  const ppEasyReset=document.createElement('button');
  ppEasyReset.type='button';
  ppEasyReset.textContent='Show full photo';
  ppEasyReset.className='ppc-crop-full-reset';
  ppEasyReset.style.cssText='display:block;width:100%;min-height:48px;margin:10px 0;padding:10px 14px;border-radius:10px;border:1px solid #b8c9e6;background:#eef5ff;color:#143762;font-weight:750;cursor:pointer';
  ppEasyReset.addEventListener('click',()=>{
    if(!state.activeCrop)return;
    cropSelection={x:0,y:0,w:1,h:1};
    refreshSelection();
  });
  if(ppCropDone?.parentElement){
    ppCropDone.textContent='Done';
    ppCropDone.setAttribute('aria-label','Done — apply crop');
    ppCropDone.parentElement.parentElement?.insertBefore(ppEasyReset,ppCropDone.parentElement);
  }
  if(ppCropDone?.parentElement)ppCropDone.parentElement.parentElement?.insertBefore(ppPositionTools,ppCropDone.parentElement);
  function ppRefreshPositionZoom(){
    if(!cropSelection)return;
    const factor=Math.max(1,Math.min(3,1/Math.min(cropSelection.w,cropSelection.h)));
    ppPositionZoom.value=String(Math.round(factor*20)*5);
    ppPositionPercent.textContent=Math.round(factor*100)+'%';
  }
  ppPositionZoom.addEventListener('input',()=>{
    if(!state.activeCrop)return;
    const old=cropSelection;
    const factor=Number(ppPositionZoom.value)/100;
    // Uniform zoom preserves the selected crop's aspect ratio.
    const aspect=old.w/Math.max(.0001,old.h);
    let w=Math.min(1,1/factor),h=w/aspect;
    if(h>1){h=1;w=h*aspect;}
    const cx=old.x+old.w/2,cy=old.y+old.h/2;
    cropSelection={x:clamp(cx-w/2,0,1-w),y:clamp(cy-h/2,0,1-h),w,h};
    ppPositionPercent.textContent=Math.round(factor*100)+'%';
    refreshSelection();
  });
  ppPositionReset.addEventListener('click',()=>{
    if(!state.activeCrop)return;
    cropSelection={x:0,y:0,w:1,h:1};
    ppRefreshPositionZoom();refreshSelection();
  });

  function refreshCrop() {
    const photo = state.activeCrop;
    if (!photo) return;

    const image = $("[data-crop-image]");
    const src = baseSrc(photo);

    // V14.9.2: The crop screen must show the saved, non-destructive colour
    // adjustments just like the collage tiles. We do not bake the filter into
    // the source file: the high-resolution print pipeline still receives the
    // original plus its saved adjustments, avoiding double application.
    image.style.filter = ppPhotoFilter(photo);

    if (image.src !== new URL(src, document.baseURI).href) {
      image.src = src;
    }

    image.onload = () =>
      requestAnimationFrame(refreshSelection);

    if (image.complete && image.naturalWidth) {
      requestAnimationFrame(refreshSelection);
    }
  }

  // V13.5: Replace keeps the same collage position and orders the original
  // full-resolution file through the existing private upload queue.
  const pp138ReplaceInput=document.createElement('input');
  pp138ReplaceInput.type='file';
  pp138ReplaceInput.accept='image/*';
  pp138ReplaceInput.hidden=true;
  root.appendChild(pp138ReplaceInput);
  let pp138PendingReplacement=null;
  const pp138ReplaceButton=document.createElement('button');
  pp138ReplaceButton.type='button';
  pp138ReplaceButton.className='ppc-v138-replace';
  pp138ReplaceButton.textContent='↻ Replace this photo';
  pp138ReplaceButton.addEventListener('click',()=>{
    if(!state.activeCrop || state.uploadBusy)return;
    pp138PendingReplacement=state.activeCrop;
    pp138ReplaceInput.click();
  });
  pp138ReplaceInput.addEventListener('change',async()=>{
    const file=pp138ReplaceInput.files?.[0];
    pp138ReplaceInput.value='';
    const old=pp138PendingReplacement;
    pp138PendingReplacement=null;
    if(!file||!old||!state.photos.includes(old))return;
    if(!file.type.startsWith('image/')){status('Please choose an image file.');return;}
    const fingerprint=[file.name,file.size,file.lastModified].join('::');
    // A duplicate filename is allowed if the customer deliberately replaces it.
    const url=URL.createObjectURL(file);
    try{
      const image=await loadImage(url);
      if(!state.photos.includes(old)){URL.revokeObjectURL(url);return;}
      ppRemember();
      const replacement={name:file.name,file,url,fingerprint,rotation:0,
        aspect:image.naturalWidth/image.naturalHeight,
        originalWidth:image.naturalWidth,originalHeight:image.naturalHeight,
        qualityDimensionsVerified:true,previewUrl:null,userCropUrl:null,
        userCropRect:null,trimRect:null,sequence:0};
      const slot=state.photos.indexOf(old);
      const originalSlot=state.original.indexOf(old);
      state.photos[slot]=replacement;
      if(originalSlot>=0)state.original[originalSlot]=replacement;
      else state.original.push(replacement);
      state.seen.delete(old.fingerprint);
      state.seen.add(fingerprint);
      // Do not revoke old URLs; in-session history may still reference them.
      closeCrop();
      uploadPhotoInBackground(replacement);
      safeRender();
      ppDraftSchedule();
      // Reuse the existing automatic screenshot trim on the replacement.
      autoTrim(replacement).then(()=>safeRender()).catch(error=>console.warn('Replacement border check skipped',error));
      status('Photo replaced in its original collage position.');
    }catch(error){URL.revokeObjectURL(url);showError(error,'photo replacement');}
  });
  const pp138CropOverlay=$('[data-crop-overlay]');
  const pp138CropCard=pp138CropOverlay?.firstElementChild;
  if(pp138CropCard){
    const heading=pp138CropCard.querySelector('h2,h3')||pp138CropCard.firstElementChild;
    if(heading?.parentNode)heading.insertAdjacentElement('afterend',pp138ReplaceButton);
    else pp138CropCard.prepend(pp138ReplaceButton);
  }

  function openCrop(photo, focusElement) {
    state.activeCrop = photo;
    state.returnFocus = focusElement;

    cropSelection = photo.userCropRect
      ? { ...photo.userCropRect }
      : { x: 0, y: 0, w: 1, h: 1 };

    $("[data-crop-overlay]").hidden = false;
    $("[data-trim-status]").textContent =
      "Need to turn this photo? Use Turn Left or Turn Right below. Drag inside the crop to reposition it, or use the corners to adjust. Tap Done when happy.";

    refreshCrop();
    ppRefreshPositionZoom();
  }

  function closeCrop() {
    $("[data-crop-overlay]").hidden = true;
    state.activeCrop = null;

    safeRender();

    // V14.9.30: Both photo-review screens need their thumbnails rebuilt.
    // Previously only Crop Review refreshed; editing from the initial
    // orientation/review screen appeared to discard the crop until collage.
    if (state.reviewMode) {
      if (state.reviewStep === "rotate") renderOrientation();
      else if (state.reviewStep === "crop") renderCropReview();
    }

    if (state.returnFocus?.isConnected) {
      state.returnFocus.focus();
    }

    state.returnFocus = null;
  }

  async function saveCrop() {
    const photo = state.activeCrop;
    if (!photo) return;

    const button = $("[data-crop-done]");
    button.disabled = true;
    button.textContent = "Saving...";

    try {
      const image = await loadImage(baseSrc(photo));
      const c = cropSelection;

      const sx = image.naturalWidth * c.x;
      const sy = image.naturalHeight * c.y;
      const sw = image.naturalWidth * c.w;
      const sh = image.naturalHeight * c.h;

      const scale = Math.min(1, 2400 / Math.max(sw, sh));

      const canvas = document.createElement("canvas");
      canvas.width = Math.max(1, Math.round(sw * scale));
      canvas.height = Math.max(1, Math.round(sh * scale));

      canvas.getContext("2d").drawImage(
        image, sx, sy, sw, sh,
        0, 0, canvas.width, canvas.height
      );

      const url = await canvasURL(canvas);

      ppRemember();
      if (photo.userCropUrl) URL.revokeObjectURL(photo.userCropUrl);
      photo.userCropUrl = url;
      photo.userCropRect = { ...cropSelection };
      photo.aspect = canvas.width / canvas.height;

      closeCrop();
      // The draft watcher primarily observes UI changes, which may not occur
      // for photo-only edits. Explicitly schedule persistence after Done.
      ppDraftSchedule();
      status("Crop applied. Your photograph has been updated.");
    } catch (error) {
      $("[data-trim-status]").textContent =
        "Unable to save crop: " + error.message;
    } finally {
      button.disabled = false;
      button.textContent = "Done";
    }
  }

  const cropStage = $("[data-crop-stage]");

  cropStage.addEventListener("pointerdown", event => {
    if (!state.activeCrop) return;

    const b = cropBounds();
    const r = cropStage.getBoundingClientRect();

    const x = clamp(
      (event.clientX - r.left - b.left) / b.width, 0, 1
    );
    const y = clamp(
      (event.clientY - r.top - b.top) / b.height, 0, 1
    );

    const old = { ...cropSelection };
    const handle = event.target?.closest?.("[data-handle]")?.dataset?.handle || event.target?.dataset?.handle;

    const inside = x >= old.x && x <= old.x + old.w &&
      y >= old.y && y <= old.y + old.h;

    const mode = handle || (inside ? "move" : "new");

    state.cropPointer = {
      id: event.pointerId, x, y, old, mode
    };

    if (mode === "new") {
      cropSelection = { x, y, w: .001, h: .001 };
    }

    try { cropStage.setPointerCapture(event.pointerId); } catch {}
    event.preventDefault();
    refreshSelection();
  });

  cropStage.addEventListener("pointermove", event => {
    const drag = state.cropPointer;
    if (!drag || drag.id !== event.pointerId) return;

    const b = cropBounds();
    const r = cropStage.getBoundingClientRect();

    const x = clamp(
      (event.clientX - r.left - b.left) / b.width, 0, 1
    );
    const y = clamp(
      (event.clientY - r.top - b.top) / b.height, 0, 1
    );

    const dx = x - drag.x, dy = y - drag.y;
    const o = drag.old;

    if (drag.mode === "move") {
      cropSelection = {
        ...o,
        x: clamp(o.x + dx, 0, 1 - o.w),
        y: clamp(o.y + dy, 0, 1 - o.h)
      };
    } else if (drag.mode === "new") {
      cropSelection = {
        x: Math.min(x, drag.x),
        y: Math.min(y, drag.y),
        w: Math.max(.001, Math.abs(dx)),
        h: Math.max(.001, Math.abs(dy))
      };
    } else {
      let l = o.x, t = o.y;
      let rr = o.x + o.w, bb = o.y + o.h;

      if (drag.mode.includes("w")) l = clamp(l + dx, 0, rr - .04);
      if (drag.mode.includes("e")) rr = clamp(rr + dx, l + .04, 1);
      if (drag.mode.includes("n")) t = clamp(t + dy, 0, bb - .04);
      if (drag.mode.includes("s")) bb = clamp(bb + dy, t + .04, 1);

      cropSelection = { x: l, y: t, w: rr - l, h: bb - t };
    }

    refreshSelection();
    ppRefreshPositionZoom();
    event.preventDefault();
  });

  function finishCropPointer() {
    const drag = state.cropPointer;
    if (!drag) return;

    if (cropSelection.w < .04 || cropSelection.h < .04) {
      cropSelection = { ...drag.old };
    }

    state.cropPointer = null;
    refreshSelection();
  }

  cropStage.addEventListener("pointerup", finishCropPointer);
  cropStage.addEventListener("pointercancel", finishCropPointer);

  // V12.2: Photo enhancements use the same active photo as cropping.
  const ppEnhanceCss=document.createElement('style');
  ppEnhanceCss.textContent=`
    #ppc-enhance-dialog[hidden]{display:none!important}
    #ppc-enhance-dialog{position:fixed;inset:0;z-index:2147483647;background:rgba(10,19,36,.85);display:flex;align-items:center;justify-content:center;padding:12px;box-sizing:border-box}
    #ppc-enhance-dialog .ppc-enhance-card{width:min(480px,100%);max-height:92dvh;overflow:auto;background:#fff;border-radius:20px;padding:20px;color:#142036;box-sizing:border-box;box-shadow:0 20px 75px #0006}
    #ppc-enhance-dialog .ppc-enhance-image{display:block;width:100%;max-height:27dvh;object-fit:contain;border-radius:10px;background:#edf2f7}
    #ppc-enhance-dialog .ppc-enhance-field{display:block;margin-top:13px;font-size:14px;font-weight:700}
    #ppc-enhance-dialog input[type=range]{width:100%;min-height:38px;accent-color:#1768e9}
    #ppc-enhance-dialog .ppc-enhance-actions{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:14px}
    #ppc-enhance-dialog button{border-radius:10px;min-height:45px;padding:8px 12px;font:inherit;font-weight:700;border:1px solid #cbd5e1;background:#fff;color:#142036}
    #ppc-enhance-dialog button.ppc-enhance-primary{background:#1265ee;color:#fff;border-color:#1265ee}
    #ppc-enhance-trigger{margin:10px 0;padding:12px 16px;background:#eaf2ff;color:#133968;border:1px solid #b5cdf7;border-radius:12px;font-weight:750;min-height:46px;width:100%}
  `;
  document.head.appendChild(ppEnhanceCss);
  const ppEnhanceTrigger=document.createElement('button');
  ppEnhanceTrigger.type='button';
  ppEnhanceTrigger.id='ppc-enhance-trigger';
  ppEnhanceTrigger.textContent='✨ Enhance This Photo';
  // Place inside the existing crop dialog, before the Use This Crop action.
  const ppCropSave=$("[data-crop-done]");
  ppCropSave?.parentElement?.parentElement?.insertBefore(ppEnhanceTrigger,ppCropSave.parentElement);
  const ppEnhanceOverlay=document.createElement('div');
  ppEnhanceOverlay.id='ppc-enhance-dialog';ppEnhanceOverlay.hidden=true;
  ppEnhanceOverlay.innerHTML=`<section class="ppc-enhance-card" role="dialog" aria-modal="true" aria-label="Enhance photograph"><h2 style="margin:0 0 12px;font-size:22px">Enhance your photo</h2><img class="ppc-enhance-image" alt="Photo adjustment preview"><p style="font-size:12px;color:#536782">Adjustments are saved with this photograph. Original files are unchanged.</p><div data-pp-enhance-controls></div><div class="ppc-enhance-actions"><button type="button" data-enhance-reset>Reset</button><button type="button" data-enhance-cancel>Cancel</button><button type="button" data-enhance-before aria-pressed="false">Hold to compare</button><button type="button" class="ppc-enhance-primary" data-enhance-save>Apply Changes</button></div></section>`;
  document.body.appendChild(ppEnhanceOverlay);
  const ppEnhanceControls=ppEnhanceOverlay.querySelector('[data-pp-enhance-controls]');
  for(const [key,label,min,max] of [['brightness','Brightness',50,150],['contrast','Contrast',50,150],['saturation','Colour intensity',0,200]]) {
    const wrap=document.createElement('label');wrap.className='ppc-enhance-field';
    wrap.textContent=label+' ';
    const value=document.createElement('output');value.dataset.enhanceValue=key;
    const slider=document.createElement('input');slider.type='range';slider.min=String(min);slider.max=String(max);slider.step='1';slider.dataset.enhanceSlider=key;
    wrap.append(value,slider);ppEnhanceControls.append(wrap);
  }
  let ppEnhancePhoto=null,ppEnhanceDraft=null;
  const ppEnhanceImage=ppEnhanceOverlay.querySelector('img');
  function ppUpdateEnhanceView(){
    if(!ppEnhanceDraft)return;
    ppEnhanceOverlay.querySelectorAll('[data-enhance-slider]').forEach(s=>{
      const key=s.dataset.enhanceSlider;s.value=String(ppEnhanceDraft[key]);
      ppEnhanceOverlay.querySelector(`[data-enhance-value="${key}"]`).textContent=ppEnhanceDraft[key]+'%';
    });
    const a=ppEnhanceDraft;
    ppEnhanceImage.style.filter=`brightness(${a.brightness}%) contrast(${a.contrast}%) saturate(${a.saturation}%)`;
  }
  ppEnhanceTrigger.addEventListener('click',()=>{
    if(!state.activeCrop)return;
    ppEnhancePhoto=state.activeCrop;
    ppEnhanceDraft=ppNormalAdjust(ppEnhancePhoto.adjustments);
    ppEnhanceImage.src=baseSrc(ppEnhancePhoto);
    ppEnhanceOverlay.hidden=false;ppUpdateEnhanceView();
    ppEnhanceOverlay.querySelector('[data-enhance-save]').focus();
  });
  ppEnhanceOverlay.querySelectorAll('[data-enhance-slider]').forEach(s=>s.addEventListener('input',()=>{
    ppEnhanceDraft[s.dataset.enhanceSlider]=Number(s.value);ppUpdateEnhanceView();
  }));
  function ppCloseEnhance(){ppEnhanceOverlay.hidden=true;ppEnhancePhoto=null;ppEnhanceDraft=null;ppEnhanceTrigger.focus();}
  ppEnhanceOverlay.querySelector('[data-enhance-reset]').addEventListener('click',()=>{ppEnhanceDraft=ppNormalAdjust({});ppUpdateEnhanceView();});
  ppEnhanceOverlay.querySelector('[data-enhance-cancel]').addEventListener('click',ppCloseEnhance);
  ppEnhanceOverlay.querySelector('[data-enhance-save]').addEventListener('click',()=>{
    if(ppEnhancePhoto){ppRemember();ppEnhancePhoto.adjustments=ppNormalAdjust(ppEnhanceDraft);safeRender();
      // Keep the change in the same photo object used by buildSavedDesign().
      const edited=state.photos.find(p=>p===ppEnhancePhoto);
      if(edited){for(const img of $$('[data-ppc-photo] img')){if(img.parentElement?.ppcPhoto===edited)img.style.setProperty('filter',(ppPhotoFilter(edited)||'none')+' '+(ppCollageFilterCSS[ppCollageFilterMode]||'none'),'important');}}
      // Also refresh the still-open crop popup, without resetting its selection.
      if(state.activeCrop===ppEnhancePhoto) refreshCrop();
      if(state.reviewMode){
        if(state.reviewStep==='rotate') renderOrientation();
        else if(state.reviewStep==='crop') renderCropReview();
      }
      ppDraftSchedule();
      status('Photo enhancements applied and included in your saved design.');}
    ppCloseEnhance();
  });
  const compare=ppEnhanceOverlay.querySelector('[data-enhance-before]');
  const compareStart=()=>{ppEnhanceImage.style.filter='none';compare.setAttribute('aria-pressed','true');};
  const compareEnd=()=>{ppUpdateEnhanceView();compare.setAttribute('aria-pressed','false');};
  compare.addEventListener('pointerdown',compareStart);compare.addEventListener('pointerup',compareEnd);
  compare.addEventListener('pointercancel',compareEnd);compare.addEventListener('blur',compareEnd);
  ppEnhanceOverlay.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();ppCloseEnhance();}});

  $("[data-crop-done]").addEventListener("click", saveCrop);
  $("[data-crop-close]").addEventListener("click", closeCrop);

  $$("[data-crop-reset]").forEach(button =>
    button.addEventListener("click", () => {
      cropSelection = { x: 0, y: 0, w: 1, h: 1 };
      refreshSelection();
    })
  );

  $("[data-select-all]").addEventListener("click", () => {
    cropSelection = { x: 0, y: 0, w: 1, h: 1 };
    refreshSelection();
  });

  $("[data-rotate-left]").addEventListener("click", async () => {
    if (state.activeCrop) await rotatePhoto(state.activeCrop, -90);
  });

  $("[data-rotate-right]").addEventListener("click", async () => {
    if (state.activeCrop) await rotatePhoto(state.activeCrop, 90);
  });

  $("[data-rotate-auto]").addEventListener("click", async () => {
    const photo = state.activeCrop;
    if (!photo) return;

    ppRemember();
    photo.rotation = 0;
    photo._orientationChecked = true;
    await rebuildPreview(photo);
  });

  $("[data-trim-auto]").addEventListener("click", async () => {
    const photo = state.activeCrop;
    if (!photo) return;

    const found = await autoTrim(photo);
    $("[data-trim-status]").textContent = found
      ? "Borders trimmed."
      : "No obvious borders found.";
  });

  $("[data-trim-keep]").addEventListener("click", async () => {
    const photo = state.activeCrop;
    if (!photo) return;

    photo.trimRect = null;
    await rebuildPreview(photo);
    $("[data-trim-status]").textContent =
      "Original borders restored.";
  });

  $("[data-crop-overlay]").addEventListener("click", event => {
    if (event.target === $("[data-crop-overlay]")) closeCrop();
  });

  document.addEventListener("keydown", event => {
    if (event.key === "Escape" && state.activeCrop) closeCrop();
  });

  // =====================================================
  // PERHAM PRINTS - MY DESIGNS INTEGRATION V1
  // Uses existing Shopify App Proxy and private R2 storage
  // =====================================================

  const collageAPI = "/apps/perham-collage";
  let savedDesignId = null;
  let savedDesignName = "";
  let savingDesign = false;

  function makeSaveButton(label, handler) {
    const button = document.createElement("button");
    button.type = "button";
    button.textContent = label;
    button.className = "ppc-save-button";
    button.style.cssText = [
      "padding:13px 20px",
      "background:#171717",
      "color:white",
      "border:0",
      "border-radius:9px",
      "font-weight:700",
      "cursor:pointer",
      "margin:6px"
    ].join(";");

    button.addEventListener("click", handler);
    return button;
  }

  async function collageRequest(path, options = {}) {
    const response = await fetch(collageAPI + path, {
      ...options,
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        ...(options.body
          ? { "Content-Type": "application/json" }
          : {}),
        ...(options.headers || {})
      }
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok || result.error) {
      throw new Error(
        result.error ||
        "The collage service returned HTTP " + response.status
      );
    }

    return result;
  }

  // V14.9.45 — selected whole-collage colour treatment, independently of per-photo edits.
  let ppCollageFilterMode = 'original';
  const ppCollageFilterCSS = {
    original:'none', bw:'grayscale(1)', sepia:'sepia(1) saturate(1.15) contrast(1.04)',
    vintage:'sepia(.65) saturate(.85) contrast(.95)',
    // Cool Tone removed; existing saved designs using it fall back to Original.
  };
  function ppApplyCollageFilter(element) {
    element.style.setProperty('filter',ppCollageFilterCSS[ppCollageFilterMode] || 'none','important');
  }
  function collageSettings() {
    const fields = {
      ratio: "[data-ratio]",
      title: "[data-title]",
      subtitle: "[data-subtitle]",
      position: "[data-position]",
      fit: "[data-fit]",
      gap: "[data-gap]",
      colour: "[data-colour]",
      bg: "[data-bg]",
      textSize: "[data-text-size]",
      textWidth: "[data-text-width]"
    };

    const result = {};

    for (const [key, selector] of Object.entries(fields)) {
      result[key] = (key === 'title' || key === 'subtitle') && !textEnabled
        ? '' : String($(selector)?.value ?? "");
    }

    // V14.9.7: The reserved text area's colour is ALWAYS the photo spacing colour.
    // Keep the legacy bg option synchronised for existing server/data contracts.
    result.bg = pp14GetGapColour();
    result.gapColour = pp14GetGapColour();
    result.gapBackground = pp1498GetBackground();
    result.photoArrangement = v11Arrangement;
    result.collageFilter = ppCollageFilterMode;
    result.textFont = ppV149Font?.value || "Arial";
    return result;
  }

  function restoreCollageSettings(options = {}) {
    const fields = {
      ratio: "[data-ratio]",
      title: "[data-title]",
      subtitle: "[data-subtitle]",
      position: "[data-position]",
      fit: "[data-fit]",
      gap: "[data-gap]",
      colour: "[data-colour]",
      bg: "[data-bg]",
      textSize: "[data-text-size]",
      textWidth: "[data-text-width]"
    };

    for (const [key, selector] of Object.entries(fields)) {
      const element = $(selector);

      if (
        element &&
        options[key] !== undefined &&
        options[key] !== null
      ) {
        element.value = String(options[key]);
      }
    }
    ppCollageFilterMode = Object.hasOwn(ppCollageFilterCSS, options.collageFilter) ? options.collageFilter : 'original';
    root.querySelectorAll('[data-pp-collage-filter]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.ppCollageFilter === ppCollageFilterMode)));
    // Older designs may contain a separate text panel colour: ignore it.
    // The current spacing colour is the only background colour choice.
    pp14SetGapColour(options.gapColour || '#ffffff');
    pp1498SetBackground(options.gapBackground || 'solid', false);
    const backgroundField = $('[data-bg]');
    if (backgroundField) backgroundField.value = pp14GetGapColour();
    if(ppV149Font && options.textFont){ ppV149Font.value = ppV149CleanFont(options.textFont); pp1494SyncFont(); }
    if(options.photoArrangement) {v11Arrangement=options.photoArrangement; v11RefreshButtons();}
    // My Designs may restore text after initialising the editor.
    if (typeof syncTextOptionFromRestoredDesign === 'function') {
      syncTextOptionFromRestoredDesign();
    }
  }

  function collageShape() {
    const ratio = $("[data-ratio]").value;
    return ratio === "1/1" ? "square" : "rectangle";
  }

  // Upload the actual original File, not the cropped preview.
  async function uploadOriginalPhotoNow(photo) {
    if (photo.remoteId) return photo.remoteId;

    if (!(photo.file instanceof File)) {
      throw new Error(
        "Original photo missing for " + photo.name +
        ". Please add this photograph again."
      );
    }

    const file = photo.file;

    const request = await collageRequest("/uploads/request", {
      method: "POST",
      body: JSON.stringify({
        filename: file.name.slice(0, 200),
        mime: file.type,
        bytes: file.size
      })
    });

    if (!request.uploadUrl || !request.photoId) {
      throw new Error("The photo upload request was incomplete.");
    }

    const uploaded = await fetch(request.uploadUrl, {
      method: "PUT",
      headers: request.headers || {
        "Content-Type": file.type
      },
      body: file
    });

    if (!uploaded.ok) {
      throw new Error(
        "Cloudflare photo upload failed (HTTP " +
        uploaded.status + ")."
      );
    }

    const completed = await collageRequest(
      "/uploads/" + encodeURIComponent(request.photoId) +
      "/complete",
      {
        method: "POST",
        body: JSON.stringify({})
      }
    );

    if (!completed.ready) {
      throw new Error("The photograph upload was not confirmed.");
    }

    photo.remoteId = request.photoId;
    return request.photoId;
  }


  // V6.4: One shared upload per photograph. The save action waits for
  // background work instead of starting the same upload a second time.
  const backgroundUploadQueue = [];
  let backgroundWorkers = 0;
  const maxBackgroundWorkers = ppIsConstrainedMobile ? 2 : 3;

  function uploadOriginalPhoto(photo) {
    if (photo.remoteId) return Promise.resolve(photo.remoteId);
    if (photo._originalUploadPromise) return photo._originalUploadPromise;
    photo._originalUploadPromise = uploadOriginalPhotoNow(photo).finally(() => {
      photo._originalUploadPromise = null;
    });
    return photo._originalUploadPromise;
  }

  function uploadPhotoInBackground(photo) {
    if (!photo || photo.remoteId || photo._backgroundQueued || !photo.file) return;
    photo._backgroundQueued = true;
    backgroundUploadQueue.push(photo);
    drainBackgroundUploads();
  }

  function drainBackgroundUploads() {
    while (backgroundWorkers < maxBackgroundWorkers && backgroundUploadQueue.length) {
      const photo = backgroundUploadQueue.shift();
      backgroundWorkers++;
      (async () => {
        try {
          // Keep originals even when the photo is later removed from the collage;
          // unused private objects can be cleaned up later by a retention job.
          await uploadOriginalPhoto(photo);
          try {
            await ensurePrivateEditingPreview(photo);
          } catch (error) {
            console.warn("Background editing preview skipped:", error);
          }
        } catch (error) {
          // Never block the editor. The next Save retries failed uploads.
          console.warn("Background original upload will retry on Save:", error);
        } finally {
          photo._backgroundQueued = false;
          backgroundWorkers--;
          drainBackgroundUploads();
        }
      })();
    }
  }

  // Create an unrotated, uncropped editing preview. The saved
  // rotation, trim and crop settings are reapplied when opening.
  async function makePrivateEditingPreview(photo) {
    const image = await loadImage(photo.url);
    const scale = Math.min(1, 1200 / Math.max(image.naturalWidth, image.naturalHeight));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    let quality = 0.82;
    let blob = null;
    do {
      blob = await new Promise(resolve => canvas.toBlob(resolve, "image/jpeg", quality));
      if (!blob) throw new Error("Unable to make the editing preview.");
      quality -= 0.12;
    } while (blob.size > 2097152 && quality >= 0.34);
    if (blob.size > 2097152) throw new Error("Preview exceeds 2 MB.");
    return blob;
  }

  async function ensurePrivateEditingPreview(photo) {
    // V16: background uploads and Save must share the same preview operation.
    if (photo.privatePreviewUploaded || !photo.remoteId) return;
    if (photo._privatePreviewPromise) return photo._privatePreviewPromise;
    photo._privatePreviewPromise = uploadPrivateEditingPreviewNow(photo);
    try { return await photo._privatePreviewPromise; }
    finally { photo._privatePreviewPromise = null; }
  }

  async function uploadPrivateEditingPreviewNow(photo) {
    if (photo.privatePreviewUploaded || !photo.remoteId) return;
    const blob = await makePrivateEditingPreview(photo);
    const details = {
      photoId: photo.remoteId,
      mime: "image/jpeg",
      bytes: blob.size
    };
    const request = await collageRequest("/previews/request", {
      method: "POST",
      body: JSON.stringify(details)
    });
    const put = await fetch(request.uploadUrl, {
      method: "PUT",
      headers: request.headers || { "Content-Type": "image/jpeg" },
      body: blob
    });
    if (!put.ok) throw new Error("Preview upload HTTP " + put.status);
    const done = await collageRequest("/previews/complete", {
      method: "POST",
      body: JSON.stringify(details)
    });
    if (!done.ready) throw new Error("Editing preview was not confirmed.");
    photo.privatePreviewUploaded = true;
  }

  // V4: Capture the whole rendered collage, including text and layout.
  // html2canvas runs in the customer's browser; no third-party upload occurs.
  let collageCapturePromise = null;
  function loadCollageCaptureLibrary() {
    if (window.html2canvas) return Promise.resolve(window.html2canvas);
    if (collageCapturePromise) return collageCapturePromise;
    collageCapturePromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
      script.async = true;
      script.onload = () => window.html2canvas ? resolve(window.html2canvas) : reject(new Error("Capture library missing"));
      script.onerror = () => reject(new Error("Unable to load collage capture library"));
      document.head.appendChild(script);
    }).catch(error => { collageCapturePromise = null; throw error; });
    return collageCapturePromise;
  }

  async function createFinishedCollageThumbnail() {
    safeRender();
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    const board = $("[data-board]");
    if (!board || !board.clientWidth || !board.clientHeight) throw new Error("Collage preview is not visible");
    const capture = await loadCollageCaptureLibrary();
    const canvas = await capture(board, {
      backgroundColor: null,
      scale: Math.min(2, 1000 / Math.max(board.clientWidth, board.clientHeight)),
      useCORS: false,
      allowTaint: false,
      logging: false,
      scrollX: 0,
      scrollY: -window.scrollY
    });
    const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/jpeg", 0.80));
    if (!blob || blob.size > 2097152) throw new Error("Finished collage thumbnail is too large");
    return blob;
  }

  async function uploadFinishedCollageThumbnail(designId) {
    const blob = await createFinishedCollageThumbnail();
    const request = await collageRequest("/design-thumbnails/" + encodeURIComponent(designId) + "/request", {
      method: "POST", body: JSON.stringify({ mime: "image/jpeg", bytes: blob.size })
    });
    const uploaded = await fetch(request.uploadUrl, {
      method: "PUT", headers: request.headers || { "Content-Type": "image/jpeg" }, body: blob
    });
    if (!uploaded.ok) throw new Error("Collage thumbnail upload HTTP " + uploaded.status);
    const done = await collageRequest("/design-thumbnails/" + encodeURIComponent(designId) + "/complete", {
      method: "POST", body: JSON.stringify({ mime: "image/jpeg", bytes: blob.size })
    });
    if (!done.ready) throw new Error("Finished thumbnail not confirmed");
  }

  // =====================================================
  // V5.1: LIVE SHOPIFY CANVAS VARIANTS
  // Full canvas face only; mirrored/blurred edges are handled
  // during printing, not in the customer editor.
  // Checkout remains disabled until production render is ready.
  // =====================================================

  // Mug Phase 1: opt-in product-mode via verified Shopify mug variant.
  const ppMugHandle = 'personalised-picture-collage-photo-cup-mug';
  const ppMugPath = '/products/' + ppMugHandle;
  const ppMugParams = new URLSearchParams(location.search);
  const ppMugMode = ppMugParams.get('collage_product') === 'mug' &&
    /^\d+$/.test(ppMugParams.get('mug_variant') || '');
  if (ppMugMode) root.classList.add('ppc-mug-mode');
  const ppMugStyle = document.createElement('style');
  ppMugStyle.textContent = `
    #pp-collage-v1.ppc-mug-mode [data-ppc-v5-orientation-box],
    #pp-collage-v1.ppc-mug-mode [data-ppc-v5-square],
    #pp-collage-v1.ppc-mug-mode [data-ratio],
    #pp-collage-v1.ppc-mug-mode [data-gap-colour],
    #pp-collage-v1.ppc-mug-mode [data-gap-background],
    #pp-collage-v1.ppc-mug-mode .ppc-v11-layouts {display:none!important}
  `;
  document.head.appendChild(ppMugStyle);
  if (ppMugMode) {
    const heading = root.querySelector('.ppc-head h2');
    if (heading) heading.textContent = 'Create Your Photo Collage Mug';
  }

  const ppCanvasHandle =
    "personalised-multi-photo-picture-of-your-choice-collage-canvas";
  const ppCanvasPath = "/products/" + ppCanvasHandle;
  const ppCanvasSizes = [
    { key: "8x12", widthIn: 8, heightIn: 12 },
    { key: "12x16", widthIn: 12, heightIn: 16 },
    { key: "16x20", widthIn: 16, heightIn: 20 },
    { key: "16x24", widthIn: 16, heightIn: 24 },
    { key: "20x30", widthIn: 20, heightIn: 30 },
    { key: "12x12", widthIn: 12, heightIn: 12 },
    { key: "16x16", widthIn: 16, heightIn: 16 },
    { key: "20x20", widthIn: 20, heightIn: 20 }
  ];

  let ppCanvasVariants = [];
  let selectedProduct = null;
  let ppProductLoading = false;
  // V14.9.35: per-canvas photo allowances (orientation-independent).
  const ppSizePhotoLimits = Object.freeze({
    "8x12":6, "12x16":15, "16x20":35, "16x24":40,
    "20x30":70, "12x12":15, "16x16":30, "20x20":40
  });
  function ppPhotoLimitFor(product = selectedProduct) {
    if (product?.profile === 'mug_wrap' || (ppMugMode && !product)) return 24;

    const a = Number(product?.widthIn), b = Number(product?.heightIn);
    const key = [Math.min(a,b), Math.max(a,b)].join("x");
    return ppSizePhotoLimits[key] ?? 100;
  }
  function ppCheckPhotoLimit(showMessage = true) {
    const max = ppPhotoLimitFor();
    if (state.photos.length <= 100) return true;
    const message = `For reliable printing, a collage can contain up to 100 photos. Please remove ${state.photos.length - 100} photos.`;
    if (showMessage) { status(message); alert(message); }
    return false;
  }


  function ppVariantSize(variant) {
    // Titles include A4/A3 and photo limits, so match only dimensions.
    const source = [variant.title, variant.option1, variant.option2,
      variant.option3].filter(Boolean).join(" ").toLowerCase();
    const match = source.match(/(\d+)\s*(?:x|×)\s*(\d+)\s*(?:["″]|inches|inch)?/i);
    if (!match) return null;
    const first = Number(match[1]);
    const second = Number(match[2]);
    return [Math.min(first, second), Math.max(first, second)].join("x");
  }

  function ppFormatMoney(pence) {
    const amount = Number(pence) / 100;
    return Number.isFinite(amount) ?
      new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" })
        .format(amount) : "Price unavailable";
  }

  async function ppLoadCanvasVariants() {
    if (ppMugMode) {
      const response = await fetch(ppMugPath + '.js', {
        credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}
      });
      if (!response.ok) throw new Error('Shopify mug product data unavailable.');
      const product = await response.json();
      if (!Array.isArray(product.variants)) throw new Error('No mug variants were returned.');
      ppCanvasVariants = product.variants.map(variant => ({
        key:'mug',widthIn:200/25.4,heightIn:95/25.4,variant
      }));
      if (!ppCanvasVariants.length) throw new Error('No mug variants were found.');
      return;
    }

    // Shopify's public product JSON supplies the CURRENT price and variant ID.
    const response = await fetch(ppCanvasPath + ".js", {
      credentials: "same-origin", cache: "no-store",
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error("Shopify product data unavailable (HTTP " + response.status + ")");
    const product = await response.json();
    if (!Array.isArray(product.variants)) throw new Error("Shopify returned no canvas variants.");
    ppCanvasVariants = ppCanvasSizes.map(size => {
      const key = [Math.min(size.widthIn, size.heightIn),
        Math.max(size.widthIn, size.heightIn)].join("x");
      const variant = product.variants.find(v => ppVariantSize(v) === key);
      return variant ? { ...size, variant } : null;
    }).filter(Boolean);
    if (!ppCanvasVariants.length) throw new Error("None of the eight canvas sizes could be matched to Shopify.");
  }

  // V10.5: Touch-friendly, accessible canvas cards instead of dropdown menus.
  // Keep the existing select elements as internal state, preserving the Shopify variant flow.
  const ppPickerStyles = document.createElement('style');
  ppPickerStyles.textContent = `
    #ppc-v5-product-picker, #ppc-v5-product-picker * { box-sizing:border-box; }
    #ppc-v5-product-picker .ppc-choice-dialog {background:#fff;color:#172338;width:min(610px,100%);max-height:min(92dvh,850px);overflow-y:auto;overscroll-behavior:contain;border-radius:22px;padding:24px;box-shadow:0 20px 65px rgba(0,0,0,.22)}
    #ppc-v5-product-picker .ppc-size-grid {display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin:10px 0 22px}
    #ppc-v5-product-picker .ppc-choice {appearance:none;text-align:left;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;gap:4px;min-height:79px;padding:13px;border:2px solid #dce5f2;border-radius:14px;background:#f3f7fd;color:#15345f;font:inherit;line-height:1.25;cursor:pointer;transition:background .12s,border-color .12s,box-shadow .12s;white-space:normal;overflow-wrap:anywhere}
    #ppc-v5-product-picker .ppc-choice[aria-pressed="true"] {border-color:#1265ee;background:#e9f2ff;box-shadow:0 0 0 2px rgba(18,101,238,.13)}
    #ppc-v5-product-picker .ppc-choice:focus-visible {outline:3px solid #338cff;outline-offset:2px}
    #ppc-v5-product-picker .ppc-choice:disabled {opacity:.42;cursor:not-allowed}
    #ppc-v5-product-picker .ppc-choice-name {font-size:17px;font-weight:800}
    #ppc-v5-product-picker .ppc-choice-detail {font-size:13px;color:#4f6485}
    #ppc-v5-product-picker .ppc-orient-grid {display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin:10px 0 16px}
    #ppc-v5-product-picker .ppc-orient-grid .ppc-choice {min-height:75px;align-items:center;text-align:center}
    #ppc-v5-product-picker .ppc-orient-icon {display:block;border:2px solid currentColor;border-radius:3px;width:32px;height:21px;margin-bottom:3px}
    #ppc-v5-product-picker .ppc-orient-icon.portrait {width:21px;height:32px}
    #ppc-v5-product-picker .ppc-square-grid {display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin:10px 0 16px}
    #ppc-v5-product-picker .ppc-square-choice {align-items:center;text-align:center;cursor:default;border-color:#1265ee;background:#e9f2ff;box-shadow:0 0 0 2px rgba(18,101,238,.13);min-height:100px}
    #ppc-v5-product-picker .ppc-orient-icon.square {width:28px;height:28px}
    #ppc-v5-product-picker .ppc-square-choice .ppc-choice-detail {color:#1265ee;font-weight:650}
    #ppc-v5-product-picker .ppc-picker-actions {display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;margin-top:18px}
    #ppc-v5-product-picker .ppc-picker-actions button {min-height:53px;padding:12px 18px;border-radius:12px;font-weight:750;font-size:16px;cursor:pointer}
    #ppc-v5-product-picker [data-ppc-v5-continue] {background:#1265ee;border:2px solid #1265ee;color:white}
    #ppc-v5-product-picker [data-ppc-v5-continue]:disabled {opacity:.5;cursor:not-allowed}
    #ppc-v5-product-picker [data-ppc-v5-cancel] {background:#fff;border:2px solid #dce5f2;color:#15345f}
    @media(max-width:600px) {
      #ppc-v5-product-picker {padding:10px!important;align-items:center!important}
      #ppc-v5-product-picker .ppc-choice-dialog {padding:19px 16px;border-radius:19px;max-height:calc(100dvh - 20px)}
      #ppc-v5-product-picker .ppc-size-grid {gap:9px}
      #ppc-v5-product-picker .ppc-choice {padding:10px;min-height:75px}
      #ppc-v5-product-picker .ppc-choice-name {font-size:16px}
      #ppc-v5-product-picker .ppc-picker-actions {grid-template-columns:1fr}
      #ppc-v5-product-picker .ppc-picker-actions button {width:100%}
    }
  `;
  // V14.9.40: Mobile cards keep all three lines INSIDE their touch target.
  ppPickerStyles.textContent += `
    #ppc-v5-product-picker .ppc-size-grid .ppc-choice {
      display:flex!important; flex-direction:column!important; align-items:flex-start!important;
      justify-content:center!important; height:auto!important; min-height:112px!important;
      padding:13px 12px!important; gap:5px!important; overflow:visible!important;
      line-height:1.24!important; position:relative!important;
    }
    #ppc-v5-product-picker .ppc-size-grid .ppc-choice > span {
      display:block!important; position:static!important; inset:auto!important;
      margin:0!important; transform:none!important; line-height:1.3!important;
      width:100%!important; max-width:100%!important; overflow-wrap:normal!important;
    }
    #ppc-v5-product-picker .ppc-size-grid .ppc-choice-name {font-size:16px!important;font-weight:800!important}
    #ppc-v5-product-picker .ppc-size-grid .ppc-choice-detail {font-size:14px!important}
    #ppc-v5-product-picker .ppc-size-grid .ppc-choice-photo-limit {font-size:12px!important}
    @media(max-width:600px){
      #ppc-v5-product-picker .ppc-size-grid {gap:12px!important;margin-bottom:18px!important}
      #ppc-v5-product-picker .ppc-size-grid .ppc-choice {min-height:112px!important;padding:12px 10px!important}
      #ppc-v5-product-picker .ppc-choice-dialog {overscroll-behavior:contain!important}
    }
  `;
  document.head.appendChild(ppPickerStyles);

  const ppPicker = document.createElement("div");
  ppPicker.id = "ppc-v5-product-picker";
  ppPicker.hidden = true;
  ppPicker.style.cssText = "position:fixed;inset:0;z-index:2147483641;background:rgba(10,18,32,.70);display:none;align-items:center;justify-content:center;padding:18px";
  ppPicker.innerHTML = `
    <div class="ppc-choice-dialog" role="dialog" aria-modal="true" aria-labelledby="ppc-choose-title">
      <h2 id="ppc-choose-title" style="margin:0 0 7px;font-size:26px">Choose Your Product Options</h2>
      <p style="margin:0 0 12px;color:#53657e">Choose your product options to start creating your collage.</p>
      <p data-ppc-canvas-loading role="status" aria-live="polite" style="font-size:13px;color:#53657e">Loading live Shopify sizes and prices...</p>
      <div role="group" aria-label="Product options">
        <div style="font-weight:800;margin:18px 0 4px">1. Choose your option</div>
        <div class="ppc-size-grid" data-ppc-size-buttons></div>
        <p data-ppc-v5-photo-allowance role="status" aria-live="polite" style="margin:10px 0 16px;color:#163b68;font-weight:700;font-size:14px"></p>
      </div>
      <select data-ppc-v5-size hidden aria-hidden="true" tabindex="-1"></select>
      <div data-ppc-v5-orientation-box>
        <div style="font-weight:800">2. Choose your orientation</div>
        <div class="ppc-orient-grid" role="group" aria-label="Canvas orientation">
          <button type="button" class="ppc-choice" data-ppc-orientation="landscape" aria-pressed="true"><span class="ppc-orient-icon" aria-hidden="true"></span><span class="ppc-choice-name">Landscape</span></button>
          <button type="button" class="ppc-choice" data-ppc-orientation="portrait" aria-pressed="false"><span class="ppc-orient-icon portrait" aria-hidden="true"></span><span class="ppc-choice-name">Portrait</span></button>
        </div>
      </div>
      <select data-ppc-v5-orientation hidden aria-hidden="true" tabindex="-1"><option value="landscape">Landscape</option><option value="portrait">Portrait</option></select>
      <div data-ppc-v5-square style="display:none">
        <div style="font-weight:800">2. Your canvas orientation</div>
        <div class="ppc-square-grid" role="group" aria-label="Canvas orientation">
          <div class="ppc-choice ppc-square-choice" role="status" aria-label="Square orientation selected">
            <span class="ppc-orient-icon square" aria-hidden="true"></span>
            <span class="ppc-choice-name">Square</span>
            <span class="ppc-choice-detail">✓ Automatically selected</span>
          </div>
        </div>
      </div>
      <div style="padding:13px 15px;border-radius:12px;background:#f1f6ff;display:flex;justify-content:space-between;align-items:center;gap:8px">
        <span style="font-weight:700">Your selection</span><strong data-ppc-v5-price style="font-size:22px"></strong>
      </div>
      <p style="font-size:12px;color:#62708a;margin:12px 0 0">Prices and availability update from Shopify.</p>
      <div class="ppc-picker-actions">
        <button type="button" data-ppc-v5-continue disabled>Upload My Photos →</button>
        <button type="button" data-ppc-v5-cancel>Cancel</button>
      </div>
    </div>`;
  // Customer-facing copy is product-neutral; the mug has a fixed landscape wrap.
  if (ppMugMode) {
    const optionPrompt = ppPicker.querySelector('[role="group"][aria-label="Product options"] > div');
    if (optionPrompt) optionPrompt.textContent = '1. Choose your mug style';
    const orientationGroup = ppPicker.querySelector('[data-ppc-v5-orientation-box]');
    if (orientationGroup) orientationGroup.hidden = true;
    const squareGroup = ppPicker.querySelector('[data-ppc-v5-square]');
    if (squareGroup) squareGroup.hidden = true;
    const loadingLabel = ppPicker.querySelector('[data-ppc-canvas-loading]');
    if (loadingLabel) loadingLabel.textContent = 'Loading available mug styles and prices...';
  } else {
    const optionPrompt = ppPicker.querySelector('[role="group"][aria-label="Product options"] > div');
    if (optionPrompt) optionPrompt.textContent = '1. Choose your canvas size';
  }
  document.body.appendChild(ppPicker);
  const ppSizeSelect = ppPicker.querySelector("[data-ppc-v5-size]");
  const ppOrientSelect = ppPicker.querySelector("[data-ppc-v5-orientation]");
  const ppOrientBox = ppPicker.querySelector("[data-ppc-v5-orientation-box]");
  const ppSquareNotice = ppPicker.querySelector("[data-ppc-v5-square]");
  const ppPrice = ppPicker.querySelector("[data-ppc-v5-price]");
  const ppLoading = ppPicker.querySelector("[data-ppc-canvas-loading]");
  const ppContinue = ppPicker.querySelector("[data-ppc-v5-continue]");
  const ppSizeButtons = ppPicker.querySelector("[data-ppc-size-buttons]");

  function ppSelectedVariant() {
    return ppCanvasVariants.find(v => String(v.variant.id) === ppSizeSelect.value);
  }
  function ppRefreshPicker() {
    const item = ppSelectedVariant();
    const square = !!item && item.widthIn === item.heightIn;
    ppOrientBox.style.display = ppMugMode || square ? "none" : "block";
    ppSquareNotice.style.display = !ppMugMode && square ? "block" : "none";
    ppPrice.textContent = item ? ppFormatMoney(item.variant.price) : "";
    const photoAllowance = ppPicker.querySelector('[data-ppc-v5-photo-allowance]');
    if (photoAllowance) photoAllowance.textContent = item
      ? (ppMugMode ? `Recommended: up to 24 photographs for your mug.` : `Recommended: ${ppPhotoLimitFor(item)} photos for this canvas size.`)
      : '';
    const available = !!item?.variant.available;
    ppContinue.disabled = !available;
    if (item && !available) ppLoading.textContent = ppMugMode ? "This mug style is currently unavailable." : "This canvas size is currently unavailable.";
    else if (item) ppLoading.textContent = "Great choice! You can change your selection before continuing.";
    for (const btn of ppSizeButtons.querySelectorAll('button[data-variant-id]')) {
      btn.setAttribute('aria-pressed', String(btn.dataset.variantId === ppSizeSelect.value));
    }
    for (const btn of ppPicker.querySelectorAll('[data-ppc-orientation]')) {
      btn.setAttribute('aria-pressed', String(btn.dataset.ppcOrientation === ppOrientSelect.value));
    }
  }
  ppSizeButtons.addEventListener('click', event => {
    const btn = event.target.closest('button[data-variant-id]');
    if (!btn || btn.disabled) return;
    ppSizeSelect.value = btn.dataset.variantId;
    ppRefreshPicker();
  });
  ppPicker.querySelectorAll('[data-ppc-orientation]').forEach(button => {
    button.addEventListener('click', () => {
      ppOrientSelect.value = button.dataset.ppcOrientation;
      ppRefreshPicker();
    });
  });

  async function ppShowPicker() {
    if (ppMugMode) {
      ppPicker.querySelector('#ppc-choose-title').textContent = 'Choose Your Mug';
      ppPicker.querySelector('[data-ppc-v5-orientation-box]').hidden = true;
      ppPicker.querySelector('[data-ppc-v5-orientation-box]').style.display='none';
      ppPicker.querySelector('[data-ppc-v5-square]').hidden = true;
      ppPicker.querySelector('[data-ppc-v5-square]').style.display='none';
      const heading = ppSizeButtons.parentElement.querySelector('div[style]');
      if (heading) heading.textContent='Select your mug style';
    }
    if (ppProductLoading) return;
    ppPicker.hidden = false;
    ppPicker.style.display = "flex";
    ppContinue.disabled = true;
    ppLoading.textContent = "Loading live Shopify sizes and prices...";
    ppSizeButtons.replaceChildren();
    ppProductLoading = true;
    try {
      await ppLoadCanvasVariants();
      ppSizeSelect.replaceChildren();
      for (const item of ppCanvasVariants) {
        const variantId = String(item.variant.id);
        const option = document.createElement("option");
        option.value = variantId;
        option.textContent = ppMugMode ? (item.variant.title || "Mug") : item.widthIn + " × " + item.heightIn + '"';
        ppSizeSelect.appendChild(option);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ppc-choice';
        btn.dataset.variantId = variantId;
        btn.setAttribute('aria-pressed', 'false');
        btn.disabled = !item.variant.available;
        const name = document.createElement('span');
        name.className = 'ppc-choice-name';
        name.textContent = item.variant.option1 || item.variant.title || (item.widthIn + ' × ' + item.heightIn + '"');
        const detail = document.createElement('span');
        detail.className = 'ppc-choice-detail';
        detail.textContent = item.variant.available ? ppFormatMoney(item.variant.price) : 'Unavailable';
        const allowance = document.createElement('span');
        allowance.className = 'ppc-choice-photo-limit';
        allowance.textContent = ppMugMode ? "20 × 9.5 cm print area" : `Up to ${ppPhotoLimitFor(item)} photos`;
        allowance.style.cssText = 'display:block;margin-top:4px;font-size:12px;font-weight:700;color:#173b67';
        btn.append(name, detail, allowance);
        ppSizeButtons.appendChild(btn);
      }
      const firstAvailable = ppCanvasVariants.find(item => item.variant.available);
      if (firstAvailable) ppSizeSelect.value = String(firstAvailable.variant.id);
      // Product-page handoff: preselect the ACTUAL Shopify variant chosen
      // before the customer clicked Add Your Photos. Ignore unknown IDs.
      const passedVariantId = new URLSearchParams(window.location.search).get(ppMugMode ? 'mug_variant' : 'canvas_variant');
      if (passedVariantId) {
        const matched = ppCanvasVariants.find(item =>
          String(item.variant.id) === String(passedVariantId) && item.variant.available
        );
        if (matched) ppSizeSelect.value = String(matched.variant.id);
      }
      ppRefreshPicker();
      ppSizeButtons.querySelector('button:not(:disabled)')?.focus();
    } catch (error) {
      ppLoading.textContent = "Could not load canvas sizes: " + error.message;
      ppPrice.textContent = "";
      ppSizeSelect.replaceChildren();
      ppSizeButtons.replaceChildren();
    } finally {
      ppProductLoading = false;
    }
  }
  function ppHidePicker() {
    ppPicker.hidden = true;
    ppPicker.style.display = "none";
  }

  // Extend the existing ratio select rather than replacing its HTML.
  // These extra ratios are needed for 4:5 and for rotating rectangular sizes.
  function ppSetRatio(value) {
    const element = $("[data-ratio]");
    if (!element) return;
    if (![...element.options].some(option => option.value === value)) {
      const option = document.createElement("option");
      option.value = value;
      option.textContent = value;
      element.appendChild(option);
    }
    element.value = value;
  }
  function ppCanvasRatio(product) {
    if (!product) return null;
    if (product.profile === "mug_wrap") return "40/19";
    const w = Number(product.widthIn);
    const h = Number(product.heightIn);
    if (!w || !h) return null;
    if (product.orientation === "square" || w === h) return "1/1";
    const wide = Math.max(w, h);
    const narrow = Math.min(w, h);
    const gcd = (a, b) => b ? gcd(b, a % b) : a;
    const d = gcd(wide, narrow);
    return product.orientation === "portrait" ?
      (narrow / d) + "/" + (wide / d) :
      (wide / d) + "/" + (narrow / d);
  }

  const ppProductSummary = document.createElement("div");
  ppProductSummary.style.cssText =
    "background:#f1f5f9;border:1px solid #cbd5e1;border-radius:9px;" +
    "padding:12px;margin:0 0 12px;display:none;font-weight:600";
  const ppEditorPanel = $("[data-editor]")?.querySelector(".ppc-panel");
  // V11.2.1: Keep summary data internally; do not show a redundant canvas price panel.
  // if (ppEditorPanel) ppEditorPanel.prepend(ppProductSummary);
  function ppUpdateProductSummary() {
    const ratio = $("[data-ratio]");
    if (selectedProduct) {
      ppSetRatio(ppCanvasRatio(selectedProduct));
      if (ratio) ratio.disabled = true;
      ppProductSummary.textContent =
        (selectedProduct.profile === "mug_wrap" ? "Photo Collage Mug — " : "Canvas Print — ") + selectedProduct.sizeLabel + " — " +
        (selectedProduct.orientation === "square" ? "Square" :
          selectedProduct.orientation === "portrait" ? "Portrait" : "Landscape") +
        (selectedProduct.displayPrice ? " — " + selectedProduct.displayPrice : "") +
        "";
      ppProductSummary.style.display = "none";
    } else {
      ppProductSummary.textContent = "";
      ppProductSummary.style.display = "none";
      if (ratio) ratio.disabled = false;
    }
  }

  // Saved collage: editable order size shown above the editor heading.
  // This is deliberately separate from the new-collage picker: no upload,
  // no clearing of the saved photos, and the selected Shopify variant is real.
  let ppSavedSizeNotice = null;
  function ppRemoveSavedSizeNotice() {
    ppSavedSizeNotice?.remove();
    ppSavedSizeNotice = null;
  }
  function ppRenderSavedSizeNotice() {
    if (!ppSavedSizeNotice) {
      ppSavedSizeNotice = document.createElement("section");
      ppSavedSizeNotice.id = "ppc-saved-order-size";
      ppSavedSizeNotice.style.cssText =
        "box-sizing:border-box;width:100%;max-width:900px;margin:12px auto 22px;" +
        "padding:17px 19px;background:#ecf5ff;border:1px solid #b4d2fb;" +
        "border-radius:14px;color:#15345f;display:flex;align-items:center;" +
        "justify-content:space-between;flex-wrap:wrap;gap:12px;";
      const textWrap = document.createElement("div");
      textWrap.style.cssText = "flex:1 1 220px;min-width:0;line-height:1.55";
      const heading = document.createElement("strong");
      heading.setAttribute("data-ppc-order-size-heading", "");
      heading.style.cssText = "display:block;font-size:16px;";
      const detail = document.createElement("span");
      detail.setAttribute("data-ppc-order-size-detail", "");
      detail.style.cssText = "display:block;font-size:13px;margin-top:3px;";
      textWrap.append(heading, detail);
      const button = document.createElement("button");
      button.type = "button";
      button.textContent = "Change Canvas Size";
      button.style.cssText =
        "min-height:44px;padding:11px 16px;border:0;border-radius:10px;" +
        "background:#155cff;color:#fff;font:inherit;font-weight:800;" +
        "cursor:pointer;white-space:normal;";
      button.addEventListener("click", ppChangeSavedCanvasSize);
      ppSavedSizeNotice.append(textWrap, button);
    }
    if (selectedProduct?.profile === "mug_wrap") { ppRemoveSavedSizeNotice(); return; }
    const size = selectedProduct?.sizeLabel || "Not selected";
    ppSavedSizeNotice.querySelector("[data-ppc-order-size-heading]").textContent =
      "Canvas size for this order: " + size;
    ppSavedSizeNotice.querySelector("[data-ppc-order-size-detail]").textContent =
      "Choose another size if you wish. Your photos and collage design will stay in place.";
    // Display the size selector immediately beneath the collage heading/help area.
    const collageHeader = root.querySelector(".ppc-head");
    if (collageHeader) {
      collageHeader.after(ppSavedSizeNotice);
      if (ppEditInstructions) ppSavedSizeNotice.after(ppEditInstructions);
    } else {
      root.prepend(ppSavedSizeNotice);
    }
  }
  async function ppChangeSavedCanvasSize() {
    const oldSize = selectedProduct;
    const overlay = document.createElement("div");
    overlay.style.cssText =
      "position:fixed;inset:0;z-index:2147483645;background:rgba(10,18,32,.72);" +
      "display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;";
    const panel = document.createElement("div");
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
    panel.setAttribute("aria-label", "Change canvas size for this order");
    panel.style.cssText =
      "width:min(510px,100%);max-height:90dvh;overflow:auto;background:#fff;" +
      "color:#172338;border-radius:18px;padding:24px;box-sizing:border-box;";
    const title = document.createElement("h2");
    title.textContent = "Change Canvas Size";
    title.style.cssText = "margin:0 0 8px;font-size:24px;";
    const description = document.createElement("p");
    description.textContent = "Choose the size you want to order. Your photos will be kept, but check their cropping after changing proportions.";
    description.style.cssText = "margin:0 0 18px;line-height:1.55;font-size:14px;";
    const sizeLabel = document.createElement("label");
    sizeLabel.textContent = "Canvas size";
    sizeLabel.style.cssText = "display:block;font-weight:800;margin-bottom:8px;";
    const select = document.createElement("select");
    select.style.cssText =
      "display:block;width:100%;min-height:48px;border:1px solid #cbd5e1;" +
      "border-radius:10px;padding:10px;background:#fff;color:#172338;font:inherit;";
    sizeLabel.appendChild(select);
    const orientationLabel = document.createElement("label");
    orientationLabel.textContent = "Orientation";
    orientationLabel.style.cssText = "display:block;font-weight:800;margin:16px 0 8px;";
    const orientationSelect = document.createElement("select");
    orientationSelect.style.cssText = select.style.cssText;
    for (const [value, label] of [["landscape", "Landscape"], ["portrait", "Portrait"]]) {
      const opt = document.createElement("option");
      opt.value = value;
      opt.textContent = label;
      orientationSelect.appendChild(opt);
    }
    orientationLabel.appendChild(orientationSelect);
    const price = document.createElement("p");
    price.style.cssText = "font-weight:800;color:#155cff;margin:16px 0;";
    const error = document.createElement("p");
    error.setAttribute("role", "status");
    error.style.cssText = "font-size:13px;color:#a32626;";
    const actions = document.createElement("div");
    actions.style.cssText = "display:flex;flex-wrap:wrap;gap:10px;";
    const save = document.createElement("button");
    save.type = "button";
    save.textContent = "Use This Canvas Size";
    const cancel = document.createElement("button");
    cancel.type = "button";
    cancel.textContent = "Cancel";
    for (const b of [save, cancel]) b.style.cssText =
      "flex:1 1 175px;min-height:46px;padding:11px;border-radius:10px;" +
      "border:1px solid #cbd5e1;font:inherit;font-weight:800;cursor:pointer;";
    save.style.background = "#155cff";
    save.style.color = "#fff";
    cancel.style.background = "#fff";
    actions.append(save, cancel);
    panel.append(title, description, sizeLabel, orientationLabel, price, error, actions);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    const close = () => overlay.remove();
    cancel.addEventListener("click", close);
    overlay.addEventListener("click", e => { if (e.target === overlay) close(); });
    overlay.addEventListener("keydown", e => {
      if (e.key === "Escape") { e.preventDefault(); close(); }
    });
    const refresh = () => {
      const item = ppCanvasVariants.find(v => String(v.variant.id) === select.value);
      const square = item && item.widthIn === item.heightIn;
      orientationLabel.hidden = !!square;
      if (square) orientationSelect.value = "landscape";
      price.textContent = item ? "Shopify price: " + ppFormatMoney(item.variant.price) : "";
      save.disabled = !item || !item.variant.available;
    };
    save.disabled = true;
    error.textContent = "Loading current Shopify sizes...";
    try {
      await ppLoadCanvasVariants();
      if (!overlay.isConnected) return;
      select.replaceChildren();
      for (const item of ppCanvasVariants) {
        const option = document.createElement("option");
        option.value = String(item.variant.id);
        option.textContent = item.widthIn + " × " + item.heightIn + '" — ' +
          (item.variant.available ? ppFormatMoney(item.variant.price) : "Unavailable");
        option.disabled = !item.variant.available;
        select.appendChild(option);
      }
      const previousMatch = ppCanvasVariants.find(v =>
        String(v.variant.id) === String(oldSize?.variantId) && v.variant.available
      );
      const defaultItem = previousMatch || ppCanvasVariants.find(v => v.variant.available);
      if (!defaultItem) throw new Error("No canvas sizes are currently available.");
      select.value = String(defaultItem.variant.id);
      orientationSelect.value = oldSize?.orientation === "portrait" ? "portrait" : "landscape";
      select.addEventListener("change", refresh);
      refresh();
      error.textContent = "";
      save.addEventListener("click", () => {
        const item = ppCanvasVariants.find(v => String(v.variant.id) === select.value);
        if (!item || !item.variant.available) return;
        const square = item.widthIn === item.heightIn;
        selectedProduct = {
          ...(selectedProduct || {}), profile: "canvas_3_2", label: "Canvas Print",
          handle: ppCanvasHandle, variantId: String(item.variant.id),
          widthIn: item.widthIn, heightIn: item.heightIn,
          sizeLabel: item.widthIn + "x" + item.heightIn + " inches",
          orientation: square ? "square" : orientationSelect.value,
          displayPrice: ppFormatMoney(item.variant.price)
        };
        // Never overwrite the original saved collage with a different size.
        // The order uses the updated variant; the design remains editable.
        if (String(oldSize?.variantId) !== String(selectedProduct.variantId) ||
            oldSize?.orientation !== selectedProduct.orientation) {
          savedDesignId = null;
          savedDesignName = "";
        }
        ppUpdateProductSummary();
        ppPhotoLimitNoticeUpdate();
        ppRenderSavedSizeNotice();
        safeRender();
        status("Canvas changed to " + selectedProduct.sizeLabel + ". Check your photo cropping before adding to basket.");
        close();
      });
      select.focus();
    } catch (e) {
      error.textContent = "Unable to load Shopify canvas sizes: " + e.message;
    }
  }

  ppPicker.querySelector("[data-ppc-v5-cancel]").addEventListener("click", ppHidePicker);
  ppPicker.addEventListener("click", event => {
    if (event.target === ppPicker) ppHidePicker();
  });
  let ppAwaitingInitialPhotoSelection = false;
  ppContinue.addEventListener("click", () => {
    const item = ppSelectedVariant();
    if (!item || !item.variant.available) return;
    const square = item.widthIn === item.heightIn;
    selectedProduct = {
      profile: ppMugMode ? "mug_wrap" : "canvas_3_2",
      label: ppMugMode ? "Photo Collage Mug" : "Canvas Print",
      handle: ppMugMode ? ppMugHandle : ppCanvasHandle,
      variantId: String(item.variant.id),
      sizeLabel: ppMugMode ? (item.variant.title || 'Mug') : item.widthIn + "x" + item.heightIn + " inches",
      widthIn: item.widthIn, heightIn: item.heightIn,
      orientation: ppMugMode ? 'landscape' : (square ? "square" : ppOrientSelect.value),
      displayPrice: ppFormatMoney(item.variant.price)
    };
    savedDesignId = null;
    savedDesignName = "";
    ppRemoveSavedSizeNotice();
    ppUpdateProductSummary();
    ppPhotoLimitNoticeUpdate();
    // Open the native picker FIRST, directly from the customer click. This keeps
    // iOS Safari user activation intact and avoids showing an empty review step.
    // The file change handler reveals review only after photographs are chosen.
    const photoInput = root.querySelector('[data-upload]');
    if (photoInput && !photoInput.disabled) {
      ppAwaitingInitialPhotoSelection = true;
      try { photoInput.click(); }
      catch (error) {
        ppAwaitingInitialPhotoSelection = false;
        ppLoading.textContent = 'Please try Upload My Photos again.';
        console.warn('Could not open photograph picker', error);
      }
    } else {
      ppLoading.textContent = 'Photo upload is unavailable. Please refresh and try again.';
    }
  });

  // Open product selection before starting a new design.
  // The My Designs button still works independently.
  root.addEventListener("click", event => {
    const start = event.target.closest('[data-action="start"]');
    if (start && root.contains(start)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      ppShowPicker();
    }
  }, true);

  function buildSavedDesign(name) {
    const options = collageSettings();

    return {
      title: name,
      product: selectedProduct ? { ...selectedProduct } : null,
      shape: collageShape(),
      ratio: options.ratio,

      text: {
        title: options.title,
        subtitle: options.subtitle,
        position: options.position,
        size: Number(options.textSize),
        width: Number(options.textWidth)
      },

      photoIds: state.photos.map(photo => photo.remoteId),

      layout: state.photos.map(photo => ({
        photoId: photo.remoteId,
        rotation: photo.rotation || 0,
        crop: photo.userCropRect
          ? { ...photo.userCropRect }
          : null,
        trim: photo.trimRect
          ? { ...photo.trimRect }
          : null,
        adjustments: ppNormalAdjust(photo.adjustments),
        faceBounds: photo.userCropRect ? null : (photo.ppFaceBounds || null)
      })),

      options
    };
  }

  // =====================================================
  // SAVING OVERLAY
  // =====================================================

  const collageSavingOverlay = document.createElement("div");

  collageSavingOverlay.id = "ppc-saving-overlay";
  collageSavingOverlay.hidden = true;

  collageSavingOverlay.style.cssText = `
    position:fixed;
    inset:0;
    z-index:2147483647;
    background:rgba(10,18,32,.72);
    display:none;
    align-items:center;
    justify-content:center;
    padding:20px;
  `;

  collageSavingOverlay.innerHTML = `
    <div role="status" aria-live="polite"
      style="
        width:min(420px,100%);
        background:white;
        border-radius:18px;
        padding:35px 25px;
        text-align:center;
        box-shadow:0 20px 70px rgba(0,0,0,.25);
        color:#172033;
      ">
      <div style="
        width:54px;
        height:54px;
        border:5px solid #e5e7eb;
        border-top-color:#075bd8;
        border-radius:50%;
        animation:ppc-saving-spin .8s linear infinite;
        margin:0 auto 20px;
      "></div>

      <h2 style="margin:0 0 12px;font-size:23px;">
        Finishing your collage
      </h2>

      <p data-ppc-saving-message
        style="margin:0 0 12px;font-size:15px;">
        Preparing your photographs...
      </p>

      <p style="font-size:13px;color:#64748b;margin:0;">
        Please keep this page open until saving finishes.
      </p>
    </div>
  `;

  const collageSpinnerStyle = document.createElement("style");

  collageSpinnerStyle.textContent = `
    @keyframes ppc-saving-spin {
      to {
        transform:rotate(360deg);
      }
    }
  `;

  document.head.appendChild(collageSpinnerStyle);
  document.body.appendChild(collageSavingOverlay);

  function showSavingOverlay(message) {
    collageSavingOverlay.style.display = "flex";
    collageSavingOverlay.hidden = false;
    updateSavingOverlay(message);
  }

  function updateSavingOverlay(message) {
    const el = collageSavingOverlay.querySelector(
      "[data-ppc-saving-message]"
    );

    if (el) {
      el.textContent = message;
    }
  }

  function hideSavingOverlay() {
    collageSavingOverlay.style.display = "none";
    collageSavingOverlay.hidden = true;
  }

  // =====================================================
  // SAVE COLLAGE TO POSTGRESQL + R2
  // =====================================================

  // In-session thumbnail reuse is safe only when the same saved design and
  // serialized payload match a previously confirmed thumbnail upload.
  let ppLastThumbnailSignature=null;
  let ppLastThumbnailDesignId=null;

  async function saveMyCollage(saveAsNew = false, options = {}) {
    const forCart = Boolean(options.forCart);
    if (savingDesign) return;
    if (!ppCheckPhotoLimit()) return;

    if (state.uploadBusy) {
      alert("Please wait for your photographs to finish loading.");
      return;
    }

    if (!state.photos.length) {
      alert("Please add some photographs before saving.");
      return;
    }

    if (state.reviewMode) {
      alert("Please finish reviewing your photographs first.");
      return;
    }

    const defaultName =
      savedDesignName || "My Photo Collage";

    const name = forCart ? defaultName : await ppDialog({heading:"Save your collage", message:"Choose a name so you can find it again in My Designs.", initial:defaultName,ask:true});

    if (name === null) return;

    const cleanedName = name.trim();

    if (!cleanedName || cleanedName.length > 120) {
      alert("Please enter a name of up to 120 characters.");
      return;
    }

    savingDesign = true;
    showSavingOverlay("Preparing your photographs...");

    const saveButtons = [
      ...root.querySelectorAll("[data-ppc-save-design]")
    ];

    saveButtons.forEach(button => {
      button.disabled = true;
      button.textContent = "Saving...";
    });

    try {
      // V6.3: bounded upload pipeline. As soon as an original is verified,
      // start preparing/uploading its private preview while other original
      // photos continue uploading. Keep full-resolution originals untouched.
      const photoSnapshot = [...state.photos];
      const uploadConcurrency = ppIsConstrainedMobile ? 2 : 4;
      let nextPhotoIndex = 0;
      let originalsDone = 0;
      let previewsDone = 0;
      let firstUploadError = null;

      async function uploadWorker() {
        while (nextPhotoIndex < photoSnapshot.length && !firstUploadError) {
          const photo = photoSnapshot[nextPhotoIndex++];
          try {
            await uploadOriginalPhoto(photo);
            originalsDone++;
            updateSavingOverlay(
              "Uploaded " + originalsDone + " of " + photoSnapshot.length +
              " original photographs..."
            );
            status("Uploaded original photographs: " + originalsDone +
              " of " + photoSnapshot.length);
          } catch (error) {
            firstUploadError = firstUploadError || error;
            return;
          }

          // Small previews are optional. A preview failure should never
          // prevent a customer's original photo or collage being saved.
          try {
            await ensurePrivateEditingPreview(photo);
          } catch (error) {
            console.warn("Editing preview skipped:", photo.name, error);
          } finally {
            previewsDone++;
            updateSavingOverlay(
              "Prepared " + previewsDone + " of " + photoSnapshot.length +
              " photographs..."
            );
          }
        }
      }

      await Promise.all(Array.from(
        { length: Math.min(uploadConcurrency, photoSnapshot.length) },
        () => uploadWorker()
      ));
      if (firstUploadError) throw firstUploadError;

      const payload = buildSavedDesign(cleanedName);

      status("Saving your collage to My Designs...");

      updateSavingOverlay(
        "Photographs uploaded! Saving your collage..."
      );

      const updatingExisting = Boolean(savedDesignId) && !saveAsNew;
      const path = updatingExisting
        ? "/designs/" + encodeURIComponent(savedDesignId)
        : "/designs";

      const result = await collageRequest(path, {
        method: updatingExisting ? "PUT" : "POST",
        body: JSON.stringify(payload)
      });

      savedDesignId = result.id || savedDesignId;
      savedDesignName = cleanedName;

      // Reuse an already confirmed thumbnail for an unchanged design.
      // Do not skip when Save as New created a different design ID.
      const thumbSignature=JSON.stringify(payload);
      const thumbnailIsCurrent=ppLastThumbnailDesignId===savedDesignId &&
        ppLastThumbnailSignature===thumbSignature;
      if(!thumbnailIsCurrent){
        try {
          updateSavingOverlay("Finishing touches…");
          await uploadFinishedCollageThumbnail(savedDesignId);
          ppLastThumbnailDesignId=savedDesignId;
          ppLastThumbnailSignature=thumbSignature;
        } catch (error) {
          ppLastThumbnailSignature=null;
          console.warn("Finished collage thumbnail unavailable:", error);
        }
      }

      status(
        "Saved successfully! Your collage is in My Designs."
      );

      // Close the loading screen before showing confirmation.
      hideSavingOverlay();

      if (!forCart) alert(
        "Your collage has been saved!\n\n" +
        "Name: " + cleanedName + "\n\n" +
        "You can reopen it from My Designs."
      );

      return savedDesignId;

    } catch (error) {
      console.error("Collage save failed:", error);

      status("Your collage could not be saved.");

      hideSavingOverlay();

      if (forCart) throw error;
      alert(
        "Unable to save your collage:\n\n" +
        error.message +
        "\n\nYour current collage is still open. " +
        "Please don't close the page until saving succeeds."
      );

    } finally {
      hideSavingOverlay();
      savingDesign = false;

      saveButtons.forEach(button => {
        button.disabled = false;
        button.textContent = button === saveAsNewButton
          ? "Save as New Collage" : "Save My Collage";
      });
    }
  }

  // =====================================================
  // LOAD ORIGINAL PHOTOGRAPHS FROM CLOUDFLARE R2
  // =====================================================

  async function restorePhotoFromR2(item) {
    // Prefer a small, private editing preview. Older saved collages
    // automatically fall back to their full-resolution original.
    let blob;
    let usedPrivatePreview = false;
    try {
      const preview = await collageRequest(
        "/previews/" + encodeURIComponent(item.photoId)
      );
      if (preview.available && preview.url) {
        const response = await fetch(preview.url, { cache: "no-store" });
        if (!response.ok) throw new Error("Preview HTTP " + response.status);
        blob = await response.blob();
        usedPrivatePreview = true;
      }
    } catch (error) {
      console.warn("Fast preview unavailable; using original:", error);
    }

    if (!blob) {
      const original = await collageRequest(
        "/photos/" + encodeURIComponent(item.photoId)
      );
      if (!original.url) throw new Error("Saved photograph not available.");
      const response = await fetch(original.url, { cache: "no-store" });
      if (!response.ok) throw new Error("Original photo HTTP " + response.status);
      blob = await response.blob();
    }
    const url = URL.createObjectURL(blob);

    try {
      const image = await loadImage(url);

      const photo = {
        name: "Saved photograph",
        file: null,
        remoteId: item.photoId,
        url,
        privatePreviewUploaded: usedPrivatePreview,
        fingerprint: item.photoId,
        rotation: item.rotation || 0,
        aspect: image.naturalWidth / image.naturalHeight,
        originalWidth: usedPrivatePreview ? null : image.naturalWidth,
        originalHeight: usedPrivatePreview ? null : image.naturalHeight,
        qualityDimensionsVerified: !usedPrivatePreview,
        previewUrl: null,
        userCropUrl: null,
        userCropRect: null,
        trimRect: item.trim || null,
        adjustments: ppNormalAdjust(item.adjustments),
        ppFaceBounds: item.faceBounds || null,
        ppFaceScanned: Boolean(item.faceBounds),
        sequence: 0
      };

      // Rebuild preview without unnecessarily rendering
      // the entire collage after every photo download.
      await rebuildPreview(photo, false);

      if (item.crop) {
        const croppedImage = await loadImage(baseSrc(photo));
        const c = item.crop;

        const sx = croppedImage.naturalWidth * c.x;
        const sy = croppedImage.naturalHeight * c.y;
        const sw = croppedImage.naturalWidth * c.w;
        const sh = croppedImage.naturalHeight * c.h;

        const scale = Math.min(
          1,
          2400 / Math.max(sw, sh)
        );

        const canvas = document.createElement("canvas");

        canvas.width = Math.max(
          1,
          Math.round(sw * scale)
        );

        canvas.height = Math.max(
          1,
          Math.round(sh * scale)
        );

        canvas.getContext("2d").drawImage(
          croppedImage,
          sx, sy, sw, sh,
          0, 0, canvas.width, canvas.height
        );

        photo.userCropUrl = await canvasURL(canvas);
        photo.userCropRect = { ...item.crop };
        photo.aspect = canvas.width / canvas.height;
      }

      return photo;

    } catch (error) {
      URL.revokeObjectURL(url);
      throw error;
    }
  }

  // =====================================================
  // OPEN AND CONTINUE EDITING AN EXISTING COLLAGE
  // =====================================================


  async function openSavedCollage(id) {
    if (savingDesign) return;


    if (
      state.photos.length &&
      !await ppDialog({heading:"Open saved collage?",message:"Your current work will be replaced. Save it first if you want to keep it."})
    ) {
      return;
    }

    const previousPhotos = state.photos;
    const previousOriginal = state.original;
    const previousSeen = state.seen;
    const previousId = savedDesignId;
    const previousName = savedDesignName;
    const previousSettings = collageSettings();
    const previousProduct = selectedProduct;


    const loadedPhotos = [];

    showSavingOverlay("Connecting to your saved collage...");

    const loadingHeading = collageSavingOverlay.querySelector("h2");
    if (loadingHeading) {
      loadingHeading.textContent = "Opening your collage";
    }

    try {
      status("Opening your saved collage...");


      const design = await collageRequest(
        "/designs/" + encodeURIComponent(id)
      );

      const payload = design.payload || {};
      const savedProfile = String(payload.product?.profile || '');
      const savedHandle = String(payload.product?.handle || '');
      const savedIsMug = savedProfile === 'mug_wrap' || savedHandle === ppMugHandle;
      // Check BEFORE loading photographs or changing editor state.
      // Never allow a design to switch a mug editor into canvas mode, or vice versa.
      if (ppMugMode
          ? !(savedProfile === 'mug_wrap' && (!savedHandle || savedHandle === ppMugHandle))
          : savedIsMug) {
        throw new Error('This collage belongs to a different product. Return to that product to open it.');
      }
      const layout = payload.layout || [];

      // Load new photos separately, so the current collage
      // remains available if reopening fails.
    
      // Faster loading: process up to 4 photos together.
      // Keep the original photo order and editing settings.

      const batchSize = 4;
      const restoredPhotos = new Array(layout.length);
      let completedCount = 0;

      for (
        let start = 0;
        start < layout.length;
        start += batchSize
      ) {
        const end = Math.min(
          start + batchSize,
          layout.length
        );

        const batch = layout.slice(start, end);

        const results = await Promise.allSettled(
          batch.map(async (item, index) => {
            const photo = await restorePhotoFromR2(item);

            // Store the photo as soon as it finishes so
            // we can clean it up if another upload fails.
            const position = start + index;
            restoredPhotos[position] = photo;
            loadedPhotos.push(photo);

            completedCount++;

            updateSavingOverlay(
              "Loaded " + completedCount +
              " of " + layout.length + " photographs..."
            );

            status(
              "Loading saved photographs: " +
              completedCount + " of " + layout.length
            );

            return photo;
          })
        );

        const failed = results.find(
          result => result.status === "rejected"
        );

        if (failed) {
          throw failed.reason;
        }
      }

      // All photographs loaded successfully.
      // Replace the temporary list with their
      // correct saved positions.
      loadedPhotos.length = 0;
      loadedPhotos.push(...restoredPhotos);

      updateSavingOverlay(
        "All photographs loaded. Preparing your collage..."
      );


      ppClearHistory();
      state.photos = loadedPhotos;
      state.original = [...loadedPhotos];
      v11Arrangement = "balanced";
      v11RefreshButtons();

      state.seen = new Set(
        loadedPhotos.map(photo => photo.fingerprint)
      );

      const options = payload.options || {
        ratio: payload.ratio,
        title: payload.text?.title || "",
        subtitle: payload.text?.subtitle || "",
        position: payload.text?.position || "middle",
        textSize: payload.text?.size || 28,
        textWidth: payload.text?.width || 40
      };

      if (options.ratio) ppSetRatio(String(options.ratio));
      restoreCollageSettings(options);
      selectedProduct = payload.product || null;
      // Restore mug mode only when reached through a mug product link.
      // Do not silently convert a customer's saved canvas into a mug.
      if (ppMugMode && selectedProduct?.profile !== 'mug_wrap') {
        throw new Error('This saved design is for a different product. Please open its original product to edit it.');
      }
      ppUpdateProductSummary();
      ppRenderSavedSizeNotice();

      savedDesignId = design.id;
      savedDesignName = design.title || payload.title || "";

      state.reviewMode = false;
      root.classList.remove("ppc-review-mode");

      $("[data-start]").hidden = true;
      $("[data-editor]").hidden = false;
      $("[data-orientation]").hidden = true;
      $("[data-crop-review]").hidden = true;

      safeRender();
      ppShowTouchTip();

      for (const photo of previousPhotos) {
        release(photo);
      }

      status(
        "Loaded: " + savedDesignName +
        ". You can continue editing."
      );

      hideMyDesigns();

    } catch (error) {
      for (const photo of loadedPhotos) {
        release(photo);
      }

      state.photos = previousPhotos;
      state.original = previousOriginal;
      state.seen = previousSeen;

      savedDesignId = previousId;
      savedDesignName = previousName;

      restoreCollageSettings(previousSettings);
      selectedProduct = previousProduct;
      ppUpdateProductSummary();


      console.error("Unable to open design:", error);

      alert(
        "Unable to open this collage:\n\n" +
        error.message
      );
    } finally {
      hideSavingOverlay();

      const loadingHeading =
        collageSavingOverlay.querySelector("h2");

      if (loadingHeading) {
        loadingHeading.textContent = "Saving your collage";
      }
    }
  }


  // =====================================================
  // MY DESIGNS POP-UP
  // =====================================================

  const myDesignsPanel = make(
    "div",
    "ppc-my-designs-panel"
  );

  myDesignsPanel.hidden = true;

  myDesignsPanel.style.cssText = [
    "position:fixed",
    "top:6vh",
    "left:50%",
    "transform:translateX(-50%)",
    "width:min(650px,calc(100vw - 30px))",
    "max-height:88vh",
    "overflow-y:auto",
    "z-index:2147483640",
    "padding:24px",
    "border:1px solid #ddd",
    "border-radius:16px",
    "background:#fff",
    "color:#171717",
    "box-shadow:0 20px 70px rgba(0,0,0,.3)",
    "box-sizing:border-box"
  ].join(";");

  function hideMyDesigns() {
    myDesignsVersion++;
    myDesignsPanel.hidden = true;
    myDesignsPanel.style.display = "none";
  }

  document.addEventListener("keydown", event => {
    if (event.key === "Escape" && !myDesignsPanel.hidden &&
        myDesignsPanel.style.display !== "none") {
      event.preventDefault();
      hideMyDesigns();
    }
  });

  function focusMyDesigns() {
    myDesignsPanel.hidden = false;
    myDesignsPanel.style.display = "block";
    myDesignsPanel.scrollTop = 0;
  }

  // My Designs V3: manage existing records with the already-installed
  // GET / PUT / POST / DELETE design endpoints. No backend changes.
  let myDesignsVersion = 0;
  const myDesignThumbUrls = new Set();

  function clearMyDesignThumbs() {
    for (const url of myDesignThumbUrls) URL.revokeObjectURL(url);
    myDesignThumbUrls.clear();
  }

  async function getSavedDesign(id) {
    return collageRequest("/designs/" + encodeURIComponent(id));
  }

  function designActionButton(text, handler, danger = false) {
    const button = makeSaveButton(text, async () => {
      if (button.disabled) return;
      button.disabled = true;
      try { await handler(); }
      catch (error) {
        console.error("My Designs action error", error);
        alert("Unable to complete that action: " + error.message);
      } finally { button.disabled = false; }
    });
    button.style.cssText += ";margin:3px;padding:9px 12px;font-size:13px;";
    if (danger) button.style.background = "#a32525";
    return button;
  }

  // One complete finished-design thumbnail, not four zoomed-in photos.
  async function addFinishedDesignThumbnail(frame, designId, version) {
    try {
      const result = await collageRequest(
        "/design-thumbnails/" + encodeURIComponent(designId)
      );
      if (version !== myDesignsVersion || !frame.isConnected) return;
      if (!result.available || !result.url) {
        frame.textContent = "Open and save this collage to add its thumbnail";
        return;
      }
      const img = make("img");
      img.alt = "Complete saved collage";
      img.loading = "lazy";
      img.style.cssText = "display:block;max-width:100%;max-height:100%;width:100%;height:100%;object-fit:contain;";
      img.onerror = () => { frame.textContent = "Thumbnail unavailable"; };
      img.src = result.url;
      frame.replaceChildren(img);
    } catch (error) {
      console.warn("Finished design thumbnail unavailable", error);
      if (version === myDesignsVersion && frame.isConnected) frame.textContent = "Thumbnail unavailable";
    }
  }

  async function showMyDesigns() {
    const version = ++myDesignsVersion;
    clearMyDesignThumbs();
    myDesignsPanel.replaceChildren();
    focusMyDesigns();
    myDesignsPanel.style.width = "min(820px,calc(100vw - 30px))";

    const heading = make("h3", null, ppMugMode ? "My Saved Mug Collages" : "My Saved Canvas Collages");
    heading.style.margin = "0 0 8px";
    const explanation = make(
      "p", null,
      "Open, rename, duplicate or delete your collages. " +
      "Each thumbnail shows the complete finished design."
    );
    explanation.style.cssText = "color:#555;font-size:14px;margin:0 0 12px;";
    // Visible close control stays in the top-right even when the list scrolls.
    const savedDesignsClose = document.createElement("button");
    savedDesignsClose.type = "button";
    savedDesignsClose.textContent = "\u00d7";
    savedDesignsClose.setAttribute("aria-label", "Close saved collages");
    savedDesignsClose.title = "Close saved collages";
    savedDesignsClose.style.cssText =
      "position:sticky;top:0;float:right;z-index:5;margin:-10px -10px 4px 8px;" +
      "width:44px;height:44px;flex-shrink:0;border-radius:50%;border:1px solid #cbd5e1;" +
      "background:#fff;color:#172338;font-size:29px;line-height:1;" +
      "font-weight:700;cursor:pointer;box-shadow:0 3px 12px #0002;";
    savedDesignsClose.addEventListener("click", hideMyDesigns);
    myDesignsPanel.append(savedDesignsClose, heading, explanation);
    myDesignsPanel.appendChild(
      makeSaveButton("Close My Designs", hideMyDesigns)
    );
    const loading = make("p", null, "Loading your saved designs...");
    myDesignsPanel.appendChild(loading);

    try {
      const result = await collageRequest("/designs");
      if (version !== myDesignsVersion) return;
      loading.remove();
      // Only offer designs saved for the product currently being customised.
      // Older canvas designs without a product profile stay visible in canvas mode.
      // Fail closed for mug mode if the server has not yet supplied profile metadata.
      const designs = (result.designs || []).filter(design => {
        const profile = String(design.product_profile || '');
        const handle = String(design.product_handle || '');
        const isMug = profile === 'mug_wrap' || handle === ppMugHandle;
        return ppMugMode
          ? profile === 'mug_wrap' && (!handle || handle === ppMugHandle)
          : !isMug;
      });
      if (!designs.length) {
        myDesignsPanel.appendChild(make('p', null, ppMugMode
          ? 'You have no saved mug collages yet. Start a mug collage to save your first design.'
          : 'You have no saved canvas collages yet.'));
        return;
      }

      const cards = make("div");
      cards.style.cssText =
        "display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,270px),1fr));" +
        "gap:14px;margin-top:14px;";
      myDesignsPanel.appendChild(cards);
      const frames = [];

      for (const design of designs) {
        const card = make("div");
        card.style.cssText =
          "border:1px solid #ddd;border-radius:13px;padding:12px;min-width:0;";
        const frame = make("div", null, "Loading photos...");
        frame.style.cssText =
          "display:flex;align-items:center;justify-content:center;" +
          "aspect-ratio:4/3;background:#f2f2f2;overflow:hidden;" +
          "border-radius:8px;font-size:13px;text-align:center;padding:8px;color:#555;";
        const title = make("strong", null, design.title || "Untitled Collage");
        title.style.cssText = "display:block;margin:10px 0 4px;overflow-wrap:anywhere;";
        const date = make("small", null, design.updated_at
          ? "Last saved: " + new Date(design.updated_at).toLocaleString("en-GB")
          : "");
        date.style.cssText = "display:block;color:#555;margin-bottom:9px;";
        const savedCanvasSize = design.product_size_label || design.product?.sizeLabel ||
          design.payload?.product?.sizeLabel || design.sizeLabel || "";
        const savedSizeLine = make("div", null,
          savedCanvasSize
            ? (ppMugMode ? "Saved mug style: " : "Saved canvas size: ") + savedCanvasSize
            : (ppMugMode ? "Mug style: shown when opened" : "Canvas size: shown when opened"));
        savedSizeLine.style.cssText =
          "font-size:13px;font-weight:700;color:#163f70;margin:5px 0 9px;";
        const actions = make("div");
        actions.style.cssText = "display:flex;flex-wrap:wrap;gap:3px;";

        actions.appendChild(designActionButton("Open & Edit", async () => {
          await openSavedCollage(design.id);
        }));

        actions.appendChild(designActionButton("Rename", async () => {
          const name = await ppDialog({heading:"Rename collage", initial:design.title || "", ask:true});
          if (name === null) return;
          const cleaned = name.trim();
          if (!cleaned || cleaned.length > 120) {
            alert("Enter a name between 1 and 120 characters.");
            return;
          }
          const record = await getSavedDesign(design.id);
          await collageRequest("/designs/" + encodeURIComponent(design.id), {
            method: "PUT",
            body: JSON.stringify({ ...record.payload, title: cleaned })
          });
          if (savedDesignId === design.id) savedDesignName = cleaned;
          await showMyDesigns();
        }));

        actions.appendChild(designActionButton("Duplicate", async () => {
          const record = await getSavedDesign(design.id);
          const name = (record.title || design.title || "My Collage") + " (Copy)";
          const duplicatedName = name.slice(0, 120);
          const copied = await collageRequest("/designs", {
            method: "POST",
            body: JSON.stringify({ ...record.payload, title: duplicatedName })
          });
          // Preserve the complete thumbnail when duplicating a collage.
          try {
            await collageRequest("/design-thumbnails/" + encodeURIComponent(copied.id) +
              "/copy-from/" + encodeURIComponent(design.id), {
                method: "POST", body: JSON.stringify({})
              });
          } catch (error) {
            console.warn("Could not copy design thumbnail", error);
          }
          await showMyDesigns();
        }));

        actions.appendChild(designActionButton("Delete", async () => {
          if (!await ppDialog({heading:"Delete saved collage?",message:"This permanently removes it from My Designs.",destructive:true})) return;
          await collageRequest("/designs/" + encodeURIComponent(design.id), {
            method: "DELETE"
          });
          if (savedDesignId === design.id) {
            savedDesignId = null;
            savedDesignName = "";
          }
          await showMyDesigns();
        }, true));

        card.append(frame, title, date, savedSizeLine, actions);
        cards.appendChild(card);
        frames.push({ frame, id: design.id });
      }

      // Load only three cards at once so thumbnail requests remain light.
      for (let i = 0; i < frames.length; i += 3) {
        if (version !== myDesignsVersion) break;
        await Promise.all(frames.slice(i, i + 3).map(
          ({ frame, id }) => addFinishedDesignThumbnail(frame, id, version)
        ));
      }
    } catch (error) {
      if (version === myDesignsVersion) {
        loading.textContent = "Unable to load My Designs: " + error.message;
      }
    }
  }

  // =====================================================
  // SAVE / MY DESIGNS / NEW COLLAGE BUTTONS
  // =====================================================

  const saveControls = make(
    "div",
    "ppc-save-controls"
  );

  saveControls.style.cssText =
    "display:flex;flex-wrap:wrap;" +
    "align-items:center;gap:8px;" +
    "padding:15px 0;";

  const saveButton = makeSaveButton(
    "Save My Collage",
    () => saveMyCollage(false)
  );

  saveButton.dataset.ppcSaveDesign = "1";

  const saveAsNewButton = makeSaveButton(
    "Save as New Collage",
    () => saveMyCollage(true)
  );
  saveAsNewButton.dataset.ppcSaveDesign = "1";

  // V6.1: Cart handoff. This is not a production-ready proof.
  let addingCollageToCart = false;
  const cartButton = makeSaveButton("Save & Add Canvas to Basket", async () => {
    if (selectedProduct?.profile === 'mug_wrap' || ppMugMode) {
      alert('Mug collage ordering is in testing. You can design and save your mug, but checkout will be enabled after the mug print file has been verified.');
      return;
    }
    if (addingCollageToCart || savingDesign) return;
    if (!ppCheckPhotoLimit()) return;
    if (!selectedProduct?.variantId || !state.photos.length || state.reviewMode) {
      alert("Choose a canvas size and finish your collage first.");
      return;
    }
    addingCollageToCart = true;
    cartButton.disabled = true;
    cartButton.textContent = "Saving your collage...";
    showSavingOverlay("Finishing your photos and safely preparing your collage...");
    try {
      // If the user is still editing while files are being prepared, finish
      // that work before taking a snapshot for the saved design.
      const preparationStart = Date.now();
      while (state.uploadBusy) {
        if (Date.now() - preparationStart > 180000) {
          throw new Error("Photograph preparation is taking too long. Please try again.");
        }
        updateSavingOverlay("Preparing your photographs... Please keep this page open.");
        await new Promise(resolve => setTimeout(resolve, 450));
      }
      // Verify live variant and stock before any save or cart mutation.
      const response = await fetch(ppCanvasPath + ".js", {
        credentials: "same-origin", cache: "no-store"
      });
      if (!response.ok) throw new Error("Couldn't check the canvas product.");
      const product = await response.json();
      const variant = product.variants?.find(v =>
        String(v.id) === String(selectedProduct.variantId)
      );
      if (!variant || !variant.available) {
        throw new Error("This canvas size is not currently available.");
      }
      // Create a fresh copy for this basket item, avoiding reuse of
      // a prior order's design ID when the customer edits later.
      const designId = await saveMyCollage(true, { forCart: true });
      if (!designId) throw new Error("The collage could not be saved.");
      showSavingOverlay("Your collage is saved. Preparing your basket...");
      // A preview-image outage must not block a successfully saved design.
      // The permanent design ID stays attached to this exact cart line.
      // If sharing is unavailable, Shopify shows the normal product image.
      let previewUrl = null;
      try {
        const previewResult = await collageRequest(
          "/design-thumbnails/" + encodeURIComponent(designId) + "/share"
        );
        if (typeof previewResult.url === 'string' && /^https:\/\//i.test(previewResult.url)) {
          previewUrl = previewResult.url;
        } else {
          console.warn('Collage preview share returned no valid URL', previewResult);
        }
      } catch (previewError) {
        console.warn('Collage preview link unavailable; using product image in cart', previewError);
      }
      const orientation = selectedProduct.orientation === "square"
        ? "Square" : selectedProduct.orientation === "portrait"
          ? "Portrait" : "Landscape";
      const cartResponse = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {"Content-Type": "application/json", "Accept": "application/json"},
        body: JSON.stringify({
          items: [{
            id: Number(variant.id), quantity: 1,
            properties: {
              ...(previewUrl ? {"_perham_preview": previewUrl} : {}),
              "Collage Design ID": String(designId),
              "Canvas Size": selectedProduct.sizeLabel,
              "Orientation": orientation
            }
          }]
        })
      });
      if (!cartResponse.ok) {
        const error = await cartResponse.json().catch(() => ({}));
        throw new Error(error.description || error.message ||
          "Unable to add your canvas to the basket.");
      }
      window.location.assign("/cart");
    } catch (error) {
      console.error("Canvas cart handoff failed:", error);
      hideSavingOverlay();
      alert("We couldn't complete your basket: " + error.message + "\n\nYour collage is still here. Please try again.");
    } finally {
      hideSavingOverlay();
      addingCollageToCart = false;
      cartButton.disabled = false;
      cartButton.textContent = "Save & Add Canvas to Basket";
    }
  });
  cartButton.style.background = "#155a31";
  if (ppMugMode) {
    cartButton.textContent = 'Mug Checkout — Coming Soon';
    cartButton.title = 'Mug production artwork is still being tested';
  }

  // V13.3: Customer-friendly final review before the existing tested Shopify
  // save/cart action. We don't replace the signed save or cart handoff.
  const ppReviewOverlay=document.createElement('div');
  ppReviewOverlay.id='ppc-v13-review';
  ppReviewOverlay.hidden=true;
  ppReviewOverlay.innerHTML=`<section class="ppc-v13-card" role="dialog" aria-modal="true" aria-labelledby="ppc-v13-title">
    <h2 id="ppc-v13-title" style="margin:0 0 6px;font-size:23px">Your collage is ready!</h2>
    <p style="margin:0;color:#536782">Please check the details before adding your collage to the basket.</p>
    <div data-v13-details style="margin-top:16px"></div>
    <p style="font-size:12px;color:#52677f;margin:14px 0 0">Your collage will be saved with your selected photo edits.</p>
    <div class="ppc-v13-actions"><button type="button" data-v13-back>Back to editing</button><button type="button" data-v13-confirm>Save &amp; Add to Basket</button></div>
  </section>`;
  document.body.appendChild(ppReviewOverlay);
  let ppReviewConfirmed=false;
  const ppReviewDetails=ppReviewOverlay.querySelector('[data-v13-details]');
  function ppReviewRow(label,value){
    const row=document.createElement('div');row.className='ppc-v13-detail';
    const name=document.createElement('span');name.textContent=label;
    const val=document.createElement('strong');val.textContent=String(value);
    row.append(name,val);return row;
  }
  // V14.9.81: allow confirming immediately; originals are verified during Save.
  // Keep the confirmation button and its status current, never frozen on a
  // one-time snapshot. Originals must be safely stored before ordering.
  let ppReviewUploadStatusTimer = null;
  function ppRefreshFinalReviewUploadStatus(){
    if (ppReviewUploadStatusTimer !== null) {
      clearTimeout(ppReviewUploadStatusTimer);
      ppReviewUploadStatusTimer = null;
    }
    if (ppReviewOverlay.hidden) return;
    const pending=state.photos.filter(p=>!p.remoteId).length;
    const waiting=Boolean(state.uploadBusy || pending);
    const confirm=ppReviewOverlay.querySelector('[data-v13-confirm]');
    let message=ppReviewOverlay.querySelector('[data-v1480-upload-status]');
    if (!message) {
      message=document.createElement('div');
      message.dataset.v1480UploadStatus='';
      message.setAttribute('role','status');
      message.setAttribute('aria-live','polite');
      message.style.cssText='margin-top:12px;font-size:13px;color:#365370;line-height:1.45;text-align:center';
      ppReviewOverlay.querySelector('.ppc-v13-actions').before(message);
    }
    confirm.disabled=Boolean(addingCollageToCart || savingDesign);
    confirm.textContent='Save & Add to Basket';
    confirm.title='Finish saving your original photos, then add your collage to the basket';
    confirm.style.opacity='1';
    message.textContent=waiting?
      (pending?`Your photos are uploading securely (${state.photos.length-pending} of ${state.photos.length}). You can tap Save & Add to Basket now.`:'Your photographs are still being prepared. You can tap Save & Add to Basket now.'):
      'Ready to save your collage and add it to your basket.';
    if (waiting) ppReviewUploadStatusTimer=setTimeout(ppRefreshFinalReviewUploadStatus,600);
  }
  function ppStopFinalReviewUploadStatus(){
    if(ppReviewUploadStatusTimer!==null){clearTimeout(ppReviewUploadStatusTimer);ppReviewUploadStatusTimer=null;}
  }
  function ppOpenFinalReview(){
    if (selectedProduct?.profile === 'mug_wrap' || ppMugMode) {
      alert('Mug checkout is not available during production testing. You can still save your mug design.');
      return;
    }
    if (!ppCheckPhotoLimit()) return;
    if(!selectedProduct?.variantId || !state.photos.length || state.reviewMode){
      status('Choose a canvas and finish editing first.');return;
    }
    ppReviewDetails.replaceChildren(
      ppReviewRow('Canvas size',selectedProduct.sizeLabel),
      ppReviewRow('Orientation',selectedProduct.orientation==='square'?'Square':selectedProduct.orientation==='portrait'?'Portrait':'Landscape'),
      ppReviewRow('Photographs',state.photos.length),
      ppReviewRow('Price',selectedProduct.displayPrice||'Shown in basket')
    );
    // V13.4: non-destructive preflight warnings before the tested cart flow.
    // Warnings are advisory; only incomplete uploads prevent confirmation.
    const problems=[];
    const incomplete=state.uploadBusy || state.photos.some(p=>!p.remoteId);
    if(incomplete)problems.push('One or more photographs are still uploading. Please wait before ordering.');
    let warnings=ppReviewOverlay.querySelector('[data-v134-warnings]');
    if(!warnings){warnings=document.createElement('div');warnings.dataset.v134Warnings='';ppReviewDetails.after(warnings);}
    warnings.replaceChildren();
    // The optional quality warning panel is removed. Upload safety remains enforced.
    warnings.style.display='none';
    const confirm=ppReviewOverlay.querySelector('[data-v13-confirm]');
    ppReviewOverlay.hidden=false;
    ppRefreshFinalReviewUploadStatus();
    confirm.focus();
  }
  cartButton.addEventListener('click',event=>{
    if(ppReviewConfirmed){ppReviewConfirmed=false;return;}
    event.preventDefault();event.stopImmediatePropagation();
    ppOpenFinalReview();
  },true);
  ppReviewOverlay.querySelector('[data-v13-back]').addEventListener('click',()=>{
    ppReviewOverlay.hidden=true;ppStopFinalReviewUploadStatus();cartButton.focus();
  });
  ppReviewOverlay.querySelector('[data-v13-confirm]').addEventListener('click',()=>{
    if (addingCollageToCart || savingDesign) return;
    ppReviewOverlay.hidden=true;
    ppStopFinalReviewUploadStatus();
    ppReviewConfirmed=true;
    cartButton.click();
    ppReviewConfirmed=false;
  });
  ppReviewOverlay.addEventListener('click',event=>{
    if(event.target===ppReviewOverlay){ppReviewOverlay.hidden=true;ppStopFinalReviewUploadStatus();}
  });
  ppReviewOverlay.addEventListener('keydown',event=>{
    if(event.key==='Escape'){ppReviewOverlay.hidden=true;ppStopFinalReviewUploadStatus();cartButton.focus();}
  });

  const designsButton = makeSaveButton(
    "My Designs",
    showMyDesigns
  );

  const newCollageButton = makeSaveButton(
    "Create New Collage",
    async () => {
      if (savingDesign || state.uploadBusy) return;

      if (
        state.photos.length &&
        !await ppDialog({heading:"Start a new collage?",message:"Please save your current design before continuing."})
      ) {
        return;
      }

      // Release old photo previews.
      state.photos.forEach(release);

      ppClearHistory();
      state.photos = [];
      state.original = [];
      state.seen.clear();
      state.swapSelected = null;

      // A new collage must not overwrite the previous design.
      savedDesignId = null;
      savedDesignName = "";
      selectedProduct = null;
      ppUpdateProductSummary();

      $("[data-title]").value = "";
      $("[data-subtitle]").value = "";

      hideMyDesigns();

      $("[data-start]").hidden = false;
      $("[data-editor]").hidden = true;

      showReview("rotate");
      safeRender();

      status("Ready to create a new collage.");
    }
  );

  // V11.1.8: Checkout is the primary action; My Designs remains available
  // through the start screen instead of duplicating it in the editor footer.
  saveControls.append(
    cartButton,
    saveButton,
    saveAsNewButton
    // The editor no longer displays Create New Collage.
  );
  cartButton.style.cssText += ';display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;line-height:1.35!important;white-space:normal!important;box-sizing:border-box!important;width:100%;max-width:100%;min-height:56px;margin:6px 0 13px;padding:14px 16px;font-size:17px;';

  const editor = $("[data-editor]");

  if (editor) {
    editor.appendChild(saveControls);
  }

  // Put the My Designs pop-up outside the collage editor.
  // This prevents it overlapping the photo layout.
  document.body.appendChild(myDesignsPanel);
  hideMyDesigns();

  // =====================================================
  // CONNECT START SCREEN TO MY DESIGNS
  // =====================================================

  // Replace the original "Use a Previous Collage" alert.
  root.addEventListener("click", event => {
    const previous = event.target.closest(
      '[data-action="previous"]'
    );

    if (previous && root.contains(previous)) {
      event.stopImmediatePropagation();
      event.preventDefault();

      showMyDesigns();
    }
  }, true);

  // Reset saved-design identity when starting from scratch.
  root.addEventListener("click", event => {
    const start = event.target.closest(
      '[data-action="start"]'
    );

    if (start && editor) {
      const priorSizeNotice = root.querySelector("#ppc-saved-order-size");
      if (priorSizeNotice) priorSizeNotice.remove();
      hideMyDesigns();

      savedDesignId = null;
      savedDesignName = "";
    }
  });

  console.log(
    "Perham Prints My Designs integration initialised."
  );

  // =====================================================
  // END MY DESIGNS INTEGRATION
  // =====================================================

  // =====================================================
  // RESPONSIVE COLLAGE LAYOUT
  // =====================================================

  window.addEventListener("resize", () => {
    if (state.activeCrop) refreshSelection();
  });

  function layoutRows(photos, ratio) {
    const n = photos.length;
    if (!n) return [];

    const aspects = photos.map(p =>
      clamp(p.aspect || 1.25, .35, 3.5)
    );

    const total = aspects.reduce((a, b) => a + b, 0);
    const ideal = clamp(Math.sqrt(total / Math.max(.2, ratio)), 1, n);

    let best = null;

    for (
      let k = 1;
      k <= Math.min(n, Math.max(3, Math.ceil(ideal * 1.8)));
      k++
    ) {
      const dp = Array.from(
        { length: k + 1 },
        () => Array(n + 1).fill(Infinity)
      );

      const prev = Array.from(
        { length: k + 1 },
        () => Array(n + 1).fill(-1)
      );

      dp[0][0] = 0;

      for (let row = 1; row <= k; row++) {
        for (
          let end = row;
          end <= n - (k - row);
          end++
        ) {
          let sum = 0;

          for (
            let begin = end - 1;
            begin >= row - 1;
            begin--
          ) {
            sum += aspects[begin];

            if (!Number.isFinite(dp[row - 1][begin])) {
              continue;
            }

            const target = k * ratio;

            const variation = Math.pow(
              Math.log(Math.max(.01, sum / target)),
              2
            );

            const score = dp[row - 1][begin] + variation;

            if (score < dp[row][end]) {
              dp[row][end] = score;
              prev[row][end] = begin;
            }
          }
        }
      }

      const score =
        dp[k][n] + .26 * Math.pow(k - ideal, 2);

      if (!best || score < best.score) {
        const chunks = [];
        let end = n;

        for (let row = k; row >= 1; row--) {
          const begin = prev[row][end];
          if (begin < 0) break;

          chunks.unshift(
            photos.slice(begin, end)
          );

          end = begin;
        }

        if (end === 0) {
          best = { score, chunks };
        }
      }
    }

    return best ? best.chunks : [photos];
  }

  // =====================================================
  // V11.1 - LAYOUT STUDIO
  // Print-safe presets: change ordering and the existing gap control only.
  // The server's verified renderer already reads the saved photo order/gap.
  // Different geometry presets are intentionally NOT introduced until the
  // backend renderer can reproduce them exactly.
  // =====================================================
  const v11Style = document.createElement('style');
  v11Style.textContent = `
    #pp-collage-v1 .ppc-v11-layouts { margin:16px 0; padding:16px; border:1px solid #d8e5f8; border-radius:18px; background:#f8fbff; color:#183153; }
    #pp-collage-v1 .ppc-v11-layouts[hidden], #pp-collage-v1.ppc-review-mode .ppc-v11-layouts {display:none!important}
    #pp-collage-v1 .ppc-v11-layouts h3 {margin:0 0 5px;font-size:20px;line-height:1.25;color:#17345c}
    #pp-collage-v1 .ppc-v11-layouts p {margin:0 0 13px;color:#536782;font-size:13px;line-height:1.4}
    #pp-collage-v1 .ppc-v11-layout-grid {display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
    #pp-collage-v1 .ppc-v11-layout-btn {min-width:0;display:flex;flex-direction:column;align-items:flex-start;text-align:left;gap:5px;padding:12px;border-radius:13px;border:2px solid #d8e5f8;background:#fff;color:#17345c;cursor:pointer;line-height:1.35;font:inherit;white-space:normal}
    #pp-collage-v1 .ppc-v11-layout-btn[aria-pressed="true"] {background:#eaf3ff;border-color:#1265ee;box-shadow:0 0 0 2px #1265ee18}
    #pp-collage-v1 .ppc-v11-layout-btn:focus-visible, #pp-collage-v1 .ppc-v11-gap:focus-visible {outline:3px solid #388ef9;outline-offset:2px}
    #pp-collage-v1 .ppc-v11-layout-btn strong {font-size:15px}
    #pp-collage-v1 .ppc-v11-layout-btn small {font-size:12px;color:#536782}
    #pp-collage-v1 .ppc-v11-thumbnail {width:100%;height:55px;display:grid;gap:3px;grid-template-columns:repeat(4,1fr);grid-template-rows:repeat(2,1fr)}
    #pp-collage-v1 .ppc-v11-thumbnail i {display:block;border-radius:3px;background:#a5c5f3}
    #pp-collage-v1 .ppc-v11-thumbnail i:nth-child(even) {background:#457dcd}
    #pp-collage-v1 .ppc-v11-thumbnail[data-shape="mixed"] i:first-child {grid-row:span 2}
    #pp-collage-v1 .ppc-v11-thumbnail[data-shape="shuffle"] i:nth-child(3) {grid-column:span 2}
    #pp-collage-v1 .ppc-v11-gap-row {display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:7px;margin-top:9px}
    #pp-collage-v1 .ppc-v11-gap {border:2px solid #d8e5f8;border-radius:12px;background:#fff;min-height:44px;cursor:pointer;font:inherit;font-weight:700;font-size:12px;color:#17345c}
    #pp-collage-v1 .ppc-v11-gap[aria-pressed="true"] {background:#1265ee;border-color:#1265ee;color:white}
    #pp-collage-v1 .ppc-v11-subtitle {font-size:14px;font-weight:800;margin-top:18px}
    @media(max-width:560px) {
      #pp-collage-v1 .ppc-v11-layouts {padding:12px;margin:12px 0}
      #pp-collage-v1 .ppc-v11-layout-grid {gap:8px}
      #pp-collage-v1 .ppc-v11-layout-btn {padding:10px;min-height:128px}
      #pp-collage-v1 .ppc-v11-thumbnail {height:46px}
      #pp-collage-v1 .ppc-v11-gap-row {grid-template-columns:repeat(2,minmax(0,1fr))}
    }
  `;
  // V11.1.1: Allow design preset card content to grow naturally, even when
  // the Shopify theme applies fixed heights / overflow rules to buttons.
  v11Style.textContent += `
    #pp-collage-v1 .ppc-v11-layout-grid {align-items:stretch!important;grid-auto-rows:auto!important;}
    #pp-collage-v1 .ppc-v11-layout-btn {
      display:flex!important;flex-direction:column!important;align-items:flex-start!important;
      justify-content:flex-start!important;gap:7px!important;
      height:auto!important;min-height:155px!important;max-height:none!important;
      padding:13px!important;overflow:visible!important;white-space:normal!important;
      word-break:normal!important;overflow-wrap:break-word!important;
      line-height:1.4!important;box-sizing:border-box!important;
    }
    #pp-collage-v1 .ppc-v11-layout-btn strong,
    #pp-collage-v1 .ppc-v11-layout-btn small {
      display:block!important;position:static!important;height:auto!important;
      max-height:none!important;overflow:visible!important;white-space:normal!important;
      line-height:1.35!important;letter-spacing:normal!important;
      width:100%!important;margin:0!important;padding:0!important;
    }
    #pp-collage-v1 .ppc-v11-layout-btn strong {font-size:15px!important;font-weight:800!important;}
    #pp-collage-v1 .ppc-v11-layout-btn small {font-size:12px!important;font-weight:500!important;}
    #pp-collage-v1 .ppc-v11-thumbnail {flex:0 0 49px!important;height:49px!important;min-height:49px!important;}
    #pp-collage-v1 [data-select-swap] {display:none!important;}
    @media(max-width:560px) {
      #pp-collage-v1 .ppc-v11-layout-btn {min-height:145px!important;padding:10px!important;gap:5px!important;}
      #pp-collage-v1 .ppc-v11-thumbnail {flex-basis:38px!important;height:38px!important;min-height:38px!important;}
    }
  `;
  v11Style.textContent += `
    #pp-collage-v1 .ppc-v149-feature-icon{display:grid;grid-template-columns:repeat(3,1fr);grid-template-rows:repeat(3,1fr);width:54px;height:48px;gap:2px}
    #pp-collage-v1 .ppc-v149-feature-icon i{background:#a4c2ee;border-radius:3px}
    #pp-collage-v1 .ppc-v149-feature-icon i:first-child{grid-column:1/4}
    #pp-collage-v1 .ppc-v149-feature-icon i:nth-child(2){grid-column:1;grid-row:2}
    #pp-collage-v1 .ppc-v149-feature-icon i:nth-child(3){grid-column:2;grid-row:2;background:#225db4}
    #pp-collage-v1 .ppc-v149-feature-icon i:nth-child(4){grid-column:3;grid-row:2}
    #pp-collage-v1 .ppc-v149-feature-icon i:nth-child(5){grid-column:1/4;grid-row:3}
    #pp-collage-v1 .ppc-v149-font-row{display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin:12px 0}
    #pp-collage-v1 .ppc-v149-font-row select{flex:1;min-width:130px;border:1px solid #c8d8ed;border-radius:9px;padding:9px;background:#fff}
    #pp-collage-v1 .ppc-v149-swatches{display:flex;flex-wrap:wrap;gap:8px;align-items:center}
    #pp-collage-v1 .ppc-v149-swatch{width:33px;height:33px;border-radius:50%;border:2px solid #d2dcec;cursor:pointer}
    #pp-collage-v1 .ppc-v149-swatch[aria-pressed=true]{outline:2px solid #2167d2;outline-offset:2px}
  `;
  v11Style.textContent += `
    #pp-collage-v1 .pp1494-font-picker{position:relative;width:100%;max-width:350px;margin-top:7px}
    #pp-collage-v1 .pp1494-font-toggle{background:white;border:1px solid #b9cbe1;border-radius:10px;min-height:43px;width:100%;text-align:left;padding:8px 12px;cursor:pointer;font-size:17px}
    #pp-collage-v1 .pp1494-font-choices{position:absolute;left:0;top:calc(100% + 3px);width:min(420px,90vw);max-height:290px;overflow-y:auto;overscroll-behavior:contain;background:#fff;border:1px solid #bbcfe9;border-radius:12px;box-shadow:0 12px 25px #162b4940;z-index:1000;padding:6px}
    #pp-collage-v1 .pp1494-font-choices[hidden]{display:none!important}
    #pp-collage-v1 .pp1494-font-choice{display:block;text-align:left;width:100%;background:white;color:#183653;padding:10px 9px;min-height:43px;border:0;border-radius:7px;font-size:17px;cursor:pointer}
    #pp-collage-v1 .pp1494-font-choice:hover,#pp-collage-v1 .pp1494-font-choice[aria-selected=true]{background:#eaf3ff}
    #pp-collage-v1 .ppc-v149-feature-center{isolation:isolate}
    #pp-collage-v1 .pp1494-middle-caption{position:absolute;bottom:0;left:0;width:100%;z-index:6;box-sizing:border-box;padding:7px 9px;text-align:center;overflow-wrap:anywhere;line-height:1.12;pointer-events:none;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;min-height:16%;max-height:48%;overflow:hidden}
  `;
  document.head.appendChild(v11Style);
  const v11Panel = document.createElement('section');
  v11Panel.className='ppc-v11-layouts';
  v11Panel.setAttribute('aria-label','Collage arrangement and spacing');
  v11Panel.innerHTML = `
    <h3>Design your collage</h3>
    <p>Choose how your photos are arranged. Your photo edits and original image quality are kept.</p>
    <div class="ppc-v11-layout-grid" role="group" aria-label="Arrange photos">
      <button type="button" class="ppc-v11-layout-btn" data-v11-layout="balanced" aria-pressed="true"><span class="ppc-v11-thumbnail" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span><strong>Balanced</strong><small>Original photo order</small></button>
      <button type="button" class="ppc-v11-layout-btn" data-v11-layout="mixed" aria-pressed="false"><span class="ppc-v11-thumbnail" data-shape="mixed" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i></span><strong>Mixed</strong><small>Alternate wide and tall photos</small></button>
      <button type="button" class="ppc-v11-layout-btn" data-v11-layout="photo-middle" aria-pressed="false"><span class="ppc-v149-feature-icon" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></span><strong>Photo Middle</strong><small>One featured photo in the centre</small></button>
      <button type="button" class="ppc-v11-layout-btn" data-v11-layout="shuffle" aria-pressed="false"><span class="ppc-v11-thumbnail" data-shape="shuffle" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i></span><strong>Surprise me</strong><small>Shuffle photo positions</small></button>
    </div>
    <div class="ppc-v11-subtitle">Spacing between photos</div>
    <div class="ppc-v11-gap-row" role="group" aria-label="Photo spacing">
      <button type="button" class="ppc-v11-gap" data-v11-gap="0">None</button>
      <button type="button" class="ppc-v11-gap" data-v11-gap="4">Small</button>
      <button type="button" class="ppc-v11-gap" data-v11-gap="8">Medium</button>
      <button type="button" class="ppc-v11-gap" data-v11-gap="12">Large</button>
    </div>`;
  // V13.1: A one-tap arrangement that keeps every photo and prioritises
  // a balanced alternation between portrait and landscape photos.
  const ppSmartArrange = document.createElement('button');
  ppSmartArrange.type = 'button';
  ppSmartArrange.className = 'ppc-v13-smart-arrange';
  ppSmartArrange.textContent = '✨ Auto-arrange my photos';
  ppSmartArrange.setAttribute('aria-label','Automatically arrange all photos');
  v11Panel.querySelector('.ppc-v11-layout-grid')?.after(ppSmartArrange);
  ppSmartArrange.addEventListener('click', () => {
    if (!state.photos.length) { status('Please upload photos first.'); return; }
    ppRemember();
    const original=[...state.photos];
    const portrait=original.filter(p => (p.aspect||1) < 0.88);
    const landscape=original.filter(p => (p.aspect||1) >= 0.88);
    const arranged=[];
    while (portrait.length || landscape.length) {
      const first=arranged.length%2 === 0 ? landscape : portrait;
      const second=first===landscape ? portrait : landscape;
      if(first.length) arranged.push(first.shift());
      else if(second.length) arranged.push(second.shift());
    }
    // A stable permutation: all original photo objects are retained exactly once.
    if(arranged.length!==original.length || new Set(arranged).size!==original.length){
      status('Arrangement unchanged; photos are being kept safe.');return;
    }
    state.photos=arranged;
    v11Arrangement='mixed';
    v11RefreshButtons();
    safeRender();
    status('Auto-arranged all '+state.photos.length+' photos. You can still drag to swap.');
  });

  // V13.2: On phones, keep the preview in sight and allow layout choices
  // to collapse, avoiding a long wall of controls.
  const ppMobileLayoutToggle=document.createElement('button');
  ppMobileLayoutToggle.type='button';
  ppMobileLayoutToggle.className='ppc-v13-layout-toggle';
  ppMobileLayoutToggle.setAttribute('aria-expanded','true');
  ppMobileLayoutToggle.textContent='Hide layout choices ↑';
  v11Panel.prepend(ppMobileLayoutToggle);
  ppMobileLayoutToggle.addEventListener('click',()=>{
    const isCollapsed=v11Panel.classList.toggle('ppc-v13-collapsed');
    ppMobileLayoutToggle.setAttribute('aria-expanded',String(!isCollapsed));
    ppMobileLayoutToggle.textContent=isCollapsed?'Show layout choices ↓':'Hide layout choices ↑';
  });

  const ppV13Styles=document.createElement('style');
  ppV13Styles.textContent=`
    #pp-collage-v1 .ppc-v13-smart-arrange{display:block;width:100%;margin:12px 0 16px;padding:12px 14px;border:1px solid #93b8f1;border-radius:12px;background:#e8f2ff;color:#16458a;font-weight:800;cursor:pointer;min-height:44px}
    #pp-collage-v1 .ppc-v13-layout-toggle{display:none;width:100%;background:#fff;border:1px solid #cbdcf6;border-radius:11px;color:#193b67;font-weight:800;min-height:42px;margin:0 0 12px;cursor:pointer}
    @media(max-width:767px){
      #pp-collage-v1 .ppc-v13-layout-toggle{display:block}
      #pp-collage-v1 .ppc-v11-layouts.ppc-v13-collapsed .ppc-v11-layout-grid,
      #pp-collage-v1 .ppc-v11-layouts.ppc-v13-collapsed .ppc-v13-smart-arrange,
      #pp-collage-v1 .ppc-v11-layouts.ppc-v13-collapsed .ppc-v11-subtitle,
      #pp-collage-v1 .ppc-v11-layouts.ppc-v13-collapsed .ppc-v11-gap-row {display:none!important}
      #pp-collage-v1 .ppc-v11-layouts.ppc-v13-collapsed{padding-bottom:4px}
    }
    #ppc-v13-review[hidden]{display:none!important}
    #ppc-v13-review{position:fixed;inset:0;z-index:2147483645;background:rgba(10,19,36,.75);display:flex;align-items:center;justify-content:center;padding:14px;box-sizing:border-box}
    #ppc-v13-review .ppc-v13-card{width:min(480px,100%);max-height:90dvh;overflow:auto;background:#fff;color:#172338;border-radius:20px;padding:24px;box-shadow:0 18px 65px #0005;box-sizing:border-box}
    #ppc-v13-review .ppc-v13-detail{display:flex;justify-content:space-between;gap:18px;padding:11px 0;border-bottom:1px solid #e0e7ef}
    #ppc-v13-review .ppc-v13-actions{display:grid;grid-template-columns:1fr 1.5fr;gap:10px;margin-top:20px}
    #ppc-v13-review button{min-height:48px;border-radius:10px;border:1px solid #b7c6d8;background:#fff;color:#16375c;font-weight:800;cursor:pointer;padding:9px 12px}
    #ppc-v13-review button[data-v13-confirm]{background:#155a31;color:white;border-color:#155a31}
    @media(max-width:440px){#ppc-v13-review .ppc-v13-actions{grid-template-columns:1fr}}
  `;
  document.head.appendChild(ppV13Styles);

  // Place above the existing editor controls, not on top of the photo board.
  const v11Editor = $('[data-editor]');
  if (v11Editor) v11Editor.prepend(v11Panel);
  // The editing instruction belongs at the top of the collage options.
  v11Panel.prepend(photoMoveHelp);
  photoMoveHelp.style.margin='0 0 14px';
  // Remove obsolete lower editor actions without hiding the optional text checkbox.
  const ppLegacyActionStyle=document.createElement('style');
  ppLegacyActionStyle.textContent=`
    #pp-collage-v1:not(.ppc-review-mode) [data-editor] [data-action="shuffle"],
    #pp-collage-v1:not(.ppc-review-mode) [data-editor] [data-action="reset"],
    #pp-collage-v1:not(.ppc-review-mode) [data-editor] [data-action="clear"]{display:none!important}
  `;
  document.head.appendChild(ppLegacyActionStyle);
  // V11.1.8: Keep the native gap input (backend and saved-design compatibility),
  // but hide its duplicate slider; spacing is controlled by the four presets.
  const gapControl = $('[data-gap]');
  if (gapControl) {
    const gapField = gapControl.closest('label');
    if (gapField) gapField.style.setProperty('display','none','important');
    else gapControl.style.setProperty('display','none','important');
  }

  // V11.2.1: Ratio follows the chosen Shopify canvas size/orientation automatically.
  // Hide the duplicate proportions control without removing or disabling its data.
  const ratioField = $('[data-ratio]');
  if (ratioField) {
    const ratioLabel = ratioField.closest('label');
    if (ratioLabel) {
      ratioLabel.style.setProperty('display', 'none', 'important');
    } else {
      // Some themes render the caption and select as siblings.
      const row = ratioField.parentElement;
      const rowText = (row?.textContent || '').toLowerCase();
      if (row && !row.classList.contains('ppc-panel') && rowText.includes('collage proportions') &&
          !row.querySelector('[data-fit]') && !row.querySelector('[data-gap]')) {
        row.style.setProperty('display', 'none', 'important');
      } else {
        ratioField.style.setProperty('display', 'none', 'important');
      }
    }
  }

  // V14.9.45 — accessible whole-collage filter choices BEFORE Photo Fit.
  const ppFilterSection=document.createElement('section');
  ppFilterSection.className='ppc-whole-filter';
  ppFilterSection.innerHTML='<h3>Collage filters</h3><p>Apply a look to all your photos. Your originals stay unchanged.</p><div class="ppc-whole-filter-choices" role="group" aria-label="Collage colour filter">'+
    [['original','Original'],['bw','Black & White'],['sepia','Sepia'],['vintage','Vintage']]
      .map(([key,label])=>'<button type="button" data-pp-collage-filter="'+key+'" aria-pressed="'+(key==='original')+'">'+label+'</button>').join('')+'</div>';
  const ppFilterStyle=document.createElement('style');
  ppFilterStyle.textContent=`
    #pp-collage-v1 .ppc-whole-filter{margin:13px 0;padding:14px;border:1px solid #d8e5f8;border-radius:14px;background:#f8fbff}
    #pp-collage-v1 .ppc-whole-filter h3{font-size:16px;font-weight:800;margin:0 0 5px}
    #pp-collage-v1 .ppc-whole-filter p{font-size:12px;margin:0 0 10px;color:#536780}
    #pp-collage-v1 .ppc-whole-filter-choices{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
    #pp-collage-v1 .ppc-whole-filter button{min-height:46px;padding:9px 7px;border:2px solid #cad8ed;border-radius:10px;background:white;color:#18385c;font-weight:750;font-size:12px;line-height:1.2}
    #pp-collage-v1 .ppc-whole-filter button[aria-pressed="true"]{background:#e7f0ff;border-color:#1764e6}
  `;
  document.head.appendChild(ppFilterStyle);
  v11Panel.querySelector('.ppc-v11-gap-row')?.before(ppFilterSection);
  ppFilterSection.addEventListener('click',event=>{
    const button=event.target.closest('[data-pp-collage-filter]');
    if(!button)return;
    ppCollageFilterMode=button.dataset.ppCollageFilter;
    ppFilterSection.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    safeRender();
    ppDraftSchedule();
  });

  // V14.9.20: one clear Photo Fit control, backed by the existing form field.
  const ppFitSelect=$('[data-fit]');
  if(ppFitSelect){
    const ppFitLabel=ppFitSelect.closest('label');
    if(ppFitLabel)ppFitLabel.style.setProperty('display','none','important');
    const ppFitPanel=document.createElement('div');
    ppFitPanel.className='ppc-v14919-fit';
    ppFitPanel.innerHTML='<strong>Photo Fit</strong><p>Choose how your pictures fit their spaces.</p><div role="group" aria-label="Photo Fit"><button type="button" data-fit-mode="cover">Fill Spaces — Smart Crop</button><button type="button" data-fit-mode="contain">Fit Whole Photo</button></div><small>Smart Crop protects detected faces where possible. If faces cannot be detected, Fill Spaces uses a centre crop: check faces before ordering. Some group photos may show their whole image to protect detected faces.</small>';
    const ppFitCss=document.createElement('style');
    ppFitCss.textContent='#pp-collage-v1 .ppc-v14919-fit{margin:15px 0;padding:15px;border:1px solid #d8e5f8;border-radius:14px;background:#f8fbff;color:#17345c}#pp-collage-v1 .ppc-v14919-fit>strong{font-size:15px}#pp-collage-v1 .ppc-v14919-fit p{font-size:12px;margin:5px 0 9px}#pp-collage-v1 .ppc-v14919-fit>div{display:grid;grid-template-columns:1fr 1fr;gap:8px}#pp-collage-v1 .ppc-v14919-fit button{background:white;border:2px solid #d1dff2;border-radius:10px;padding:10px 8px;min-height:51px;color:#17345c;font-weight:750;font-size:12px;cursor:pointer}#pp-collage-v1 .ppc-v14919-fit button[aria-pressed=true]{background:#e8f1ff;border-color:#1764e6}#pp-collage-v1 .ppc-v14919-fit small{display:block;color:#52647c;font-size:11px;margin-top:9px;line-height:1.35}';
    document.head.appendChild(ppFitCss);
    const ppSyncFit=()=>ppFitPanel.querySelectorAll('[data-fit-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.fitMode===ppFitSelect.value)));
    ppFitPanel.querySelectorAll('[data-fit-mode]').forEach(b=>b.addEventListener('click',()=>{ppFitSelect.value=b.dataset.fitMode;ppFitSelect.dispatchEvent(new Event('input',{bubbles:true}));ppFitSelect.dispatchEvent(new Event('change',{bubbles:true}));ppSyncFit();}));
    ppFitSelect.addEventListener('change',ppSyncFit);
    const ppFitSafety=document.createElement('small');
    ppFitSafety.dataset.ppFaceSafety='1';
    ppFitSafety.style.cssText='display:block;font-weight:650;color:#915a13;margin-top:8px';
    ppFitPanel.appendChild(ppFitSafety);
    const ppFitSafetySync=()=>{
      if(ppFitSelect.value!=='cover'){ppFitSafety.textContent='';return;}
      const unchecked=state.photos.filter(p=>!p.userCropRect && !p.ppFaceBounds).length;
      const unavailable=state.photos.filter(p=>p.ppFaceStatus==='detector-unavailable' || p.ppFaceStatus==='scan-error').length;
      ppFitSafety.textContent=unchecked ? 'Please check the framing of each photograph before ordering.' : 'Detected faces positioned for safer framing. Check every crop before ordering.';
    };
    ppFitSelect.addEventListener('change',ppFitSafetySync);
    root.addEventListener('pp-faces-scanned',ppFitSafetySync);
    ppFitSafetySync();
    v11Panel.querySelector('.ppc-v11-gap-row')?.before(ppFitPanel);
    ppSyncFit();
  }

  // V14.9.7: retain [data-bg] for older saved designs/event listeners, but
  // remove the separate Text Panel Colour setting from the customer interface.
  // The visible spacing-colour controls are the one source of truth.
  const pp1497TextBackgroundField = $('[data-bg]');
  if (pp1497TextBackgroundField) {
    const pp1497LegacyBgRow = pp1497TextBackgroundField.closest('label') || pp1497TextBackgroundField;
    pp1497LegacyBgRow.style.setProperty('display','none','important');
    pp1497TextBackgroundField.value = '#ffffff';
  }

  // Optional text panel. Keep the original text inputs in the DOM to preserve
  // saved-design data, input listeners and the production renderer contract.
  const editorPanel = $('[data-editor] .ppc-panel');
  const mainTitleField = $('[data-title]');
  const subtitleField = $('[data-subtitle]');
  let textEnabled = Boolean(mainTitleField?.value.trim() || subtitleField?.value.trim());
  let textOptionCheckbox = null;
  const pp1499TextWidthField = $('[data-text-width]');
  const pp1499TextWidthRow = pp1499TextWidthField ? (pp1499TextWidthField.closest('label') || pp1499TextWidthField) : null;
  if (pp1499TextWidthRow) pp1499TextWidthRow.style.setProperty('display','none','important');
  if (editorPanel && mainTitleField && subtitleField) {
    const headings = [...editorPanel.querySelectorAll('h2,h3,h4,strong')];
    const heading = headings.find(el => el.textContent.trim().toLowerCase() === 'add text');
    const fields = ['[data-title]','[data-subtitle]','[data-position]',
      '[data-text-size]','[data-colour]'];
    const rows = [...new Set(fields.map(sel => {
      const input = $(sel);
      return input ? (input.closest('label') || input) : null;
    }).filter(Boolean))];
    const toggle = document.createElement('label');
    toggle.className = 'ppc-v118-text-toggle';
    toggle.style.cssText = 'display:flex;align-items:center;gap:12px;margin:12px 0 14px;padding:14px;background:#eef5ff;border:1px solid #cbdcf6;border-radius:12px;cursor:pointer;font-weight:800;color:#143963;';
    toggle.innerHTML = '<input type="checkbox" aria-label="Add text to collage" style="width:22px;height:22px;min-height:22px;flex:none;accent-color:#1565ea;"><span>Add text to my collage?</span>';
    textOptionCheckbox = toggle.querySelector('input');
    function updateTextOptions() {
      textEnabled = textOptionCheckbox.checked;
      rows.forEach(row => row.style.setProperty('display',textEnabled?'':'none','important'));
      if (heading) heading.style.setProperty('display','none','important');
      // Switch off existing text WITHOUT erasing customer entries. Saved
      // text is restored if the checkbox is switched back on.
      safeRender();
    }
    textOptionCheckbox.checked = textEnabled;
    if (heading) heading.parentNode.insertBefore(toggle, heading);
    else rows[0]?.parentNode.insertBefore(toggle,rows[0]);
    textOptionCheckbox.addEventListener('change', updateTextOptions);
    updateTextOptions();
  }
  function syncTextOptionFromRestoredDesign() {
    if (!textOptionCheckbox) return;
    textOptionCheckbox.checked = Boolean(mainTitleField?.value.trim() || subtitleField?.value.trim());
    textOptionCheckbox.dispatchEvent(new Event('change',{bubbles:true}));
  }
  let v11Arrangement='balanced';
  function v11RefreshButtons() {
    v11Panel.querySelectorAll('[data-v11-layout]').forEach(button =>
      button.setAttribute('aria-pressed', String(button.dataset.v11Layout===v11Arrangement)));
    const gap=Number($('[data-gap]')?.value||0);
    v11Panel.querySelectorAll('[data-v11-gap]').forEach(button =>
      button.setAttribute('aria-pressed', String(Number(button.dataset.v11Gap)===gap)));
  }
  v11Panel.addEventListener('click', event => {
    const layoutButton=event.target.closest('[data-v11-layout]');
    if(layoutButton) {
      if (!state.photos.length) {status('Upload your photos before arranging them.');return;}
      const choice=layoutButton.dataset.v11Layout;
      ppRemember();
      v11Arrangement=choice;
      if(choice==='balanced') {
        const known=new Set(state.photos);
        state.photos=[...state.original.filter(p=>known.has(p)),...state.photos.filter(p=>!state.original.includes(p))];
      } else if(choice==='mixed') {
        const portrait=state.photos.filter(p=>(p.aspect||1)<1);
        const landscape=state.photos.filter(p=>(p.aspect||1)>=1);
        const order=[];
        while(portrait.length||landscape.length){
          if(landscape.length)order.push(landscape.shift());
          if(portrait.length)order.push(portrait.shift());
        }
        state.photos=order;
      } else if(choice==='portrait-first') {
        state.photos=[...state.photos].sort((a,b)=>(a.aspect||1)-(b.aspect||1));
      } else if(choice==='landscape-first') {
        state.photos=[...state.photos].sort((a,b)=>(b.aspect||1)-(a.aspect||1));
      } else if(choice==='pairs') {
        const tall=state.photos.filter(p=>(p.aspect||1)<1);
        const wide=state.photos.filter(p=>(p.aspect||1)>=1);
        const arranged=[];
        while(tall.length||wide.length){
          arranged.push(...wide.splice(0,2),...tall.splice(0,2));
        }
        state.photos=arranged;
      } else if(choice==='photo-middle') {
        if(state.photos.length<5){v11Arrangement='balanced';status('Photo Middle needs at least 5 photos.');v11RefreshButtons();return;}
      } else if(choice==='shuffle') {
        for(let i=state.photos.length-1;i>0;i--){
          const j=Math.floor(Math.random()*(i+1));
          [state.photos[i],state.photos[j]]=[state.photos[j],state.photos[i]];
        }
      }
      // Each preset is a permutation, never a filter: retain every original
      // photo reference even if a future preset produces an incomplete list.
      const seenPhotos = new Set(state.photos);
      for (const originalPhoto of state.original) {
        if (!seenPhotos.has(originalPhoto)) {
          state.photos.push(originalPhoto);
          seenPhotos.add(originalPhoto);
        }
      }
      v11RefreshButtons();safeRender();status('All '+state.photos.length+' photos kept in your arrangement.');return;
    }
    const gapButton=event.target.closest('[data-v11-gap]');
    if(gapButton){
      const input=$('[data-gap]');
      const wanted=Number(gapButton.dataset.v11Gap);
      const lo=input.min!==''?Number(input.min):0;
      const hi=input.max!==''?Number(input.max):20;
      if(String(input.value)!==String(clamp(wanted,lo,hi)))ppRemember();
      input.value=String(clamp(wanted,lo,hi));
      input.dispatchEvent(new Event('input',{bubbles:true}));
      v11RefreshButtons();
    }
  });
  $('[data-gap]').addEventListener('input',v11RefreshButtons);
  v11RefreshButtons();

  // =====================================================
  // PHOTO SWAPPING
  // =====================================================

  function swapPhotos(a, b) {
    const x = state.photos.indexOf(a);
    const y = state.photos.indexOf(b);

    if (x < 0 || y < 0 || x === y) return;
    ppRemember();

    [state.photos[x], state.photos[y]] =
      [state.photos[y], state.photos[x]];

    state.swapSelected = null;

    safeRender();
    status("Photographs swapped.");
  }

  // =====================================================
  // BUILD THE COLLAGE PHOTO GRID
  // =====================================================

  function renderGrid(photos, ratio, preserveWholeCrop = false) {
    const grid = make(
      "div",
      "ppc-photo-grid"
    );

    grid.style.cssText =
      "position:relative!important;" +
      "display:block!important;" +
      "width:100%!important;" +
      "height:100%!important;" +
      "overflow:hidden!important;";

    if (!photos.length) return grid;

    const baseRatio = $("[data-ratio]")
      .value.split("/").map(Number);

    const regionRatio =
      ratio || baseRatio[0] / baseRatio[1];

    const rows = layoutRows(
      photos,
      regionRatio
    );

    // Preserve the exact saved spacing for print-preview consistency.
    const gap = Number($("[data-gap]").value) || 0;

    const sums = rows.map(row =>
      row.reduce(
        (s, p) =>
          s + clamp(p.aspect || 1, .35, 3.5),
        0
      )
    );

    const weights = sums.map(s => 1 / s);

    const totalWeight = weights.reduce(
      (a, b) => a + b,
      0
    );

    let y = 0;

    rows.forEach((row, r) => {
      const rowHeight =
        weights[r] / totalWeight;

      const rowAspect = sums[r];

      let x = 0;

      row.forEach((photo, c) => {
        const fraction =
          clamp(photo.aspect || 1, .35, 3.5) /
          rowAspect;

        const tile = make(
          "div",
          "ppc-tile"
        );

        tile.tabIndex = 0;
        tile.setAttribute("role", "button");
        tile.dataset.ppcPhoto = "1";
        tile.ppcPhoto = photo;

        tile.style.setProperty(
          "position",
          "absolute",
          "important"
        );

        tile.style.setProperty(
          "left",
          `calc(${x * 100}% + ${
            (c - x * (row.length - 1)) * gap
          }px)`,
          "important"
        );

        tile.style.setProperty(
          "top",
          `calc(${y * 100}% + ${
            (r - y * (rows.length - 1)) * gap
          }px)`,
          "important"
        );

        tile.style.setProperty(
          "width",
          `calc(${fraction * 100}% - ${
            fraction * (row.length - 1) * gap
          }px)`,
          "important"
        );

        tile.style.setProperty(
          "height",
          `calc(${rowHeight * 100}% - ${
            rowHeight *
            (rows.length - 1) *
            gap
          }px)`,
          "important"
        );

        // Any customer-saved crop is shown IN FULL. Never silently crop it
        // again to fill the tile. The chosen spacing colour shows through.
        // Unedited photos still follow the customer’s Photo Fit selection.
        const manualCrop = Boolean(photo.userCropRect);
        const image = make("img");
        image.src = displaySrc(photo);
        image.alt = photo.name;
        image.style.setProperty("position", "absolute", "important");
        image.style.setProperty("inset", "0", "important");
        image.style.setProperty("width", "100%", "important");
        image.style.setProperty("height", "100%", "important");
        const smart=ppSmartFit(photo,regionRatio*(fraction/rowHeight),preserveWholeCrop);
        const keepFullPhoto=smart.fit==='contain';
        if (keepFullPhoto) {
          // V14.9.18: size the *element* to the complete saved crop, rather than
          // depending on object-fit on a stretched 100%-by-100% image.
          // In particular, portrait crops within wide cells remain fully visible.
          const imageRatio = Math.max(0.01, Number(photo.aspect) || 1);
          image.style.setProperty("inset", "auto", "important");
          image.style.setProperty("left", "50%", "important");
          image.style.setProperty("top", "50%", "important");
          image.style.setProperty("transform", "translate(-50%, -50%)", "important");
          image.style.setProperty("width", "auto", "important");
          image.style.setProperty("height", "auto", "important");
          image.style.setProperty("max-width", "100%", "important");
          image.style.setProperty("max-height", "100%", "important");
          image.style.setProperty("aspect-ratio", String(imageRatio), "important");
          image.style.setProperty("object-fit", "contain", "important");
          image.style.setProperty("display", "block", "important");
          // Set explicit dimensions once the actual tile has a measurable size.
          // A ResizeObserver is unnecessary: the image's intrinsic ratio and
          // CSS max constraints handle screen size changes.
          image.addEventListener('load', () => {
            if (!image.isConnected) return;
            const actualRatio = image.naturalWidth / Math.max(1, image.naturalHeight);
            image.style.setProperty('aspect-ratio', String(actualRatio), 'important');
            const box = tile.getBoundingClientRect();
            if (box.width > 0 && box.height > 0) {
              if (box.width / box.height > actualRatio) {
                image.style.setProperty('height', '100%', 'important');
                image.style.setProperty('width', 'auto', 'important');
              } else {
                image.style.setProperty('width', '100%', 'important');
                image.style.setProperty('height', 'auto', 'important');
              }
            }
          }, {once:true});
        } else {
          image.style.setProperty("object-fit", "cover", "important");
          image.style.setProperty('object-position',(smart.px??50)+'% '+(smart.py??50)+'%','important');
        }
        // V14.9.6: "Fit whole photo" exposes the tile beneath the image.
        // Use the SAME spacing colour for all tiles, not the theme's white
        // default. Also covers the featured middle photo on portrait swaps.
        // Keep fitted-photo letterboxing genuinely transparent. The single
        // continuous board pattern beneath the tile is the true background.
        // Do not repaint the pattern in each tile: that restarts gradients.
        tile.style.setProperty("background", "transparent", "important");
        grid.style.setProperty("background", "transparent", "important");
        tile.style.setProperty("overflow", "hidden", "important");
        image.style.setProperty('filter', (ppPhotoFilter(photo)||'none')+' '+(ppCollageFilterCSS[ppCollageFilterMode]||'none'),'important');
        tile.appendChild(image);
        if (keepFullPhoto && image.complete && image.naturalWidth) {
          image.dispatchEvent(new Event('load'));
        }
        // V14.9.58: Touch drag starts on first movement; prevent Safari from hijacking it as page scrolling.
        tile.style.setProperty('touch-action','none','important');
        image.style.setProperty('touch-action','none','important');
        image.draggable=false;
        tile.setAttribute('aria-label','Tap to crop or drag to swap '+photo.name);

        // Detect drag to swap photographs.
        tile.addEventListener(
          "pointerdown",
          event => {
            if (event.button !== 0) return;
            // Mobile touch: tap crops; moving a finger starts a photo drag immediately.
            if (event.pointerType !== 'mouse') {
              if(event.pointerType === 'touch') ppMobileSwapStart(event, photo, tile);
              return;
            }

            state.suppressClick = false;
            state.dragging = {
              photo,
              id: event.pointerId,
              x: event.clientX,
              y: event.clientY,
              moved: false,
              tile
            };
            // Both mouse and touch swaps now start with a direct drag.
          }
        );
        tile.addEventListener('pointermove',event=>{
          const drag=state.dragging;
          if(!drag||drag.id!==event.pointerId)return;
          if(Math.hypot(event.clientX-drag.x,event.clientY-drag.y)>12){
            drag.moved=true;
            tile.style.outline='3px solid #1170f5';
            tile.style.outlineOffset='-3px';
          }
          if(drag.moved&&event.cancelable)event.preventDefault();
        });

        tile.addEventListener(
          "click",
          event => {
            if (ppMobileSuppressClickUntil > Date.now()) { event.preventDefault(); return; }
            if (state.suppressClick) {
              state.suppressClick = false;
              return;
            }

            if (
              state.swapSelected &&
              state.swapSelected !== photo
            ) {
              swapPhotos(
                state.swapSelected,
                photo
              );
              return;
            }

            // Tap / click to open the same full crop editor as photo review.
            // Pointer movement above the swap threshold is handled separately.
            if (state.dragging?.moved) return;
            if (!state.reviewMode && !state.activeCrop) openCrop(photo, tile);
          }
        );

        // Accessible keyboard editing without interfering with drag-to-swap.
        tile.tabIndex = 0;
        tile.setAttribute('role', 'button');
        tile.setAttribute('aria-label', 'Crop ' + photo.name + '. Drag to swap photographs.');
        tile.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (!state.reviewMode && !state.activeCrop) openCrop(photo, tile);
        });

        grid.appendChild(tile);
        x += fraction;
      });

      y += rowHeight;
    });

    return grid;
  }

  // =====================================================
  // V14.9.58 — DIRECT TOUCH DRAG PHOTO SWAPPING
  // Tap still edits; moving 9px or more drags immediately.
  // Mobile users scroll using the space outside photo tiles.
  // =====================================================
  let ppMobileSwap = null;
  let ppMobileSuppressClickUntil = 0;
  function ppMobileSwapClear(){
    if(!ppMobileSwap)return;
    if(ppMobileSwap.tile?.isConnected){
      ppMobileSwap.tile.style.outline='';
      ppMobileSwap.tile.style.outlineOffset='';
    }
    ppMobileSwap=null;
  }
  function ppMobileSwapStart(event,photo,tile){
    if(state.activeCrop||state.reviewMode||!event.isPrimary)return;
    ppMobileSwapClear();
    ppMobileSwap={id:event.pointerId,photo,tile,x:event.clientX,y:event.clientY,
      lastX:event.clientX,lastY:event.clientY,active:false};
  }
  document.addEventListener('pointermove',event=>{
    const drag=ppMobileSwap;
    if(!drag||event.pointerId!==drag.id)return;
    drag.lastX=event.clientX;drag.lastY=event.clientY;
    if(!drag.active && Math.hypot(event.clientX-drag.x,event.clientY-drag.y)>=9){
      drag.active=true;
      ppMobileSuppressClickUntil=Date.now()+1100;
      drag.tile.style.outline='3px solid #1170f5';
      drag.tile.style.outlineOffset='-3px';
    }
    if(drag.active && event.cancelable)event.preventDefault();
  },{passive:false});
  document.addEventListener('touchmove',event=>{
    if(ppMobileSwap?.active && event.cancelable)event.preventDefault();
  },{passive:false});
  document.addEventListener('pointerup',event=>{
    const drag=ppMobileSwap;
    if(!drag||drag.id!==event.pointerId)return;
    const wasActive=drag.active;
    const x=event.clientX,y=event.clientY;
    ppMobileSwapClear();
    if(!wasActive)return;
    ppMobileSuppressClickUntil=Date.now()+1100;
    const target=document.elementFromPoint(x,y)?.closest('[data-ppc-photo]');
    if(target?.ppcPhoto && target.ppcPhoto!==drag.photo)swapPhotos(drag.photo,target.ppcPhoto);
  });
  document.addEventListener('pointercancel',event=>{
    if(ppMobileSwap?.id===event.pointerId)ppMobileSwapClear();
  });

  // =====================================================
  // COMPLETE PHOTO DRAG & DROP
  // =====================================================

  document.addEventListener(
    "pointerup",
    event => {
      const drag = state.dragging;

      if (!drag || event.pointerId !== drag.id || event.pointerType !== 'mouse') {
        return;
      }

      state.dragging = null;
      if(drag.tile?.isConnected){drag.tile.style.outline='';drag.tile.style.outlineOffset='';}

      if (
        Math.hypot(
          event.clientX - drag.x,
          event.clientY - drag.y
        ) < 12
      ) {
        return;
      }

      state.suppressClick = true;
      const target = document.elementFromPoint(
        event.clientX,
        event.clientY
      )?.closest("[data-ppc-photo]");

      if (
        target?.ppcPhoto &&
        target.ppcPhoto !== drag.photo
      ) {
        state.suppressClick = true;

        swapPhotos(
          drag.photo,
          target.ppcPhoto
        );
      }
    }
  );

  document.addEventListener(
    "pointercancel",
    () => {
      state.dragging = null;
    }
  );


  // Clear any pending mouse drag if the page scrolls mid-gesture.
  window.addEventListener('scroll', () => {
    if(ppMobileSwap)ppMobileSwapClear();
    if (state.dragging) {
      if (state.dragging.tile?.isConnected) state.dragging.tile.style.outline = '';
      state.dragging = null;
    }
  }, {passive:true});

  // V14.9: Text font selector and convenient colour swatches. Existing
  // text colour input is retained as the custom picker for all colour values.
  const ppV149AllowedFonts=['Arial','Helvetica','Verdana','Tahoma','Trebuchet MS','Geneva','Century Gothic','Gill Sans','Arial Black','Impact','Georgia','Times New Roman','Garamond','Palatino Linotype','Book Antiqua','Baskerville','Cambria','Courier New','Lucida Console','Comic Sans MS','Brush Script MT','Segoe Script','Lucida Handwriting','Monotype Corsiva','Papyrus'];
  function ppV149CleanFont(value){return ppV149AllowedFonts.includes(value)?value:'Arial';}
  const ppV149Font=document.createElement('select');
  ppV149Font.setAttribute('aria-label','Text font');
  ppV149Font.dataset.ppcTextFont='1';
  ppV149AllowedFonts.forEach(name=>{
    const o=document.createElement('option');o.value=name;o.textContent=name;ppV149Font.appendChild(o);
  });
  // V14.9.4: Visual font chooser. The original select remains the single source
  // of truth for save/reopen, and the custom choices show actual font samples.
  const pp1494FontPicker=document.createElement('div');
  pp1494FontPicker.className='pp1494-font-picker';
  const pp1494FontToggle=document.createElement('button');
  pp1494FontToggle.type='button';pp1494FontToggle.className='pp1494-font-toggle';
  pp1494FontToggle.setAttribute('aria-expanded','false');
  pp1494FontToggle.setAttribute('aria-label','Choose font style');
  const pp1494FontChoices=document.createElement('div');
  pp1494FontChoices.className='pp1494-font-choices';pp1494FontChoices.hidden=true;
  function pp1494FontStack(name){return '"'+String(name).replace(/[^a-zA-Z0-9 ]/g,'')+'", '+(/script|handwriting|corsiva|brush/i.test(name)?'cursive':/courier|console/i.test(name)?'monospace':/georgia|times|garamond|palatino|antiqua|baskerville|cambria/i.test(name)?'serif':'sans-serif');}
  function pp1494SyncFont(){
    const name=ppV149CleanFont(ppV149Font.value);
    pp1494FontToggle.textContent=name+'  ▾';
    pp1494FontToggle.style.fontFamily=pp1494FontStack(name);
    pp1494FontChoices.querySelectorAll('[data-font-choice]').forEach(b=>b.setAttribute('aria-selected',String(b.dataset.fontChoice===name)));
  }
  // V14.9.8: use only the current Main title; the subtitle never affects font samples.
  function pp1498TitleSample(){
    const typed=String(mainTitleField?.value||'').trim().replace(/\s+/g,' ');
    return typed || 'Your title';
  }
  function pp1498RefreshFontSamples(){
    const sample=pp1498TitleSample();
    pp1494FontChoices.querySelectorAll('[data-font-choice]').forEach(button=>{
      button.textContent=button.dataset.fontChoice+' — '+sample;
    });
  }
  mainTitleField?.addEventListener('input',pp1498RefreshFontSamples);
  pp1494FontToggle.addEventListener('click',pp1498RefreshFontSamples);
  ppV149AllowedFonts.forEach(name=>{
    const b=document.createElement('button');b.type='button';
    b.className='pp1494-font-choice';b.dataset.fontChoice=name;
    b.style.fontFamily=pp1494FontStack(name);
    b.textContent=name+' — '+pp1498TitleSample();
    b.addEventListener('click',()=>{
      ppV149Font.value=name;ppV149Font.dispatchEvent(new Event('change',{bubbles:true}));
      pp1494FontChoices.hidden=true;pp1494FontToggle.setAttribute('aria-expanded','false');pp1494SyncFont();
    });pp1494FontChoices.appendChild(b);
  });
  pp1494FontToggle.addEventListener('click',()=>{
    pp1494FontChoices.hidden=!pp1494FontChoices.hidden;
    pp1494FontToggle.setAttribute('aria-expanded',String(!pp1494FontChoices.hidden));
  });
  document.addEventListener('click',event=>{
    if(!pp1494FontPicker.contains(event.target)){
      pp1494FontChoices.hidden=true;pp1494FontToggle.setAttribute('aria-expanded','false');
    }
  });
  pp1494FontPicker.append(pp1494FontToggle,pp1494FontChoices);
  pp1494SyncFont();
  const ppV149FontRow=document.createElement('div');
  ppV149FontRow.className='ppc-v149-font-row';
  const ppV149FontLabel=document.createElement('label');
  ppV149FontLabel.textContent='Font style';
  ppV149FontLabel.appendChild(pp1494FontPicker);
  ppV149FontLabel.appendChild(ppV149Font);
  ppV149Font.style.display='none';
  ppV149FontRow.appendChild(ppV149FontLabel);
  const ppV149Colours=document.createElement('div');
  ppV149Colours.className='ppc-v149-font-row';
  ppV149Colours.innerHTML='<strong>Text colour</strong>';
  ppV149Colours.setAttribute('aria-label','Text colour choices');
  const ppV149Swatches=document.createElement('div');
  ppV149Swatches.className='ppc-v149-swatches';
  const pp1510TextColours = [
    ['#171717','Black'],['#ffffff','White'],['#1d4ed8','Blue'],
    ['#b91c1c','Red'],['#157347','Green'],['#d97706','Orange'],
    ['#d4af37','Gold'],['#c0c0c0','Silver'],['#8b5a2b','Bronze']
  ];
  for(const [colour,label] of pp1510TextColours){
    const btn=document.createElement('button');btn.type='button';
    btn.className='ppc-v149-swatch';btn.dataset.ppcInk=colour;
    btn.title=label;btn.setAttribute('aria-label','Set text colour to '+label);
    const circle=document.createElement('span');circle.className='ppc-v1510-ink-preview';
    circle.textContent='Aa';
    const foilKind=pp1512FoilKind(colour);
    if(foilKind){
      circle.style.backgroundImage=pp1512FoilGradient(foilKind);
      circle.style.backgroundSize='95px 95px, 190% 100%';
      circle.style.backgroundColor=colour;
    }else{
      circle.style.backgroundColor=colour;
    }
    circle.style.color=(colour==='#ffffff'||colour==='#c0c0c0')?'#17233c':'#ffffff';
    const caption=document.createElement('small');caption.textContent=label;
    btn.append(circle,caption);
    btn.addEventListener('click',()=>{
      const picker=$('[data-colour]');
      if(picker){picker.value=colour;picker.dispatchEvent(new Event('input',{bubbles:true}));}
      ppV149UpdateSwatches();
    });
    ppV149Swatches.appendChild(btn);
  }
  ppV149Colours.appendChild(ppV149Swatches);
  ppV149Colours.classList.add('ppc-v1498-colour-group');
  const pp1498ColourStyle=document.createElement('style');
  pp1498ColourStyle.textContent=`
    #pp-collage-v1 .ppc-v1498-colour-group{display:flex;flex-wrap:wrap;gap:9px;align-items:center;padding:13px 0;border-top:1px solid #d8e5f8}
    #pp-collage-v1 .ppc-v1498-colour-group>strong{flex-basis:100%;font-size:14px;color:#17345c}
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-swatches{display:flex;flex-wrap:wrap;align-items:center;gap:8px;width:auto}
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-swatch{width:40px;height:38px;border-radius:10px;border:2px solid #d8e5f8;cursor:pointer;flex:none}
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-swatch[aria-pressed=true]{outline:2px solid #1464e9;outline-offset:2px}
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-custom-colour{margin-top:0!important;display:flex;align-items:center;gap:8px;font-size:13px}
    #pp-collage-v1 .ppc-v1498-colour-group input[type=color]{height:38px;width:42px;padding:2px;border:1px solid #b7cde8;border-radius:9px;background:white}
    #pp-collage-v1 .ppc-v1498-background-presets{display:flex;gap:8px;flex-wrap:wrap;width:100%;margin-top:7px}
    #pp-collage-v1 .ppc-v1498-background-presets button{display:inline-flex;align-items:center;gap:7px;font-size:12px;min-height:41px;padding:5px 10px}
    #pp-collage-v1 .ppc-v1498-background-presets button[aria-pressed=true]{border-color:#1265ee;box-shadow:0 0 0 2px #1265ee22}
    #pp-collage-v1 .ppc-v1498-background-presets i{display:inline-block;width:25px;height:25px;border:1px solid #a8b4c6;border-radius:5px;flex:none}
  `;
  pp1498ColourStyle.textContent += `
    /* V14.9.10 – large, labelled, keyboard-accessible visual cards */
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-swatches{display:grid!important;grid-template-columns:repeat(auto-fit,minmax(68px,1fr));width:100%!important;gap:9px!important}
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-swatch{display:flex!important;flex-direction:column;align-items:center;justify-content:center;gap:4px;width:100%!important;height:auto!important;min-height:83px!important;background:#fff!important;border:2px solid #d8e4f5!important;border-radius:13px!important;padding:8px 4px!important;color:#243c61!important;box-sizing:border-box!important}
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-swatch[aria-pressed=true]{border-color:#1265ee!important;background:#f0f6ff!important;box-shadow:0 0 0 2px #1265ee22!important;outline:none!important}
    #pp-collage-v1 .ppc-v1510-ink-preview{display:grid;place-items:center;width:40px;height:37px;border-radius:9px;border:1px solid #9aafc9;font-size:16px;font-weight:800;letter-spacing:-.5px}
    #pp-collage-v1 .ppc-v149-swatch small{font-size:11px;line-height:1.1;font-weight:700;color:#193c6a}
    #pp-collage-v1 .ppc-v1498-background-presets{display:grid!important;grid-template-columns:repeat(auto-fit,minmax(100px,1fr));gap:9px!important;align-items:stretch;margin-top:11px!important}
    #pp-collage-v1 .ppc-v1498-background-presets button{display:flex!important;flex-direction:column!important;align-items:stretch!important;gap:7px!important;min-height:104px!important;min-width:0;border:2px solid #d8e4f5!important;border-radius:13px!important;padding:7px!important;background:white!important;cursor:pointer;text-align:center;box-sizing:border-box;color:#153863;font-weight:750}
    #pp-collage-v1 .ppc-v1498-background-presets button[aria-pressed=true]{background:#f0f6ff!important;border-color:#1265ee!important;box-shadow:0 0 0 2px #1265ee22!important}
    #pp-collage-v1 .ppc-v1498-background-presets i{display:block!important;width:100%!important;height:57px!important;border:1px solid #d9e2f0!important;border-radius:8px!important;box-sizing:border-box}
    #pp-collage-v1 .ppc-v1498-background-presets span{font-size:12px;line-height:1.2;overflow-wrap:break-word}
    #pp-collage-v1 .ppc-v1498-background-presets button:focus-visible,#pp-collage-v1 .ppc-v149-swatch:focus-visible{outline:3px solid #1265ee!important;outline-offset:3px!important}
    @media(max-width:500px){#pp-collage-v1 .ppc-v1498-background-presets{grid-template-columns:repeat(3,minmax(0,1fr))!important}#pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-swatches{grid-template-columns:repeat(4,minmax(0,1fr))!important}}
  `;
  document.head.appendChild(pp1498ColourStyle);
  const ppV149CustomLabel=document.createElement('label');
  ppV149CustomLabel.className='ppc-v149-custom-colour';
  ppV149CustomLabel.textContent='Custom colour ';
  ppV149CustomLabel.style.cssText='';

  function ppV149UpdateSwatches(){const selected=String($('[data-colour]')?.value||'').toLowerCase();ppV149Swatches.querySelectorAll('button').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.ppcInk===selected)));}
  // Group with the existing title/size/colour settings, not the collage spacing.
  const ppV149InkPicker=$('[data-colour]');
  if(ppV149InkPicker){
    const settingsContainer=ppV149InkPicker.closest('label') || ppV149InkPicker;
    settingsContainer?.insertAdjacentElement('afterend',ppV149FontRow);
    ppV149FontRow.insertAdjacentElement('afterend',ppV149Colours);
    // Move the EXISTING bound colour input into the same section as swatches.
    // No duplicate state or colour field: saved-design code still reads [data-colour].
    ppV149CustomLabel.appendChild(ppV149InkPicker);
    const inkCaption=document.createElement('small');inkCaption.textContent='Custom colour';
    ppV149CustomLabel.textContent='';
    ppV149CustomLabel.append(ppV149InkPicker,inkCaption);
    ppV149Swatches.appendChild(ppV149CustomLabel);
    const oldColourField=settingsContainer;
    if(oldColourField!==ppV149InkPicker && !oldColourField.contains(ppV149Colours)) oldColourField.style.setProperty('display','none','important');
    // Remove the orphaned legacy Text Colour row that sat above Font Style.
    if(oldColourField && oldColourField!==ppV149InkPicker && oldColourField!==ppV149Colours) oldColourField.hidden=true;

    ppV149InkPicker.addEventListener('input',ppV149UpdateSwatches);
  }
  ppV149Font.addEventListener('change',()=>{pp1494SyncFont();safeRender();});
  function ppV149ShowTextControls(){
    const visible=Boolean(textOptionCheckbox?.checked);
    ppV149FontRow.style.display=visible?'flex':'none';
    ppV149Colours.style.display=visible?'flex':'none';
  }
  textOptionCheckbox?.addEventListener('change',ppV149ShowTextControls);
  ppV149ShowTextControls();
  ppV149UpdateSwatches();

  // =====================================================
  // TEXT PANEL
  // =====================================================

  // V14.9.3: Pure, deterministic wrapped-text layout used by BOTH preview and
  // server reference. All measurements are in a 900-wide design coordinate space.
  function pp1493Wrap(text, maxUnits) {
    const words=String(text||'').trim().split(/\s+/).filter(Boolean), rows=[];
    let line='';
    // Approximate glyph widths; actual font rendering differs slightly by platform.
    const units=t=>[...t].reduce((n,c)=>n+(c===' '?0.32:/[MW@#%]/.test(c)?0.92:/[ilI.,!|']/.test(c)?0.28:0.55),0);
    for(const original of words){
      let word=original;
      while(units(word)>maxUnits && word.length>1){
        let take=1;
        while(take<word.length && units(word.slice(0,take+1))<=maxUnits) take++;
        if(line){rows.push(line);line='';}
        rows.push(word.slice(0,take));word=word.slice(take);
      }
      if(!word)continue;
      const proposed=line?line+' '+word:word;
      if(line && units(proposed)>maxUnits){rows.push(line);line=word;}else line=proposed;
    }
    if(line)rows.push(line);
    return rows;
  }
  function pp1493TextGeometry(title,subtitle,position,size,widthPercent,ratio){
    const side=position==='left'||position==='right';
    const textWidth=side?Math.max(.20,Math.min(.34,Math.max(.20,widthPercent/100*.65))):1;
    const actualWidth=900*textWidth;
    // Maintain a readable font but don't let a long title overflow its box.
    let chosen=Math.min(size,64), lines=[], sub=[];
    const available=Math.max(24,actualWidth-28);
    for(;chosen>=11;chosen--){
      lines=pp1493Wrap(title,available/chosen);
      sub=pp1493Wrap(subtitle,available/(chosen*.57));
      if(lines.length<=4 && sub.length<=2)break;
    }
    const lineHeight=chosen*1.16;
    const required=lines.length*lineHeight+sub.length*chosen*.70+(lines.length&&sub.length?chosen*.18:0)+18;
    const heightRatio=Math.min(.34,Math.max(.075,required/(900/Math.max(.35,ratio))));
    return {font:chosen,titleLines:lines,subLines:sub,heightRatio,bandW:textWidth};
  }

  function textPanel(title, subtitle, geometry) {
    const node = make(
      "div",
      "ppc-copy"
    );

    node.style.background = 'transparent';
    node.style.boxShadow = 'none';
    node.style.color =
      $("[data-colour]").value;
    node.style.fontFamily = pp1494FontStack(ppV149CleanFont(ppV149Font.value));

    const size=geometry.font;
    node.style.padding='7px 10px';
    node.style.gap='2px';
    node.style.minWidth='0';
    node.style.minHeight='0';
    if(geometry.titleLines.length){
      const el=make('strong',null,geometry.titleLines.join('\n'));
      el.style.cssText='display:block;max-width:100%;white-space:pre-line;overflow-wrap:anywhere;line-height:1.16;font-weight:700;';
      el.style.setProperty('font-size',size+'px','important');
      pp1512ApplyTextAppearance(el);
      node.appendChild(el);
    }
    if(geometry.subLines.length){
      const el=make('span',null,geometry.subLines.join('\n'));
      el.style.cssText='display:block;max-width:100%;white-space:pre-line;overflow-wrap:anywhere;line-height:1.20;';
      el.style.setProperty('font-size',Math.max(9,Math.round(size*.57))+'px','important');
      pp1512ApplyTextAppearance(el);
      node.appendChild(el);
    }
    return node;
  }


  function pp1499MiddleCaptionGeometry(title, subtitle, preferredSize) {
    let chosen = Math.min(Number(preferredSize) || 24, 34);
    let titleLines = [], subLines = [];
    const available = 900 - 30;
    for (; chosen >= 10; chosen--) {
      titleLines = pp1493Wrap(title, available / chosen);
      subLines = pp1493Wrap(subtitle, available / Math.max(9, chosen * .56));
      if (titleLines.length <= 2 && subLines.length <= 1) break;
    }
    return { font: chosen, titleLines, subLines };
  }

  function pp1499CreateMiddleCaption(title, subtitle) {
    const geometry = pp1499MiddleCaptionGeometry(title, subtitle, Number($('[data-text-size]').value) || 24);
    const caption = make('div', 'pp1494-middle-caption');
    caption.style.background = 'transparent';
    caption.style.boxShadow = 'none';
    caption.style.color = $('[data-colour]').value;
    caption.style.fontFamily = pp1494FontStack(ppV149CleanFont(ppV149Font.value));
    if (geometry.titleLines.length) {
      const strong = make('strong', null, geometry.titleLines.join('\n'));
      strong.style.cssText = 'display:block;max-width:100%;white-space:pre-line;overflow-wrap:anywhere;line-height:1.1;font-weight:700;';
      strong.style.setProperty('font-size', geometry.font + 'px', 'important');
      pp1512ApplyTextAppearance(strong);
      caption.appendChild(strong);
    }
    if (geometry.subLines.length) {
      const span = make('span', null, geometry.subLines.join('\n'));
      span.style.cssText = 'display:block;max-width:100%;white-space:pre-line;overflow-wrap:anywhere;line-height:1.16;';
      span.style.setProperty('font-size', Math.max(9, Math.round(geometry.font * .56)) + 'px', 'important');
      pp1512ApplyTextAppearance(span);
      caption.appendChild(span);
    }
    return { caption, geometry };
  }

  // =====================================================
  // RENDER THE COMPLETE COLLAGE
  // =====================================================

  function render() {
    const board = $("[data-board]");
    board.replaceChildren();

    const photos = state.photos;
    const ratio = $("[data-ratio]").value;

    const [rw, rh] = ratio
      .split("/")
      .map(Number);

    // V14.9.15: Square canvases use the same full-bleed spacing colour,
    // transparent letterboxing and tile editing as landscape/portrait sizes.
    // Enforce the Shopify-selected physical format, including restored drafts.
    const pp14915IsSquare = selectedProduct && (
      selectedProduct.orientation === 'square' ||
      Number(selectedProduct.widthIn) === Number(selectedProduct.heightIn)
    );
    const pp14915Ratio = pp14915IsSquare ? '1 / 1' : ratio;
    board.style.aspectRatio = pp14915Ratio;
    pp1498ApplyBackgroundStyles(board);
    board.style.setProperty('background-color', pp14GetGapColour(), 'important');
    board.dataset.ppSquare = pp14915IsSquare ? '1' : '0';
    board.style.setProperty('--pp-square-gap', pp14GetGapColour());

    // V11.1.9: Size the PRESENTATION FRAME from the real print dimensions.
    // Orientation can change while restoring a saved design or choosing a canvas.
    // Do not modify photo pixels, photo data or the print geometry.
    const stage = board.closest('.ppc-canvas-stage');
    if (stage) {
      const physicalWidth = Number(selectedProduct?.widthIn);
      const physicalHeight = Number(selectedProduct?.heightIn);
      const orient = selectedProduct?.orientation;
      const actualRatio = physicalWidth > 0 && physicalHeight > 0
        ? (orient === 'square' || physicalWidth === physicalHeight ? 1 : orient === 'portrait' ? Math.min(physicalWidth, physicalHeight) / Math.max(physicalWidth, physicalHeight)
          : orient === 'square' ? 1 : Math.max(physicalWidth, physicalHeight) / Math.min(physicalWidth, physicalHeight))
        : (rw > 0 && rh > 0 ? rw / rh : 1.5);
      stage.style.setProperty('--ppc-stage-ratio', String(actualRatio));
      stage.classList.toggle('ppc-v159-square-stage', pp14915IsSquare);
    }

    board.style.setProperty(
      "--ppc-ratio",
      pp14915IsSquare ? 1 : (rw / rh)
    );

    $("[data-count]").textContent =
      photos.length + " photographs";

    $("[data-gap-value]").textContent =
      $("[data-gap]").value + "px";

    $("[data-text-size-value]").textContent =
      $("[data-text-size]").value + "px";

    const pp1499TextWidthValue = $('[data-text-width-value]');
    if (pp1499TextWidthValue && $('[data-text-width]')) {
      pp1499TextWidthValue.textContent = $('[data-text-width]').value + '%';
    }

    board.className = "ppc-board";

    if (
      root.dataset.previewExpanded === "1"
    ) {
      board.classList.add("ppc-expanded");
    }

    if (!photos.length) {
      board.appendChild(
        make(
          "div",
          "ppc-empty",
          "Your collage will appear here when you add photographs."
        )
      );

    } else {
      const title = textEnabled ? $("[data-title]").value.trim() : "";
      const subtitle = textEnabled ? $("[data-subtitle]").value.trim() : "";

      const position =
        $("[data-position]").value;

      // V14.8: Genuine reserved text band. Photos occupy ONLY the remaining
      // regions, so no photograph is hidden beneath text. Zones use the same
      // geometry and proportional photo allocation as the print renderer.
      if (v11Arrangement==='photo-middle' && photos.length>=5) {
        // One centre photo, four surrounding groups. The same coordinates and
        // photo allocation are used by the production proof renderer.
        const zones=[
          {x:0,y:0,w:1,h:.30},
          {x:0,y:.30,w:.30,h:.40},
          {x:.70,y:.30,w:.30,h:.40},
          {x:0,y:.70,w:1,h:.30}
        ];
        const groups=[[],[],[],[]];
        photos.slice(1).forEach((photo,index)=>groups[index%4].push(photo));
        // V14.9.16: apply the same spacing between the five Photo Middle zones
        // as between photographs within each zone. Keep the outer canvas edge
        // full-bleed; each neighbouring zone contributes half a gutter.
        const middleGap = Math.max(0, Number($('[data-gap]').value) || 0);
        const half = middleGap / 2;
        const bw = Math.max(1, board.clientWidth);
        const bh = Math.max(1, board.clientHeight);
        function middleZone(zone, index, node) {
          const edges = index === 0 ? [0,0,0,half] :
            index === 1 ? [0,half,half,half] :
            index === 2 ? [half,half,0,half] :
            index === 3 ? [0,half,0,0] : [half,half,half,half];
          const [leftPad,topPad,rightPad,bottomPad] = edges;
          const left = zone.x * bw + leftPad;
          const top = zone.y * bh + topPad;
          const width = Math.max(1, zone.w * bw - leftPad - rightPad);
          const height = Math.max(1, zone.h * bh - topPad - bottomPad);
          node.style.cssText = 'position:absolute;overflow:hidden;left:'+left+'px;top:'+top+
            'px;width:'+width+'px;height:'+height+'px;';
          return width / height;
        }
        zones.forEach((zone,index)=>{
          if(!groups[index].length)return;
          const region=make('div','ppc-v149-feature-zone');
          const zoneRatio=middleZone(zone,index,region);
          region.appendChild(renderGrid(groups[index],zoneRatio));
          board.appendChild(region);
        });
        const hero={x:.30,y:.30,w:.40,h:.40};
        const center=make('div','ppc-v149-feature-center');
        const centreRatio=middleZone(hero,4,center);
        // The centre is a display frame, not a second crop operation.
        // Preserve the customer's full saved crop, even after a portrait/landscape swap.
        center.appendChild(renderGrid([photos[0]],centreRatio,true));
        if(title || subtitle){
          const built=pp1499CreateMiddleCaption(title, subtitle);
          const caption=built.caption;
          // Centre-photo-only caption; never reserves or rearranges grid space.
          caption.style.maxHeight='42%';
          center.appendChild(caption);
          const capScale=(center.getBoundingClientRect().width||300)/900;
          caption.querySelectorAll('strong,span').forEach(part=>{
            const base=part.tagName==='STRONG'?built.geometry.font:Math.max(9,Math.round(built.geometry.font*.56));
            part.style.setProperty('font-size', Math.max(8, base*capScale)+'px', 'important');
          });
        }
        board.appendChild(center);
      } else if (!title && !subtitle) {
        board.appendChild(renderGrid(photos));
      } else {
        const position = $('[data-position]').value;
        const metrics=pp1493TextGeometry(title,subtitle,position,Number($('[data-text-size]').value),Number($('[data-text-width]').value),rw/rh);
        const side = position === 'left' || position === 'right';
        const bandW = metrics.bandW;
        const bandH = side ? 1 : metrics.heightRatio;
        let band, regions;
        if (position === 'top') {
          band={x:0,y:0,w:1,h:bandH};
          regions=[{x:0,y:bandH,w:1,h:1-bandH}];
        } else if (position === 'bottom') {
          band={x:0,y:1-bandH,w:1,h:bandH};
          regions=[{x:0,y:0,w:1,h:1-bandH}];
        } else if (position === 'left') {
          band={x:0,y:0,w:bandW,h:1};
          regions=[{x:bandW,y:0,w:1-bandW,h:1}];
        } else if (position === 'right') {
          band={x:1-bandW,y:0,w:bandW,h:1};
          regions=[{x:0,y:0,w:1-bandW,h:1}];
        } else {
          band={x:0,y:(1-bandH)/2,w:1,h:bandH};
          regions=[{x:0,y:0,w:1,h:(1-bandH)/2},
                   {x:0,y:(1+bandH)/2,w:1,h:(1-bandH)/2}];
        }
        const split=regions.length===2 ? Math.max(1,Math.min(photos.length-1,Math.ceil(photos.length/2))) : photos.length;
        const groups=regions.length===2 ? [photos.slice(0,split),photos.slice(split)] : [photos];
        regions.forEach((region,i)=>{
          if (!groups[i].length) return;
          const zone=make('div','ppc-v148-photo-zone');
          zone.style.cssText='position:absolute;overflow:hidden;'+
            'left:'+region.x*100+'%;top:'+region.y*100+'%;'+
            'width:'+region.w*100+'%;height:'+region.h*100+'%;';
          zone.appendChild(renderGrid(groups[i],(rw/rh)*(region.w/region.h)));
          board.appendChild(zone);
        });
        const label=textPanel(title,subtitle,metrics);
        label.style.cssText += ';position:absolute!important;'+
          'left:'+band.x*100+'%;top:'+band.y*100+'%;'+
          'width:'+band.w*100+'%;height:'+band.h*100+'%;'+
          'z-index:4;box-sizing:border-box;pointer-events:none!important;'+
          'display:flex!important;flex-direction:column!important;'+
          'align-items:center!important;justify-content:center!important;'+
          'text-align:center!important;overflow:hidden!important;';
        board.appendChild(label);
        // Scale the design-space font to the displayed board's actual width.
        // Keep a fixed design basis so fullscreen and normal preview agree.
        const visualScale=(board.getBoundingClientRect().width||900)/900;
        label.querySelectorAll('strong,span').forEach((part,i)=>{
          const font=part.tagName==='STRONG'?metrics.font:Math.max(9,metrics.font*.57);
          part.style.setProperty('font-size',Math.max(7,font*visualScale)+'px','important');
        });
      }

    }

    // =====================================================
    // PHOTO THUMBNAILS
    // =====================================================

    const thumbs = $("[data-thumbs]");
    thumbs.replaceChildren();

    photos.forEach((photo, index) => {
      const item = make(
        "div",
        "ppc-thumb"
      );

      const image = make("img");

      image.decoding = "async";
      image.loading = "lazy";
      image.src = displaySrc(photo);
      image.alt = photo.name;

      item.appendChild(image);

      // V12.2.2: Sideways photos can be corrected here, and Edit opens the
      // existing crop/enhance modal so customers do not need a separate step.
      const turns = make("div", "ppc-thumb-turn-controls");
      turns.setAttribute("role", "group");
      turns.setAttribute("aria-label", "Edit " + photo.name);

      for (const control of [
        { type: "rotate", caption: "↶", degrees: -90, label: "Turn left" },
        { type: "edit", caption: "Edit", label: "Edit photo" },
        { type: "rotate", caption: "↷", degrees: 90, label: "Turn right" }
      ]) {
        const button = make(
          "button",
          control.type === "edit" ? "ppc-thumb-edit" : "ppc-thumb-turn",
          control.caption
        );
        button.type = "button";
        button.title = control.label + " — " + photo.name;
        button.setAttribute("aria-label", control.label + " — " + photo.name);

        if (control.type === "edit") {
          button.addEventListener("click", event => {
            event.stopPropagation();
            openCrop(photo, button);
          });
        } else {
          button.addEventListener("click", async event => {
            event.stopPropagation();
            if (photo.userCropRect) {
              const proceed = await ppDialog({
                heading: "Rotate this photograph?",
                message: "Rotating will reset the crop for this photo. You can crop it again afterwards."
              });
              if (!proceed) return;
            }
            button.disabled = true;
            try {
              await rotatePhoto(photo, control.degrees);
              status("Photograph rotated. The saved print uses this orientation too.");
            } finally {
              button.disabled = false;
            }
          });
        }

        turns.appendChild(button);
      }
      item.appendChild(turns);

      const remove = make(
        "button",
        "ppc-thumb-remove",
        "×"
      );

      remove.type = "button";
      remove.title = "Remove " + photo.name;

      remove.setAttribute(
        "aria-label",
        "Remove " + photo.name
      );

      remove.addEventListener(
        "click",
        event => {
          event.stopPropagation();
          ppRemember();
          state.photos.splice(index, 1);
          ppPhotoLimitNoticeUpdate();

          state.original =
            state.original.filter(
              p => p !== photo
            );

          state.seen.delete(
            photo.fingerprint
          );

          // Keep the local object URLs until page exit for in-session Undo.
          safeRender();
        }
      );

      item.appendChild(remove);

      item.appendChild(
        make(
          "small",
          null,
          String(index + 1)
        )
      );

      thumbs.appendChild(item);
    });
    requestAnimationFrame(ppQualityUpdate);
  }


  // V12.1: Advisory print-quality estimator. Uses ORIGINAL pixel dimensions where
  // verified and measured photo tile dimensions, never the 1200/2400px preview.
  // It does not upload images, modify crops, or block saving/checkout.
  const ppQualityCss = document.createElement('style');
  ppQualityCss.textContent = `
    #pp-collage-v1 .ppc-quality-panel{border:1px solid #cbdcf3;background:#f4f8ff;border-radius:14px;padding:15px;margin:12px 0;color:#183253;font-size:14px;line-height:1.5}
    #pp-collage-v1 .ppc-quality-heading{display:flex;align-items:center;justify-content:space-between;gap:12px;font-weight:800;font-size:16px}
    #pp-collage-v1 .ppc-quality-list{margin:9px 0 0;padding-left:20px}
    #pp-collage-v1 .ppc-quality-list li{margin:4px 0}
    #pp-collage-v1 .ppc-quality-note{font-size:12px;color:#526782;margin:8px 0 0}
    #pp-collage-v1 .ppc-thumb{position:relative}
    #pp-collage-v1 .ppc-thumb .ppc-quality-chip{position:absolute;bottom:5px;left:5px;z-index:3;font-size:10px;font-weight:800;color:#fff;background:#ad3b19;padding:3px 6px;border-radius:6px;pointer-events:none}
    #pp-collage-v1 .ppc-thumb .ppc-quality-chip[data-level="fair"]{background:#986300}
    #pp-collage-v1 .ppc-thumb .ppc-quality-chip[data-level="unknown"]{background:#526782}
  `;
  document.head.appendChild(ppQualityCss);
  const ppQualityPanel = document.createElement('section');
  ppQualityPanel.className = 'ppc-quality-panel';
  ppQualityPanel.setAttribute('aria-label', 'Photograph print quality');
  ppQualityPanel.innerHTML = '<div class="ppc-quality-heading"><span>📷 Photo quality check</span><span data-quality-summary></span></div><p data-quality-message></p><ol class="ppc-quality-list" data-quality-list></ol><p class="ppc-quality-note">Estimate based on photo pixels, selected size and current crop. It cannot reliably detect blur or guarantee final print quality. Photos are not altered.</p>';
  const ppQualityTarget = $('[data-editor]')?.querySelector('.ppc-panel');
  if (ppQualityTarget) ppQualityTarget.appendChild(ppQualityPanel);
  let ppQualityScheduled = false;
  function ppQualityUpdate() {
    if (ppQualityScheduled) return;
    ppQualityScheduled = true;
    requestAnimationFrame(() => {
      ppQualityScheduled = false;
      if (!ppQualityPanel.isConnected) return;
      const summary = ppQualityPanel.querySelector('[data-quality-summary]');
      const message = ppQualityPanel.querySelector('[data-quality-message]');
      const list = ppQualityPanel.querySelector('[data-quality-list]');
      list.replaceChildren();
      const photos = state.photos;
      const thumbs = $$('[data-thumbs] .ppc-thumb');
      thumbs.forEach(t=>t.querySelector('.ppc-quality-chip')?.remove());
      const sizeW = Number(selectedProduct?.widthIn);
      const sizeH = Number(selectedProduct?.heightIn);
      const orient = selectedProduct?.orientation;
      if (!photos.length || !(sizeW>0 && sizeH>0)) {
        ppQualityPanel.hidden = true;
        return;
      }
      ppQualityPanel.hidden = false;
      const canvasW = orient === 'portrait' ? Math.min(sizeW,sizeH) : Math.max(sizeW,sizeH);
      const canvasH = orient === 'portrait' ? Math.max(sizeW,sizeH) : Math.min(sizeW,sizeH);
      const board = $('[data-board]');
      const boardRect = board?.getBoundingClientRect();
      if (!boardRect?.width || !boardRect.height) {
        summary.textContent = 'Checking…';
        message.textContent = 'Waiting for the collage preview to be sized.';
        return;
      }
      const tiles = [...board.querySelectorAll('[data-ppc-photo]')];
      let warn = 0, fair = 0, unknown = 0;
      for (let index=0; index<photos.length; index++) {
        const photo=photos[index];
        const tile=tiles.find(el=>el.ppcPhoto===photo);
        const originalW=Number(photo.originalWidth), originalH=Number(photo.originalHeight);
        let level='good', reason='';
        let ppi=0;
        if (!photo.qualityDimensionsVerified || !originalW || !originalH) {
          level='unknown'; reason='Original pixel dimensions not available for this saved photo.';
        } else if (!tile) {
          level='unknown'; reason='Photo position not ready for assessment.';
        } else {
          const trim=photo.trimRect || {w:1,h:1};
          const crop=photo.userCropRect || {w:1,h:1};
          const rotated = (Number(photo.rotation)||0)%180!==0;
          let pxW=originalW*Number(trim.w||1)*Number(crop.w||1);
          let pxH=originalH*Number(trim.h||1)*Number(crop.h||1);
          if(rotated) [pxW,pxH]=[pxH,pxW];
          const r=tile.getBoundingClientRect();
          const inchW=canvasW*(r.width/boardRect.width);
          const inchH=canvasH*(r.height/boardRect.height);
          // 'Fill spaces' crops to target aspect ratio, so take the limiting pixel axis.
          ppi=Math.min(pxW/Math.max(.001,inchW),pxH/Math.max(.001,inchH));
          if(ppi<100){level='warn';reason='Low estimated resolution ('+Math.round(ppi)+' PPI). May look soft or pixelated.';}
          else if(ppi<160){level='fair';reason='Moderate estimated resolution ('+Math.round(ppi)+' PPI). Check this photo closely.';}
        }
        if (level==='warn')warn++;
        if (level==='fair')fair++;
        if (level==='unknown')unknown++;
        if (level!=='good') {
          const li=document.createElement('li');
          li.textContent='Photo '+(index+1)+': '+reason;
          list.appendChild(li);
          const thumb=thumbs[index];
          if(thumb){
            const chip=document.createElement('span');
            chip.className='ppc-quality-chip';
            chip.dataset.level=level;
            chip.textContent=level==='warn'?'Low resolution':level==='fair'?'Check quality':'Not checked';
            thumb.appendChild(chip);
          }
        }
      }
      summary.textContent=(warn+fair+unknown)+' to review';
      message.textContent=warn ? warn+' photo(s) may print with reduced sharpness. Review flagged thumbnails below.' :
        fair ? fair+' photo(s) could benefit from higher-resolution originals.' :
        unknown ? 'Some saved photos cannot be checked until original dimensions are available.' :
        'All '+photos.length+' photographs have encouraging estimated resolution at their current sizes.';
      list.hidden=!list.childElementCount;
    });
  }

  window.addEventListener('resize', ppQualityUpdate, {passive:true});

  function ppRefreshV1243ReviewCopy() {
    try {
      root.querySelectorAll('[data-action="finish-orientation"]').forEach(button => {
        if (button.textContent.trim() !== 'Continue to collage') button.textContent = 'Continue to collage';
      });
      root.querySelectorAll('[data-action="finish-crop-review"], [data-action="back-to-rotation"]').forEach(button => {
        button.hidden = true;
      });

      const replacements = [
        ['First upload your photos, then check their rotation and cropping.', ''],
        ['First upload your photos, then review or edit any that need adjusting.', ''],
        ['Next: Check Cropping', 'Continue to collage'],
        ['Next check cropping', 'Continue to collage'],
        ['Check Cropping', 'Continue to collage'],
        ['Step 2: Check your photos and adjust any that need it.', 'Your collage is ready! Tap any photo or Edit to adjust it.']
      ];

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const original = node.nodeValue;
        if (!original || !original.trim()) continue;
        let updated = original;
        for (const [from, to] of replacements) {
          if (updated.includes(from)) updated = updated.split(from).join(to);
        }
        if (updated !== original) node.nodeValue = updated;
      }
    } catch (error) {
      console.warn('Copy refresh skipped', error);
    }
  }

  ppRefreshV1243ReviewCopy();
  new MutationObserver(() => ppRefreshV1243ReviewCopy()).observe(root, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // V14.9.48: remove redundant instructions and manual refresh control.
  function pp148RemoveObsoleteCopy(){
    root.querySelectorAll('button').forEach(button=>{
      if(/^refresh\s+preview$/i.test(button.textContent.trim())) button.remove();
    });
    root.querySelectorAll('p,small,div').forEach(node=>{
      if(node.children.length) return;
      const value=(node.textContent||'').trim().replace(/\s+/g,' ');
      if(/^click a photograph to crop it\.\s*drag a photo onto another to swap positions\.?(?:\s*original photographs are never modified\.?)?$/i.test(value) ||
         /^original photographs are never modified\.?$/i.test(value)) node.remove();
    });
  }
  pp148RemoveObsoleteCopy();
  // Ignore controls that are dynamically recreated during editor rendering.
  const pp148CleanupObserver=new MutationObserver(records=>{
    if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 &&
      (node.matches?.('button, p, small, div') || node.querySelector?.('button, p, small, div'))))){
      pp148RemoveObsoleteCopy();
    }
  });
  pp148CleanupObserver.observe(root,{childList:true,subtree:true});

  // =====================================================
  // MAIN INTERFACE BUTTON ACTIONS
  // =====================================================

  root.addEventListener(
    "click",
    async event => {
      const button = event.target.closest(
        "[data-action]"
      );

      if (!button) return;

      const action = button.dataset.action;

      if (action === "start") {
        $("[data-start]").hidden = true;
        $("[data-editor]").hidden = false;

        showReview("rotate");
        safeRender();
      }

      if (action === "previous") {
        // Handled by the My Designs integration
        // in Part 4.
        return;
      }

      if (action === "finish-orientation") {
        if (state.photos.length > ppPhotoLimitFor() && state.photos.length <= 100) {
          ppShowOverLimitChoice();
        } else {
          finishRotation();
        }
      }

      if (action === "back-to-rotation") {
        showReview("rotate");
      }

      if (action === "finish-crop-review") {
        finishCropReview();
      }

      if (action === "shuffle") {
        ppRemember();
        for (
          let i = state.photos.length - 1;
          i > 0;
          i--
        ) {
          const j = Math.floor(
            Math.random() * (i + 1)
          );

          [
            state.photos[i],
            state.photos[j]
          ] = [
            state.photos[j],
            state.photos[i]
          ];
        }

        v11Arrangement = "shuffle";
        v11RefreshButtons();
        safeRender();

        status(
          "Your photographs have been shuffled."
        );
      }

      if (action === "reset") {
        ppRemember();
        state.photos = [...state.original];
        v11Arrangement = "balanced";
        v11RefreshButtons();
        safeRender();

        status(
          "Original photo order restored."
        );
      }

      if (
        action === "clear" &&
        state.photos.length
      ) {
        if (await ppDialog({heading:"Remove all photographs?",message:"This will clear the photographs from this design.",destructive:true})) {
          // Ensure a new collage will not overwrite
          // an existing saved design.
          savedDesignId = null;
          savedDesignName = "";

          state.photos.forEach(release);

          ppClearHistory();
          state.photos = [];
          state.original = [];
          state.seen.clear();
          state.swapSelected = null;

          safeRender();
          showReview("rotate");

          status(
            "All photographs removed. Ready for a new collage."
          );
        }
      }

      if (action === "preview") {
        safeRender();
      }

      if (action === "preview-size") {
        const expanded =
          root.dataset.previewExpanded !== "1";

        root.dataset.previewExpanded =
          expanded ? "1" : "0";

        button.textContent =
          expanded
            ? "Fit to screen"
            : "Expand preview";

        safeRender();
      }
    }
  );

  // =====================================================
  // PHOTO UPLOAD INPUT
  // =====================================================

  // V13.7: lightweight bulk-read progress; background uploads are separately
  // verified by the existing save/checkout logic.
  const pp138UploadProgress=document.createElement('div');
  pp138UploadProgress.className='ppc-v138-upload-progress';
  pp138UploadProgress.hidden=true;
  pp138UploadProgress.setAttribute('role','status');
  pp138UploadProgress.setAttribute('aria-live','polite');
  const pp138ProgressText=document.createElement('span');
  const pp138ProgressBar=document.createElement('progress');
  pp138ProgressBar.max=100;pp138ProgressBar.value=0;
  pp138UploadProgress.append(pp138ProgressText,pp138ProgressBar);
  const pp138UploadInput=$('[data-upload]');
  pp138UploadInput?.insertAdjacentElement('afterend',pp138UploadProgress);
  // Visible next to the upload control, and updated as photos are added/removed.
  const ppPhotoLimitNotice=document.createElement('p');
  ppPhotoLimitNotice.setAttribute('role','status');
  ppPhotoLimitNotice.setAttribute('aria-live','polite');
  ppPhotoLimitNotice.style.cssText='margin:8px 0 12px;font-size:14px;font-weight:650;color:#173b67;line-height:1.45';
  pp138UploadProgress.insertAdjacentElement('afterend',ppPhotoLimitNotice);
  function ppPhotoLimitNoticeUpdate(){
    const count=state.photos.length;
    const max=ppPhotoLimitFor();
    ppPhotoLimitNotice.textContent=count > max
      ? `Recommended for this size: ${max} photos. You have ${count}. Consider removing ${count-max} photo${count-max===1?'':'s'} for clearer individual pictures, or proceed anyway.`
      : count === max
        ? `${count} photographs added — recommended number for this size.`
        : `Recommended for this size: ${max} photos • ${count} added`;
  }
  // V14.9.75: recommended photo limits are guidance, not mandatory.
  let ppLimitChoiceOpen=false;
  function ppShowOverLimitChoice(){
    if(ppLimitChoiceOpen || !selectedProduct || !state.reviewMode) return;
    const count=state.photos.length, advised=ppPhotoLimitFor();
    if(count<=advised) return;
    if(count>100){ ppCheckPhotoLimit(true); return; }
    ppLimitChoiceOpen=true;
    const shade=document.createElement('div');
    shade.id='ppc-photo-guidance-modal';
    shade.style.cssText='position:fixed;inset:0;z-index:2147483605;background:rgba(13,32,60,.7);display:flex;align-items:center;justify-content:center;padding:15px;box-sizing:border-box';
    const panel=document.createElement('section');
    panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-labelledby','ppc-photo-guidance-title');
    panel.style.cssText='width:min(470px,100%);max-height:90vh;overflow:auto;padding:24px;border-radius:18px;background:#fff;color:#17365b;box-shadow:0 16px 55px #0004;font-family:inherit;box-sizing:border-box';
    const heading=document.createElement('h2');heading.id='ppc-photo-guidance-title';heading.textContent='A tip for a lovely canvas';heading.style.cssText='margin:0 0 12px;font-size:23px;color:#17365b';
    const intro=document.createElement('p');intro.style.cssText='line-height:1.55;margin:0 0 18px';
    intro.textContent=`You've uploaded ${count} photographs. We recommend up to ${advised} for a ${selectedProduct.sizeLabel} canvas so each photo stays easy to see. You can remove ${count-advised}, choose a bigger canvas, or keep all your photos.`;
    const deleteBtn=document.createElement('button');deleteBtn.type='button';deleteBtn.textContent='Choose Which Photos to Delete';
    const proceedBtn=document.createElement('button');proceedBtn.type='button';proceedBtn.textContent='Proceed Anyway';
    [deleteBtn,proceedBtn].forEach(b=>{b.style.cssText='display:block;width:100%;min-height:48px;border-radius:10px;padding:11px 13px;font-size:15px;font-weight:700;font-family:inherit;cursor:pointer;margin:10px 0;box-sizing:border-box';});
    deleteBtn.style.background='#fff';deleteBtn.style.color='#1765cc';deleteBtn.style.border='2px solid #1765cc';
    proceedBtn.style.background='#1765cc';proceedBtn.style.color='#fff';proceedBtn.style.border='2px solid #1765cc';
    const foot=document.createElement('p');foot.textContent='All your uploaded photos are kept. More photos on a smaller canvas may mean smaller individual pictures.';foot.style.cssText='font-size:12px;line-height:1.45;color:#53647b;margin:12px 0 0';
    panel.append(heading,intro,deleteBtn,proceedBtn,foot);shade.append(panel);document.body.append(shade);
    const close=()=>{shade.remove();ppLimitChoiceOpen=false;};
    deleteBtn.addEventListener('click',()=>{close();renderOrientation();const section=$('[data-orientation]');section?.scrollIntoView({behavior:'smooth',block:'start'});});
    proceedBtn.addEventListener('click',async()=>{close();if(state.photos.length>100)return ppCheckPhotoLimit();await finishRotation();});
  }
  // V14.9.51: photo upload must be the prominent first step on all screens.
  const pp151Style=document.createElement('style');
  pp151Style.textContent=`
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload {
      display:flex!important;flex-direction:column!important;align-items:stretch!important;
      width:100%!important;max-width:100%!important;min-width:0!important;
      grid-column:1/-1!important;order:-50!important;gap:10px!important;
      padding:20px!important;margin:0 0 16px!important;border:2px solid #1765e9!important;
      background:#eff6ff!important;border-radius:17px!important;box-sizing:border-box!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload label,
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload .ppc-btn,
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload button {
      display:flex!important;align-items:center!important;justify-content:center!important;
      width:100%!important;max-width:100%!important;min-height:68px!important;
      padding:15px 18px!important;background:#1265ee!important;border:0!important;
      border-radius:13px!important;color:white!important;-webkit-text-fill-color:white!important;
      font-size:clamp(19px,4vw,24px)!important;font-weight:850!important;
      line-height:1.25!important;text-align:center!important;cursor:pointer!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload label *,
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload button * {
      color:white!important;-webkit-text-fill-color:white!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] [data-action="finish-orientation"] {
      display:flex!important;align-items:center!important;justify-content:center!important;
      width:100%!important;max-width:100%!important;min-height:54px!important;
      padding:13px 16px!important;text-align:center!important;
      background:#1265ee!important;color:white!important;-webkit-text-fill-color:white!important;
      font-size:17px!important;font-weight:800!important;border-radius:11px!important;
      margin:10px 0!important;order:-10!important;grid-column:1/-1!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] [data-action="finish-orientation"]:disabled {
      background:#98a9c0!important;opacity:1!important;cursor:not-allowed!important;
    }
    #pp-collage-v1 .ppc-v151-upload-reminder {color:#9b1c1c!important;background:#fff2f2!important;
      border:1px solid #f5b5b5!important;border-radius:9px!important;padding:10px 12px!important;
      margin:8px 0!important;font-size:14px!important;font-weight:750!important;line-height:1.4!important}
    #pp-collage-v1 button[style*="background:#1265ee"],
    #pp-collage-v1 .ppc-upgrade-open {color:#fff!important;-webkit-text-fill-color:#fff!important}
    @media(max-width:767px){
      #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload{padding:14px!important;margin-bottom:12px!important}
      #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload label,
      #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload button{min-height:70px!important}
    }
  `;
  document.head.appendChild(pp151Style);
  const pp151Orientation=$('[data-orientation]');
  const pp151UploadArea=$('[data-upload]')?.closest('.ppc-upload');
  if(pp151Orientation && pp151UploadArea && pp151Orientation.contains(pp151UploadArea)){
    pp151Orientation.prepend(pp151UploadArea);
  }
  const pp151Reminder=document.createElement('p');
  pp151Reminder.className='ppc-v151-upload-reminder';
  pp151Reminder.setAttribute('role','alert');
  pp151Reminder.textContent='Please add at least one photograph before continuing.';
  pp151Reminder.hidden=true;
  const pp151Continue=$('[data-action="finish-orientation"]');
  if(pp151Continue){
    if(pp151UploadArea && pp151Orientation?.contains(pp151Continue) && pp151Orientation.contains(pp151UploadArea)) {
      pp151UploadArea.insertAdjacentElement('afterend',pp151Continue);
    }
    pp151Continue.insertAdjacentElement('beforebegin',pp151Reminder);
    // Existing finishRotation() also validates the upload count. Keep that validation.
    pp151Continue.addEventListener('click',()=>{
      if(!state.photos.length){pp151Reminder.hidden=false;pp151UploadArea?.scrollIntoView({block:'center',behavior:'smooth'});}
    });
  }
  const pp151UpdateUploadState=()=>{
    if(state.photos.length)pp151Reminder.hidden=true;
    if(pp151Continue){
      pp151Continue.setAttribute('aria-disabled',String(!state.photos.length));
      pp151Continue.title=state.photos.length?'Check your uploaded photographs':'Add photographs before continuing';
    }
  };
  // Runs after gallery refresh and upload batches; do not disable click because the
  // existing handler provides the status message and our reminder.
  const pp151Gallery=$('[data-orientation-gallery]');
  if(pp151Gallery)new MutationObserver(pp151UpdateUploadState).observe(pp151Gallery,{childList:true});
  pp151UpdateUploadState();
  // V14.9.52: a single, welcoming photo-upload flow on desktop and mobile.
  const pp152Style=document.createElement('style');
  pp152Style.textContent=`
    #pp-collage-v1.ppc-review-mode [data-orientation]:not([hidden]) {
      display:flex!important;flex-direction:column!important;align-items:stretch!important;
      gap:14px!important;width:100%!important;max-width:1100px!important;
      margin:0 auto!important;box-sizing:border-box!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation]:not([hidden]) > * {
      width:100%!important;max-width:100%!important;min-width:0!important;
      box-sizing:border-box!important;float:none!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload {
      order:-100!important;display:flex!important;flex-direction:column!important;
      align-items:stretch!important;gap:12px!important;
      background:linear-gradient(135deg,#f0f7ff,#e8f4ff)!important;
      color:#16345a!important;border:2px solid #b5d5ff!important;
      border-radius:20px!important;padding:22px!important;margin:0!important;
      box-shadow:0 7px 22px rgba(26,99,183,.09)!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload::before {
      content:'Step 1 · Add your favourite photographs';display:block!important;
      color:#133765!important;font-weight:850!important;font-size:clamp(19px,2.2vw,25px)!important;
      line-height:1.3!important;text-align:left!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload label,
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload .ppc-btn,
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload button {
      background:#1165e9!important;color:#fff!important;-webkit-text-fill-color:#fff!important;
      border:2px solid #1165e9!important;border-radius:14px!important;
      min-height:76px!important;padding:18px 22px!important;
      box-shadow:0 5px 13px rgba(17,101,233,.18)!important;
      font-size:clamp(19px,3vw,25px)!important;font-weight:850!important;
      line-height:1.25!important;justify-content:center!important;text-align:center!important;
      width:100%!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload label *,
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload button * {
      color:#fff!important;-webkit-text-fill-color:#fff!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload p,
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload small,
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload [role=status] {
      color:#163d6b!important;-webkit-text-fill-color:#163d6b!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] [data-orientation-gallery] {
      order:5!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] [data-action="finish-orientation"] {
      order:20!important;margin:8px 0 0!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-v151-upload-reminder {
      order:19!important;
    }
    @media(max-width:767px){
      #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload {padding:17px!important;gap:10px!important;}
      #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload label,
      #pp-collage-v1.ppc-review-mode [data-orientation] .ppc-upload button {min-height:74px!important;}
    }
  `;
  document.head.appendChild(pp152Style);
  // Restore natural review order: upload, review heading/photos, then continue.
  // v14.9.51 had moved Continue directly after the upload area.
  if(pp151Continue && pp151Orientation && pp151Orientation.contains(pp151Continue)){
    const gallery=pp151Orientation.querySelector('[data-orientation-gallery]');
    if(gallery){gallery.insertAdjacentElement('afterend',pp151Continue);pp151Continue.insertAdjacentElement('beforebegin',pp151Reminder);}
    else pp151Orientation.append(pp151Continue);
  }
  // V14.9.54: upload belongs INSIDE the photo-review panel on every screen,
  // including the empty state (previous releases only styled descendants).
  if (pp151Orientation && pp151UploadArea && !pp151Orientation.contains(pp151UploadArea)) {
    pp151Orientation.prepend(pp151UploadArea);
  }
  // Ensure the review area's children are stacked, even in themes with a
  // two-column desktop parent grid.
  const pp154UploadStyle=document.createElement('style');
  pp154UploadStyle.textContent=`
    #pp-collage-v1.ppc-review-mode [data-orientation]:not([hidden]) {
      display:flex!important;flex-direction:column!important;align-items:stretch!important;
      width:min(1100px,100%)!important;max-width:100%!important;min-width:0!important;
      margin:0 auto!important;float:none!important;grid-column:1/-1!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] > .ppc-upload {
      display:flex!important;flex-direction:column!important;order:-100!important;
      width:100%!important;max-width:100%!important;box-sizing:border-box!important;
      background:linear-gradient(135deg,#f0f7ff,#e8f4ff)!important;
      border:2px solid #b5d5ff!important;color:#16345a!important;
      padding:20px!important;border-radius:18px!important;margin:0 0 10px!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] > .ppc-upload label,
    #pp-collage-v1.ppc-review-mode [data-orientation] > .ppc-upload button {
      background:#1165e9!important;color:#fff!important;-webkit-text-fill-color:#fff!important;
      border-radius:13px!important;font-weight:800!important;font-size:20px!important;
      min-height:70px!important;
    }
    #pp-collage-v1.ppc-review-mode [data-orientation] > .ppc-upload [role=status],
    #pp-collage-v1.ppc-review-mode [data-orientation] > .ppc-upload p{
      color:#163d6b!important;-webkit-text-fill-color:#163d6b!important;
    }
    #pp-collage-v1 .ppc-v143-preview-full-button,
    #pp-collage-v1 .ppc-v143-preview-full-button *,
    #pp-collage-v1 button[data-v14-full] {
      color:#fff!important;-webkit-text-fill-color:#fff!important;
      opacity:1!important;visibility:visible!important;
      text-shadow:none!important;font-size:14px!important;font-weight:800!important;
      background:#174fa4!important;border-color:#174fa4!important;
      min-width:145px!important;min-height:44px!important;
      display:inline-flex!important;align-items:center!important;justify-content:center!important;
      text-align:center!important;white-space:normal!important;
    }
    #pp-collage-v1.ppc-review-mode .ppc-v143-preview-full-button {display:none!important}
  `;
  document.head.appendChild(pp154UploadStyle);
  // V14.9.55: The desktop photo review had a 320px-wide parent grid column.
  // A wide gallery CSS rule alone cannot expand that parent's allocated track.
  // Put the review panels immediately below the designer heading on desktop,
  // and restore their native positions on mobile (without cloning DOM nodes).
  const pp155DesktopQuery=window.matchMedia('(min-width: 781px)');
  const pp155Heading=root.querySelector('.ppc-head');
  const pp155ReviewPanels=[root.querySelector('[data-orientation]'),root.querySelector('[data-crop-review]')].filter(Boolean);
  const pp155Origins=pp155ReviewPanels.map(panel=>{
    const marker=document.createComment('Perham review panel original position');
    panel.parentNode?.insertBefore(marker,panel);
    return {panel,marker};
  });
  function pp155ArrangeReviewPanels(){
    if(!pp155Heading)return;
    if(pp155DesktopQuery.matches){
      let after=pp155Heading;
      for(const {panel} of pp155Origins){after.insertAdjacentElement('afterend',panel);after=panel;}
    }else{
      for(const {panel,marker} of pp155Origins){
        if(marker.parentNode)marker.parentNode.insertBefore(panel,marker.nextSibling);
      }
    }
  }
  pp155ArrangeReviewPanels();
  pp155DesktopQuery.addEventListener?.('change',pp155ArrangeReviewPanels);
  const pp155DesktopGridCss=document.createElement('style');
  pp155DesktopGridCss.textContent=`
    @media(min-width:781px){
      #pp-collage-v1.ppc-review-mode [data-orientation]:not([hidden]),
      #pp-collage-v1.ppc-review-mode [data-crop-review]:not([hidden]){
        width:min(1180px,calc(100% - 32px))!important;
        max-width:1180px!important;
        min-width:0!important;
        margin:14px auto 30px!important;
        box-sizing:border-box!important;
        float:none!important;
        grid-column:1/-1!important;
      }
      #pp-collage-v1.ppc-review-mode [data-orientation-gallery],
      #pp-collage-v1.ppc-review-mode [data-crop-review-gallery]{
        display:grid!important;
        grid-template-columns:repeat(auto-fill,minmax(215px,1fr))!important;
        gap:16px!important;
        width:100%!important;
        max-width:100%!important;
        align-items:stretch!important;
      }
      #pp-collage-v1.ppc-review-mode [data-orientation-gallery] .ppc-orientation-item,
      #pp-collage-v1.ppc-review-mode [data-crop-review-gallery] .ppc-orientation-item{
        min-width:0!important;width:100%!important;max-width:100%!important;
        margin:0!important;box-sizing:border-box!important;
      }
      #pp-collage-v1.ppc-review-mode [data-orientation-gallery] .ppc-review-photo-frame,
      #pp-collage-v1.ppc-review-mode [data-crop-review-gallery] .ppc-review-photo-frame{
        width:100%!important;max-width:100%!important;
      }
    }
  `;
  document.head.appendChild(pp155DesktopGridCss);
  // V14.9.78: Defer painting individual offscreen review cards on mobile.
  // This does not affect original images, collage preview or print artwork.
  const pp78MobilePaint = document.createElement('style');
  pp78MobilePaint.textContent = `@media(max-width:767px){
    #pp-collage-v1 [data-orientation-gallery] .ppc-orientation-item,
    #pp-collage-v1 [data-crop-review-gallery] .ppc-orientation-item {
      content-visibility:auto; contain-intrinsic-size:auto 270px;
    }
  }`;
  document.head.appendChild(pp78MobilePaint);

  // V14.9.49: offer live Shopify canvas size upgrades without losing uploaded photos.
  // Photo records, private upload references, crops and layouts stay in memory.
  const ppUpgradeStyle=document.createElement('style');
  ppUpgradeStyle.textContent=`
    #pp-collage-v1 .ppc-upgrade-banner{border:1px solid #bdd6f8;background:#eff6ff;border-radius:12px;padding:13px;margin:10px 0 16px;color:#15395f;line-height:1.45}
    #pp-collage-v1 .ppc-upgrade-banner strong{display:block;margin-bottom:5px}
    #pp-collage-v1 .ppc-upgrade-open{appearance:none;background:#1265ee;color:#fff;border:0;border-radius:9px;min-height:43px;padding:10px 14px;font-weight:750;cursor:pointer;margin-top:10px;max-width:100%;white-space:normal}
    #ppc-upgrade-overlay{position:fixed;inset:0;z-index:2147483643;background:rgba(11,26,48,.73);display:none;justify-content:center;align-items:center;padding:12px;box-sizing:border-box}
    #ppc-upgrade-overlay *{box-sizing:border-box}
    #ppc-upgrade-overlay .ppc-upgrade-dialog{width:min(580px,100%);max-height:90dvh;overflow:auto;background:#fff;color:#172b4a;border-radius:18px;padding:20px;box-shadow:0 18px 65px rgba(0,0,0,.25)}
    #ppc-upgrade-overlay .ppc-upgrade-options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin:16px 0}
    #ppc-upgrade-overlay .ppc-upgrade-size{font:inherit;text-align:left;display:flex;flex-direction:column;gap:5px;border:2px solid #d6e4f3;border-radius:12px;padding:12px;background:#f5f9ff;color:#173b67;cursor:pointer;min-height:101px}
    #ppc-upgrade-overlay .ppc-upgrade-size strong{font-size:17px}
    #ppc-upgrade-overlay .ppc-upgrade-size span{font-size:13px}
    #ppc-upgrade-overlay .ppc-upgrade-size:disabled{opacity:.55;cursor:not-allowed;background:#f5f5f5}
    #ppc-upgrade-overlay .ppc-upgrade-size[data-current="true"]{border-color:#145bc3;background:#e6f1ff}
    #ppc-upgrade-overlay .ppc-upgrade-close{border:1px solid #b7c9df;background:#fff;border-radius:10px;min-height:42px;padding:8px 15px;cursor:pointer;font-weight:700}
    @media(max-width:390px){#ppc-upgrade-overlay .ppc-upgrade-dialog{padding:14px}#ppc-upgrade-overlay .ppc-upgrade-options{gap:7px}#ppc-upgrade-overlay .ppc-upgrade-size{padding:10px;min-height:110px}}
  `;
  document.head.appendChild(ppUpgradeStyle);
  const ppUpgradeBanner=document.createElement('div');
  ppUpgradeBanner.className='ppc-upgrade-banner';
  const ppUpgradeExplanation=document.createElement('div');
  const ppUpgradeButton=document.createElement('button');
  ppUpgradeButton.type='button';ppUpgradeButton.className='ppc-upgrade-open';
  ppUpgradeButton.textContent='Upgrade Canvas Size';
  ppUpgradeBanner.append(ppUpgradeExplanation,ppUpgradeButton);
  ppPhotoLimitNotice.insertAdjacentElement('afterend',ppUpgradeBanner);
  const ppUpgradeOverlay=document.createElement('div');
  ppUpgradeOverlay.id='ppc-upgrade-overlay';
  ppUpgradeOverlay.innerHTML=`<div class="ppc-upgrade-dialog" role="dialog" aria-modal="true" aria-labelledby="ppc-upgrade-heading">
    <h2 id="ppc-upgrade-heading" style="margin:0 0 8px;font-size:23px">Change your canvas size</h2>
    <p data-ppc-upgrade-intro style="font-size:14px;margin:0;color:#3d526c"></p>
    <p data-ppc-upgrade-status role="status" aria-live="polite" style="font-size:13px;margin:10px 0;color:#415874"></p>
    <div class="ppc-upgrade-options" data-ppc-upgrade-options></div>
    <p style="font-size:12px;color:#53647b">All your uploaded photographs and edits stay in your collage. Prices come directly from Shopify.</p>
    <button class="ppc-upgrade-close" type="button">Keep current size</button>
  </div>`;
  document.body.appendChild(ppUpgradeOverlay);
  const ppUpgradeOptions=ppUpgradeOverlay.querySelector('[data-ppc-upgrade-options]');
  const ppUpgradeStatus=ppUpgradeOverlay.querySelector('[data-ppc-upgrade-status]');
  function ppUpgradeClose(){ppUpgradeOverlay.style.display='none';}
  ppUpgradeOverlay.querySelector('.ppc-upgrade-close').addEventListener('click',ppUpgradeClose);
  ppUpgradeOverlay.addEventListener('click',event=>{if(event.target===ppUpgradeOverlay)ppUpgradeClose();});
  function ppUpgradeNoticeUpdate(){
    const amount=state.photos.length,max=ppPhotoLimitFor();
    ppUpgradeBanner.hidden=!(selectedProduct&&amount>max);
    if(!(selectedProduct&&amount>max)){ppUpgradeClose();return;}
    if(amount>max){
      ppUpgradeExplanation.textContent='For best visibility we recommend around '+max+' photos on this '+selectedProduct.sizeLabel+' canvas. You can remove '+(amount-max)+' photos, upgrade, or proceed with all '+amount+'.';
      ppUpgradeButton.textContent='Upgrade Canvas Size — Keep All Photos';
    }
  }
  async function ppUpgradeOpen(){
    if(!selectedProduct||state.photos.length<=ppPhotoLimitFor()||state.uploadBusy||state.faceScanBusy)return;
    ppUpgradeOverlay.style.display='flex';
    ppUpgradeOptions.replaceChildren();
    ppUpgradeStatus.textContent='Loading current canvas sizes and prices from Shopify…';
    ppUpgradeOverlay.querySelector('[data-ppc-upgrade-intro]').textContent=`You have ${state.photos.length} photographs. Your current canvas is ${selectedProduct.sizeLabel}. Choose a size below to keep them all.`;
    try{
      await ppLoadCanvasVariants();
      ppUpgradeStatus.textContent='Choose any available canvas that fits your photographs. Smaller sizes that cannot fit are shown but cannot be selected.';
      for(const item of ppCanvasVariants){
        const limit=ppPhotoLimitFor(item),fits=limit>=state.photos.length;
        const current=String(item.variant.id)===String(selectedProduct.variantId);
        const btn=document.createElement('button');btn.type='button';btn.className='ppc-upgrade-size';
        btn.dataset.current=String(current);
        btn.disabled=!item.variant.available||!fits||current;
        const label=document.createElement('strong');label.textContent=item.widthIn+' × '+item.heightIn+'″';
        const price=document.createElement('span');price.textContent=item.variant.available?ppFormatMoney(item.variant.price):'Unavailable';
        const allowance=document.createElement('span');allowance.textContent='Holds up to '+limit+' photos';
        const note=document.createElement('span');
        note.textContent=current?'✓ Current size':!item.variant.available?'Out of stock':!fits?'Needs '+(state.photos.length-limit)+' fewer photos':'✓ Fits all '+state.photos.length+' photos';
        note.style.fontWeight='700';
        btn.append(label,price,allowance,note);
        if(!btn.disabled)btn.addEventListener('click',()=>{
          const square=item.widthIn===item.heightIn;
          const oldOrientation=selectedProduct.orientation;
          selectedProduct={...selectedProduct,variantId:String(item.variant.id),sizeLabel:item.widthIn+'x'+item.heightIn+' inches',widthIn:item.widthIn,heightIn:item.heightIn,
            orientation:square?'square':oldOrientation==='portrait'?'portrait':'landscape',displayPrice:ppFormatMoney(item.variant.price)};
          // Preserve photos, original files, edits and order; only product/ratio change.
          ppUpdateProductSummary();ppPhotoLimitNoticeUpdate();ppUpgradeClose();
          if(state.reviewMode){if(state.reviewStep==='rotate')renderOrientation();else renderCropReview();}
          else safeRender();
          ppDraftSchedule();
          status('Canvas changed to '+selectedProduct.sizeLabel+'. All '+state.photos.length+' photographs have been kept.');
        });
        ppUpgradeOptions.appendChild(btn);
      }
    }catch(error){ppUpgradeStatus.textContent='Could not load canvas options. Please try again. '+error.message;}
  }
  ppUpgradeButton.addEventListener('click',ppUpgradeOpen);
  const ppPhotoLimitNoticeUpdateBeforeUpgrade=ppPhotoLimitNoticeUpdate;
  ppPhotoLimitNoticeUpdate=function(){ppPhotoLimitNoticeUpdateBeforeUpgrade();ppUpgradeNoticeUpdate();};
  ppPhotoLimitNoticeUpdate();
  function pp138ShowReadProgress(done,total){
    pp138UploadProgress.hidden=false;
    pp138ProgressBar.value=total?Math.round(done/total*100):0;
    pp138ProgressText.textContent='Preparing '+done+' of '+total+' photos… Original files upload securely in the background.';
  }

  $("[data-upload]").addEventListener(
    "change",
    event => {
      const files = [
        ...(event.target.files || [])
      ];

      event.target.value = "";

      if (files.length) {
        if (ppAwaitingInitialPhotoSelection) {
          ppAwaitingInitialPhotoSelection = false;
          ppHidePicker();
          $("[data-start]").hidden = true;
          $("[data-editor]").hidden = false;
          showReview("rotate");
          safeRender();
          status("Preparing photographs for your " + selectedProduct.sizeLabel + " canvas collage.");
        }
        addFiles(files).catch(error => showError(error, "photo upload"));
      } else {
        // When the native photo picker is cancelled, stay on the size picker.
        ppAwaitingInitialPhotoSelection = false;
      }
    }
  );

  // Hide obsolete crop-dialog swap button; drag-to-swap remains available on the collage.
  const legacySwapButton = $("[data-select-swap]");
  if (legacySwapButton) { legacySwapButton.hidden = true; legacySwapButton.setAttribute("aria-hidden", "true"); legacySwapButton.tabIndex = -1; }

  // =====================================================
  // SWAP BUTTON WITHIN PHOTO CROPPING
  // =====================================================

  $("[data-select-swap]").addEventListener(
    "click",
    () => {
      const photo = state.activeCrop;
      if (!photo) return;

      if (
        state.swapSelected &&
        state.swapSelected !== photo
      ) {
        const first =
          state.swapSelected;

        closeCrop();

        swapPhotos(
          first,
          photo
        );

      } else {
        state.swapSelected = photo;

        closeCrop();

        status(
          "Tap another photograph to swap positions."
        );
      }
    }
  );

  // =====================================================
  // LIVE EDITOR SETTINGS
  // =====================================================

  for (const selector of [
    "[data-title]",
    "[data-subtitle]",
    "[data-ratio]",
    "[data-position]",
    "[data-fit]",
    "[data-gap]",
    "[data-colour]",
    "[data-bg]",
    "[data-text-size]",
    "[data-text-width]"
  ]) {
    $(selector).addEventListener(
      "input",
      safeRender
    );
  }

  // V13.1 — Same-device draft recovery (browser IndexedDB).
  // The original File/Blob objects and editable metadata remain on this device.
  // This is a convenience feature, NOT a guaranteed account/cloud backup.
  const ppDraftDbName = 'perham-collage-drafts-v1';
  const ppDraftKey = 'active-collage';
  const ppDraftMaxAge = 7 * 24 * 60 * 60 * 1000;
  const ppDraftMaxBytes = 90 * 1024 * 1024;
  let ppDraftRestoring = false;
  let ppDraftSaveTimer = null;
  let ppDraftSaveBusy = false;
  let ppDraftQueued = false;
  let ppDraftLastSignature = '';
  let ppDraftLastStatus = '';

  const ppDraftStyle = document.createElement('style');
  ppDraftStyle.textContent = `
    #pp-collage-v1 .ppc-local-draft {border:1px solid #c9d9ef;background:#f2f7ff;color:#17375f;padding:12px 14px;border-radius:13px;margin:12px 0;line-height:1.45;font-size:14px}
    #pp-collage-v1 .ppc-local-draft strong {display:block;font-size:15px;margin-bottom:3px}
    #pp-collage-v1 .ppc-local-draft-actions {display:flex;gap:8px;margin-top:9px;flex-wrap:wrap}
    #pp-collage-v1 .ppc-local-draft button {min-height:40px;border-radius:8px;padding:7px 12px;background:#135fe6;border:1px solid #135fe6;color:#fff;font-weight:700;cursor:pointer}
    #pp-collage-v1 .ppc-local-draft button.ppc-draft-discard {background:white;color:#17375f;border-color:#b6c9e4}
    #pp-collage-v1 .ppc-draft-indicator {font-size:12px;color:#4b647e;margin:5px 0 10px;min-height:18px}
  `;
  document.head.appendChild(ppDraftStyle);
  const ppDraftBanner = make('div', 'ppc-local-draft');
  ppDraftBanner.hidden = true;
  const ppDraftStart = $('[data-start]');
  const ppDraftEditor = $('[data-editor]');
  if (ppDraftStart) ppDraftStart.prepend(ppDraftBanner);
  const ppDraftIndicator = make('p','ppc-draft-indicator');
  ppDraftIndicator.setAttribute('role','status');
  if (ppDraftEditor) ppDraftEditor.prepend(ppDraftIndicator);

  function ppDraftDb() {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) return reject(new Error('Browser draft storage is unavailable'));
      const request = indexedDB.open(ppDraftDbName, 1);
      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains('drafts')) db.createObjectStore('drafts');
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error || new Error('Draft storage unavailable'));
    });
  }
  async function ppDraftWrite(value) {
    const db = await ppDraftDb();
    try {
      await new Promise((resolve, reject) => {
        const tx = db.transaction('drafts','readwrite');
        tx.objectStore('drafts').put(value,ppDraftKey);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error || new Error('Draft save failed'));
        tx.onabort = () => reject(tx.error || new Error('Draft save aborted'));
      });
    } finally { db.close(); }
  }
  async function ppDraftRead() {
    const db = await ppDraftDb();
    try {
      return await new Promise((resolve, reject) => {
        const tx=db.transaction('drafts','readonly');
        const request=tx.objectStore('drafts').get(ppDraftKey);
        request.onsuccess=()=>resolve(request.result||null);
        request.onerror=()=>reject(request.error);
      });
    } finally { db.close(); }
  }
  async function ppDraftRemove() {
    const db=await ppDraftDb();
    try {
      await new Promise((resolve,reject)=>{
        const tx=db.transaction('drafts','readwrite');
        tx.objectStore('drafts').delete(ppDraftKey);
        tx.oncomplete=()=>resolve();
        tx.onerror=()=>reject(tx.error);
      });
    } finally { db.close(); }
  }

  function ppDraftBuild() {
    if (!selectedProduct || !state.photos.length || state.uploadBusy || state.activeCrop || ppDraftRestoring) return null;
    const original = state.original.filter(p=>state.photos.includes(p));
    const photos = original.length ? original : state.photos;
    if (photos.some(p=>!(p.file instanceof Blob))) return null;
    const totalBytes = photos.reduce((n,p)=>n+(p.file?.size||0),0);
    if (totalBytes > ppDraftMaxBytes) {
      ppDraftIndicator.textContent='This collage is too large for browser draft recovery. Use Save My Collage for a cloud-saved design.';
      return null;
    }
    return {
      version:1, updated:Date.now(), product:{...selectedProduct},
      settings:collageSettings(), arrangement:v11Arrangement,
      savedDesignId, savedDesignName,
      order:state.photos.map(p=>p.fingerprint),
      originals:photos.map(p=>({
        fingerprint:p.fingerprint, name:p.name, file:p.file,
        width:p.originalWidth||0,height:p.originalHeight||0,
        remoteId:p.remoteId||null,
        rotation:p.rotation||0,
        trim:p.trimRect?{...p.trimRect}:null,
        crop:p.userCropRect?{...p.userCropRect}:null,
        adjustments:ppNormalAdjust(p.adjustments)
      }))
    };
  }
  function ppDraftSignature(draft) {
    return JSON.stringify({product:draft.product,settings:draft.settings,
      arrangement:draft.arrangement,order:draft.order,
      originals:draft.originals.map(({file,...metadata})=>metadata),
      savedDesignId:draft.savedDesignId,savedDesignName:draft.savedDesignName});
  }
  async function ppDraftSave() {
    if (ppDraftRestoring || ppDraftSaveBusy) { ppDraftQueued=true; return; }
    const snapshot=ppDraftBuild();
    if (!snapshot) return;
    const signature=ppDraftSignature(snapshot);
    if (signature===ppDraftLastSignature) return;
    ppDraftSaveBusy=true;
    try {
      await ppDraftWrite(snapshot);
      ppDraftLastSignature=signature;
      ppDraftLastStatus='Draft saved on this device';
      ppDraftIndicator.textContent=ppDraftLastStatus;
    } catch (error) {
      ppDraftIndicator.textContent='Automatic draft recovery is unavailable in this browser. Use Save My Collage.';
      console.warn('Local collage draft save failed',error);
    } finally {
      ppDraftSaveBusy=false;
      if(ppDraftQueued){ppDraftQueued=false;ppDraftSchedule();}
    }
  }
  function ppDraftSchedule() {
    if (ppDraftRestoring) return;
    if (ppDraftSaveTimer) clearTimeout(ppDraftSaveTimer);
    ppDraftSaveTimer=setTimeout(()=>{ppDraftSaveTimer=null;ppDraftSave();},1500);
  }

  async function ppDraftRestore(data) {
    if(!data || !Array.isArray(data.originals) || !data.originals.length)return;
    ppDraftRestoring=true;
    const restored=[];
    try {
      ppDraftIndicator.textContent='Restoring your local collage draft…';
      for(const record of data.originals){
        if(!(record.file instanceof Blob))throw new Error('One or more local photographs are unavailable');
        const url=URL.createObjectURL(record.file);
        const img=await loadImage(url);
        const photo={name:record.name||record.file.name||'Photograph',file:record.file,url,
          fingerprint:record.fingerprint||record.name,
          rotation:record.rotation||0,aspect:img.naturalWidth/img.naturalHeight,
          originalWidth:record.width||img.naturalWidth,originalHeight:record.height||img.naturalHeight,
          qualityDimensionsVerified:true,previewUrl:null,userCropUrl:null,userCropRect:null,
          trimRect:record.trim||null,adjustments:ppNormalAdjust(record.adjustments),sequence:0,
          remoteId:record.remoteId||null};
        restored.push(photo);
        await rebuildPreview(photo,false);
        if(record.crop)await ppRestoreCrop(photo,record.crop);
      }
      const byFingerprint=new Map(restored.map(p=>[p.fingerprint,p]));
      const ordered=data.order.map(key=>byFingerprint.get(key)).filter(Boolean);
      if(ordered.length!==restored.length)throw new Error('Draft photograph order is incomplete');
      state.photos=ordered;
      state.original=restored;
      state.seen=new Set(restored.map(p=>p.fingerprint));
      state.uploadBusy=false;
      state.reviewMode=false;
      state.activeCrop=null;
      state.swapSelected=null;
      root.classList.remove('ppc-review-mode');
      selectedProduct=data.product||null;
      if(data.settings?.ratio) ppSetRatio(String(data.settings.ratio));
      restoreCollageSettings(data.settings||{});
      ppUpdateProductSummary();
      v11Arrangement=data.arrangement||'balanced';
      v11RefreshButtons();
      savedDesignId=data.savedDesignId||null;
      savedDesignName=data.savedDesignName||'';
      $('[data-start]').hidden=true;
      $('[data-editor]').hidden=false;
      $('[data-orientation]').hidden=true;
      $('[data-crop-review]').hidden=true;
      ppDraftBanner.hidden=true;
      ppClearHistory();
      safeRender();
      ppShowTouchTip();
      // Existing private R2 upload flow retries photos that have no remote ID.
      for(const photo of restored) if(!photo.remoteId)uploadPhotoInBackground(photo);
      ppDraftIndicator.textContent='Local draft restored. Save My Collage for an account-backed copy.';
      ppDraftLastSignature=ppDraftSignature(ppDraftBuild()||data);
      status('Your draft has been restored. Continue editing your collage.');
    } catch(error) {
      for(const photo of restored)release(photo);
      ppDraftIndicator.textContent='Unable to restore local draft: '+error.message;
      throw error;
    } finally{ppDraftRestoring=false;}
  }
  async function ppDraftPrompt() {
    try {
      const data=await ppDraftRead();
      if(!data || !data.updated)return;
      if(Date.now()-data.updated>ppDraftMaxAge){await ppDraftRemove();return;}
      if(!ppDraftStart || !ppDraftStart.isConnected)return;
      ppDraftBanner.replaceChildren();
      const title=make('strong',null,'Continue your previous collage?');
      const desc=make('span',null,(data.originals?.length||0)+' photos saved locally on this device. Local drafts are not cloud backups and may be cleared by your browser.');
      const actions=make('div','ppc-local-draft-actions');
      const resume=make('button',null,'Resume draft');
      const discard=make('button','ppc-draft-discard','Discard draft');
      resume.type=discard.type='button';
      resume.addEventListener('click',async()=>{
        resume.disabled=true;
        try{await ppDraftRestore(data);}catch(error){resume.disabled=false;}
      });
      discard.addEventListener('click',async()=>{
        discard.disabled=true;
        try{await ppDraftRemove();ppDraftBanner.hidden=true;ppDraftLastSignature='';}
        catch(error){discard.disabled=false;}
      });
      actions.append(resume,discard);
      ppDraftBanner.append(title,desc,actions);
      ppDraftBanner.hidden=false;
    }catch(error){console.warn('Draft recovery check skipped',error);}
  }

  // Watch meaningful editor changes. Signatures prevent redundant writes and
  // the draft is not saved during half-finished crop or upload operations.
  root.addEventListener('input',ppDraftSchedule,{passive:true});
  root.addEventListener('change',ppDraftSchedule,{passive:true});
  root.addEventListener('click',ppDraftSchedule,{passive:true});
  const ppDraftWatcher=new MutationObserver(ppDraftSchedule);
  const ppDraftBoard=$('[data-board]');
  if(ppDraftBoard)ppDraftWatcher.observe(ppDraftBoard,{childList:true,subtree:true});
  window.addEventListener('pagehide',()=>{
    // Best effort: drafts are normally saved earlier, before navigation.
    if(ppDraftSaveTimer){clearTimeout(ppDraftSaveTimer);ppDraftSaveTimer=null;ppDraftSave();}
  });
  ppDraftPrompt();

  // =====================================================
  // V13.9: FIRST-VISIT WALKTHROUGH + REOPEN HELP
  // UI-only: does not alter layout, original uploads, saved artwork or checkout.
  // =====================================================
  (function ppSetupCollageGuide() {
    const GUIDE_KEY = 'perham_collage_guide_dismissed_v1';
    const guideSteps = [
      { title: 'Choose your product options', description: 'Select the style or size you would like to order. Your collage preview will match your selection.', symbol: '1' },
      { title: 'Add your favourite photographs', description: 'Upload photos from your phone or computer. You can upload more photos or replace an individual picture later.', symbol: '2' },
      { title: 'Make it your own', description: 'Choose a layout, move photos around and tap an individual photo to crop, zoom or enhance it.', symbol: '3' },
      { title: 'Review and add to basket', description: 'Check your finished collage, then save the design and add it to your Shopify basket.', symbol: '4' }
    ];
    const guideStyle = document.createElement('style');
    guideStyle.textContent = `
      #pp-collage-v1 .ppc-guide-help {display:inline-flex;align-items:center;justify-content:center;gap:7px;min-height:38px;padding:8px 12px;border:1px solid #b9d1f0;border-radius:999px;background:#fff;color:#174476;font-weight:750;font-size:13px;cursor:pointer;box-shadow:0 2px 10px rgba(18,64,119,.06);}
      #pp-collage-v1 .ppc-head .ppc-guide-help {display:flex;width:max-content;max-width:100%;margin:12px auto 14px;text-align:center;}
      #pp-collage-v1 .ppc-guide-help:focus-visible {outline:3px solid #2368d9;outline-offset:2px;}
      .ppc-guide-overlay {position:fixed;inset:0;z-index:2147483000;background:rgba(9,28,49,.68);display:flex;align-items:center;justify-content:center;padding:16px;overscroll-behavior:contain;}
      .ppc-guide-overlay[hidden] {display:none!important;}
      .ppc-guide-dialog {box-sizing:border-box;width:min(100%,490px);max-height:min(90vh,760px);overflow:auto;border-radius:20px;background:white;box-shadow:0 22px 75px rgba(0,0,0,.28);color:#183653;padding:24px;position:relative;font-family:inherit;}
      .ppc-guide-dialog * {box-sizing:border-box;}
      .ppc-guide-close {position:absolute;right:15px;top:13px;border:0;border-radius:50%;width:34px;height:34px;background:#eef4fc;color:#244262;font-size:24px;line-height:1;cursor:pointer;}
      .ppc-guide-headline {font-size:23px;font-weight:850;line-height:1.2;margin:4px 30px 8px 0;color:#143960;}
      .ppc-guide-subtitle {font-size:14px;line-height:1.6;color:#54687d;margin:0 0 19px;}
      .ppc-guide-steps {display:grid;gap:11px;margin:0 0 19px;padding:0;list-style:none;}
      .ppc-guide-steps li {display:flex;gap:12px;padding:13px;background:#f2f7ff;border:1px solid #deebfc;border-radius:13px;}
      .ppc-guide-stepnum {flex:0 0 30px;width:30px;height:30px;display:grid;place-items:center;background:#1d65d8;border-radius:50%;color:white;font-weight:850;}
      .ppc-guide-steptext strong {display:block;font-size:14px;margin-bottom:3px;}
      .ppc-guide-steptext span {display:block;color:#52667c;font-size:13px;line-height:1.5;}
      .ppc-guide-remember {display:flex;align-items:center;gap:9px;font-size:13px;color:#38506a;margin:0 0 17px;cursor:pointer;}
      .ppc-guide-remember input {width:17px;height:17px;accent-color:#1d65d8;flex:none;}
      .ppc-guide-start {width:100%;min-height:46px;border:0;border-radius:11px;background:#1664d9;color:#fff;font-weight:800;font-size:15px;cursor:pointer;}
      .ppc-guide-start:hover {background:#1155bf;}
      .ppc-guide-start:focus-visible,.ppc-guide-close:focus-visible {outline:3px solid #ffba49;outline-offset:2px;}
      @media(max-width:640px){.ppc-guide-dialog{padding:19px;max-height:93dvh}.ppc-guide-headline{font-size:21px}.ppc-guide-steps li{padding:11px}}
    `;
    document.head.appendChild(guideStyle);

    const help = document.createElement('button');
    help.type = 'button';
    help.className = 'ppc-guide-help';
    help.textContent = 'ⓘ How to create your collage';
    help.setAttribute('aria-haspopup','dialog');
    // Center the help link immediately beneath the welcome heading.
    // If a theme customisation changes the heading, place it above the welcome cards.
    const welcomeHeading = root.querySelector('.ppc-head h2') || root.querySelector('.ppc-head h1');
    if (welcomeHeading) {
      welcomeHeading.insertAdjacentElement('afterend', help);
    } else {
      const welcomeCards = root.querySelector('[data-start]');
      if (welcomeCards && welcomeCards.parentNode) {
        welcomeCards.parentNode.insertBefore(help, welcomeCards);
      } else {
        root.insertBefore(help, root.firstChild);
      }
      help.style.display = 'flex';
      help.style.width = 'max-content';
      help.style.margin = '12px auto 14px';
    }

    const overlay = document.createElement('div');
    overlay.className = 'ppc-guide-overlay';
    overlay.hidden = true;
    overlay.setAttribute('role','presentation');
    const dialog = document.createElement('section');
    dialog.className = 'ppc-guide-dialog';
    dialog.setAttribute('role','dialog');
    dialog.setAttribute('aria-modal','true');
    dialog.setAttribute('aria-labelledby','ppc-guide-heading');
    dialog.setAttribute('aria-describedby','ppc-guide-intro');
    const close = document.createElement('button');
    close.type = 'button';
    close.className='ppc-guide-close';
    close.textContent='×';
    close.setAttribute('aria-label','Close collage guide');
    const heading = document.createElement('h2');
    heading.id='ppc-guide-heading';
    heading.className='ppc-guide-headline';
    heading.textContent='Create your perfect photo collage 💙';
    const intro=document.createElement('p');
    intro.id='ppc-guide-intro';
    intro.className='ppc-guide-subtitle';
    intro.textContent='It only takes four simple steps to create your personalised photo collage.';
    const steps=document.createElement('ol');
    steps.className='ppc-guide-steps';
    guideSteps.forEach(item=>{
      const li=document.createElement('li');
      const number=document.createElement('span');
      number.className='ppc-guide-stepnum';
      number.textContent=item.symbol;
      number.setAttribute('aria-hidden','true');
      const info=document.createElement('div');
      info.className='ppc-guide-steptext';
      const title=document.createElement('strong');
      title.textContent=item.title;
      const description=document.createElement('span');
      description.textContent=item.description;
      info.append(title,description);
      li.append(number,info);
      steps.appendChild(li);
    });
    const start=document.createElement('button');
    start.type='button';
    start.className='ppc-guide-start';
    start.textContent="Let's create my collage →";
    dialog.append(close,heading,intro,steps,start);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    let lastFocus=null;
    function openGuide(){
      lastFocus=document.activeElement;
      overlay.hidden=false;
      close.focus();
    }
    function dismissGuide(){
      try{localStorage.setItem(GUIDE_KEY,'1');}catch(e){ /* Private browsing */ }
      overlay.hidden=true;
      if(lastFocus && lastFocus.isConnected && typeof lastFocus.focus==='function')lastFocus.focus();
    }
    help.addEventListener('click',openGuide);
    close.addEventListener('click',dismissGuide);
    start.addEventListener('click',dismissGuide);
    overlay.addEventListener('click',event=>{if(event.target===overlay)dismissGuide();});
    overlay.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();dismissGuide();}
      if(event.key==='Tab'){
        const controls=[close,start];
        const idx=controls.indexOf(document.activeElement);
        if(event.shiftKey && idx===0){event.preventDefault();start.focus();}
        else if(!event.shiftKey && idx===1){event.preventDefault();close.focus();}
      }
    });
    try{
      if(localStorage.getItem(GUIDE_KEY)!=='1'){
        // Give existing draft-recovery prompts priority on page load.
        setTimeout(()=>{
          if(!document.documentElement.contains(root))return;
          const draft=root.querySelector('.ppc-local-draft:not([hidden])');
          if(!draft)openGuide();
        },900);
      }
    }catch(e){/* Storage blocked: guide remains available through the help button. */}
  })();

  // =====================================================
  // CLEAN UP BROWSER PHOTO PREVIEWS
  // =====================================================

  window.addEventListener(
    "pagehide",
    () => {
      state.photos.forEach(release);
    },
    { once: true }
  );


  // V14.9.15: Square size artwork must stay square in both views; the
  // outer presentation frame remains white, never part of the print design.
  const pp14915SquareStyle = document.createElement('style');
  pp14915SquareStyle.textContent = `
    #pp-collage-v1 [data-board][data-pp-square="1"] {
      aspect-ratio:1 / 1!important;
      background-color:var(--pp-square-gap,#ffffff);
      overflow:hidden!important;
    }
  `;
  document.head.appendChild(pp14915SquareStyle);
  // Built-in print-safe decorative presets. Saved as enum, never arbitrary CSS/URLs.
  const pp1498Backgrounds=['solid'];
  function pp1498GetBackground(){return 'solid';}
  function pp1498BackgroundCSS(){return 'none';}
  function pp1498ApplyBackgroundStyles(node){
    if(!node) return;
    node.style.backgroundColor = pp14GetGapColour();
    node.style.backgroundImage = pp1498BackgroundCSS();
    node.style.backgroundSize = '100% 100%';
    node.style.backgroundRepeat = 'repeat';
    node.style.backgroundPosition = 'center';
  }
  function pp1498SetBackground(name, redraw=true){
    window.__pp1498Background='solid';
    root.querySelectorAll('[data-pp1498-background]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.pp1498Background===pp1498GetBackground())));
    if(redraw)safeRender();
  }

  function pp1512FoilKind(value){
    const v=String(value||'').trim().toLowerCase();
    if(v==='#d4af37') return 'gold';
    if(v==='#c0c0c0') return 'silver';
    if(v==='#8b5a2b') return 'bronze';
    return '';
  }
  function pp1512FoilGradient(kind){
    const palettes={
      gold:['#4b3100','#9c6c05','#e3b83b','#fff3b1','#b37c08','#ffe28a','#7d5104'],
      silver:['#363f4b','#89929e','#e6ecf2','#ffffff','#929dab','#d4dce5','#505a66'],
      bronze:['#472416','#8a4929','#c88757','#f9d2a6','#a15b32','#dfa374','#61331f']
    };
    const p=palettes[kind];
    if(!p)return 'none';
    // Fine scratches and small, bright highlight streaks imitate printed foil.
    return `repeating-linear-gradient(104deg,transparent 0px,rgba(255,255,255,.13) 1px,transparent 2px,transparent 7px),linear-gradient(112deg,${p[0]} 0%,${p[1]} 13%,${p[2]} 26%,${p[3]} 32%,${p[4]} 43%,${p[5]} 53%,${p[1]} 67%,${p[3]} 74%,${p[6]} 100%)`;
  }
  function pp1512ApplyTextAppearance(node){
    if(!node) return;
    const colour=String($('[data-colour]')?.value||'#171717');
    const foil=pp1512FoilKind(colour);
    node.style.removeProperty('background-image');
    node.style.removeProperty('background-size');
    node.style.removeProperty('background-position');
    node.style.removeProperty('background-repeat');
    node.style.removeProperty('-webkit-background-clip');
    node.style.removeProperty('background-clip');
    node.style.removeProperty('-webkit-text-fill-color');
    node.style.removeProperty('filter');
    node.style.removeProperty('text-shadow');
    node.style.removeProperty('letter-spacing');
    if(foil){
      node.style.backgroundImage=pp1512FoilGradient(foil);
      node.style.backgroundSize='95px 95px, 190% 100%';
      node.style.backgroundPosition='center center, center center';
      node.style.backgroundRepeat='repeat, no-repeat';
      node.style.setProperty('-webkit-background-clip','text','important');
      node.style.setProperty('background-clip','text','important');
      node.style.setProperty('-webkit-text-fill-color','transparent','important');
      node.style.color='transparent';
      node.style.filter='drop-shadow(0 1px 0 rgba(255,255,255,.33)) drop-shadow(0 2px 2px rgba(0,0,0,.32))';
      node.style.textShadow='none';
      node.style.letterSpacing='0.01em';
    }else{
      node.style.color=colour;
      node.style.background='none';
    }
  }
  function pp14GetGapColour(){const colour=window.__pp14GapColour||'#ffffff';return /^#[0-9a-fA-F]{6}$/.test(colour)?colour:'#ffffff';}
  function pp14SetGapColour(colour){window.__pp14GapColour=/^#[0-9a-fA-F]{6}$/.test(colour)?colour:'#ffffff';const field=root.querySelector('[data-v14-color]');if(field)field.value=window.__pp14GapColour;const legacy=root.querySelector('[data-bg]');if(legacy)legacy.value=window.__pp14GapColour;safeRender();}


  // V14 — live large editor, print-backed gap colour, active-copy saving and review.
  const pp14CSS = document.createElement('style');
  pp14CSS.textContent = `
    /* V14.1: Don't show advanced editing until photo review is completed. */
    #pp-collage-v1 .ppc-v14-toolbar {display:none!important;box-sizing:border-box;width:100%;max-width:100%;margin:0 0 14px;padding:15px 16px;background:#f6f9ff;border:1px solid #d7e3f5;border-radius:15px;gap:13px;box-shadow:none}
    #pp-collage-v1.ppc-v14-ready:not(.ppc-review-mode) [data-editor]:not([hidden]) > .ppc-v14-toolbar {display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1.4fr);align-items:stretch}
    #pp-collage-v1 .ppc-v14-tool-group {min-width:0;display:flex;flex-wrap:wrap;align-items:center;gap:8px;padding:0;}
    #pp-collage-v1 .ppc-v14-tool-group + .ppc-v14-tool-group {padding-left:15px;border-left:1px solid #d5e1f0;}
    #pp-collage-v1 .ppc-v14-tool-title {flex:0 0 100%;margin:0 0 2px;font-size:13px;font-weight:800;color:#173a6b;}
    #pp-collage-v1 .ppc-v14-tool-group [data-v14-full] {background:#174fa4;color:white;border-color:#174fa4;}
    #pp-collage-v1 .ppc-v14-tool-group [data-v14-copy] {background:white;}
    #pp-collage-v1 .ppc-v14-toolbar button{min-height:42px;border:1px solid #b7cde8;background:#fff;border-radius:10px;padding:9px 13px;color:#123c70;font-weight:750;cursor:pointer}
    #pp-collage-v1 .ppc-v14-toolbar button:focus-visible{outline:3px solid #155bd5;outline-offset:2px}
    #pp-collage-v1 .ppc-v14-toolbar label{display:inline-flex;align-items:center;gap:8px;color:#15385d;font-weight:700;font-size:13px}
    #pp-collage-v1 .ppc-v14-toolbar input[type=color]{width:42px;height:38px;border:1px solid #b7cde8;border-radius:8px;padding:2px;background:#fff}
    #pp-collage-v1 .ppc-v14-toolbar button[data-v14-active]{background:#1859c8;color:#fff}
    #pp-collage-v1.ppc-v14-full:not(.ppc-review-mode) [data-editor] > .ppc-workspace > .ppc-canvas-stage{position:fixed!important;inset:50px 12px 12px!important;z-index:2147483602!important;width:calc(100vw - 24px)!important;height:calc(100dvh - 62px)!important;max-width:none!important;max-height:none!important;background:#e9eff7!important;border-radius:15px!important;box-sizing:border-box!important;overflow:auto!important;display:flex!important;justify-content:center!important;align-items:center!important;padding:12px!important;box-shadow:none!important;}
    #pp-collage-v1.ppc-v14-full .ppc-canvas-stage > [data-board]{position:relative!important;flex:0 0 auto!important;width:min(100%,calc((100dvh - 105px) * var(--ppc-stage-ratio,1.5)))!important;max-width:100%!important;height:auto!important;aspect-ratio:var(--ppc-stage-ratio,1.5)!important;box-shadow:0 4px 30px #0003!important;}
    .ppc-v14-backdrop[hidden],.ppc-v14-full-head[hidden]{display:none!important}
    .ppc-v14-backdrop{position:fixed;inset:0;z-index:2147483600;background:#122036e8}
    .ppc-v14-full-head{position:fixed;top:0;left:0;right:0;height:50px;z-index:2147483603;background:#fff;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:0 14px;color:#15355c;box-sizing:border-box;font-size:14px;font-weight:750}
    .ppc-v14-full-head button{background:#145dc9;color:#fff;border:0;padding:9px 15px;border-radius:9px;font-weight:750;cursor:pointer;min-height:38px}
    #ppc-v13-review .ppc-v14-review-preview:not([hidden]){display:block;width:100%;height:210px;object-fit:contain;background:#e7edf5;border-radius:12px;margin:14px 0}
    @media (max-width:767px){#pp-collage-v1.ppc-v14-ready:not(.ppc-review-mode) [data-editor]:not([hidden]) > .ppc-v14-toolbar{grid-template-columns:minmax(0,1fr);order:-27!important;margin:0 0 6px;padding:12px}#pp-collage-v1 .ppc-v14-tool-group + .ppc-v14-tool-group{padding:12px 0 0;border-left:0;border-top:1px solid #d5e1f0}#pp-collage-v1 .ppc-v14-toolbar button{min-height:40px}#pp-collage-v1.ppc-v14-full .ppc-canvas-stage{inset:50px 5px 5px!important;width:calc(100vw - 10px)!important;height:calc(100dvh - 55px)!important;padding:5px!important}}
  `;
  document.head.appendChild(pp14CSS);
  // V14.2: Focused full-screen editing. Prevent other editor controls from
  // sitting above the canvas or cluttering the lower-left of the overlay.
  // Everything returns automatically when the ppc-v14-full class is removed.
  const pp14FullCleanCSS=document.createElement('style');
  pp14FullCleanCSS.textContent=`
    #pp-collage-v1.ppc-v14-full [data-editor] > :not(.ppc-workspace),
    #pp-collage-v1.ppc-v14-full [data-editor] > .ppc-workspace > :not(.ppc-canvas-stage) {
      visibility:hidden!important;pointer-events:none!important;
    }
    #pp-collage-v1.ppc-v14-full [data-editor] > .ppc-workspace > .ppc-canvas-stage {
      visibility:visible!important;pointer-events:auto!important;
      position:fixed!important;top:64px!important;left:0!important;right:0!important;bottom:0!important;
      inset:64px 0 0!important;width:100vw!important;height:calc(100dvh - 64px)!important;
      margin:0!important;max-width:none!important;max-height:none!important;
      padding:16px!important;overflow:auto!important;display:flex!important;
      align-items:center!important;justify-content:center!important;
      border-radius:0!important;background:#edf2f8!important;
      box-shadow:none!important;z-index:2147483602!important;
    }
    #pp-collage-v1.ppc-v14-full .ppc-canvas-stage > [data-board] {
      position:relative!important;flex:0 0 auto!important;
      width:min(calc(100vw - 48px),calc((100dvh - 112px) * var(--ppc-stage-ratio,1.5)))!important;
      max-width:100%!important;max-height:calc(100dvh - 112px)!important;
      height:auto!important;aspect-ratio:var(--ppc-stage-ratio,1.5)!important;
      margin:auto!important;
    }
    .ppc-v14-full-head {height:64px!important;min-height:64px!important;gap:18px!important;padding:8px 24px!important;box-shadow:0 2px 12px #0001!important;}
    .ppc-v14-full-head span {font-size:14px;line-height:1.4;min-width:0;}
    .ppc-v14-full-head button {flex:0 0 auto;white-space:nowrap;}
    @media(max-width:767px){
      #pp-collage-v1.ppc-v14-full [data-editor] > .ppc-workspace > .ppc-canvas-stage {
        inset:64px 0 0!important;width:100vw!important;height:calc(100dvh - 64px)!important;padding:8px!important;
      }
      #pp-collage-v1.ppc-v14-full .ppc-canvas-stage > [data-board] {
        width:min(calc(100vw - 20px),calc((100dvh - 90px) * var(--ppc-stage-ratio,1.5)))!important;
        max-height:calc(100dvh - 90px)!important;
      }
      .ppc-v14-full-head{padding:7px 10px!important;gap:8px!important;}
      .ppc-v14-full-head span{font-size:12px!important;}
      .ppc-v14-full-head button{padding:9px 10px!important;font-size:12px!important;}
    }
  `;
  document.head.appendChild(pp14FullCleanCSS);
  // V14.7: Prevent Shopify's sticky header from covering the large collage.
  // Only suppress storefront navigation while immersive editing is active.
  const pp147HeaderFixCSS=document.createElement('style');
  pp147HeaderFixCSS.textContent=`
    body.ppc-v147-immersive #shopify-section-header,
    body.ppc-v147-immersive .shopify-section-group-header-group,
    body.ppc-v147-immersive .shopify-section--header,
    body.ppc-v147-immersive .header-wrapper,
    body.ppc-v147-immersive .site-header,
    body.ppc-v147-immersive header[role="banner"],
    body.ppc-v147-immersive #shopify-section-announcement-bar,
    body.ppc-v147-immersive .announcement-bar-section {
      visibility:hidden!important;
      pointer-events:none!important;
      opacity:0!important;
    }
    body.ppc-v147-immersive {overflow:hidden!important;}
    body.ppc-v147-immersive #pp-collage-v1.ppc-v14-full .ppc-canvas-stage > [data-board] {
      max-height:calc(100dvh - 108px)!important;
      max-width:calc(100vw - 32px)!important;
    }
    @media(max-width:767px){
      body.ppc-v147-immersive #pp-collage-v1.ppc-v14-full .ppc-canvas-stage > [data-board]{
        max-height:calc(100dvh - 88px)!important;
        max-width:calc(100vw - 16px)!important;
      }
    }
  `;
  document.head.appendChild(pp147HeaderFixCSS);
  const pp14Toolbar=make('div','ppc-v14-toolbar');
  pp14Toolbar.innerHTML='<div class="ppc-v14-tool-group"><p class="ppc-v14-tool-title">Edit your collage</p><button type="button" data-v14-full>⛶ Edit in Large View</button><button type="button" data-v14-copy>Duplicate My Collage</button></div><div class="ppc-v14-tool-group"><p class="ppc-v14-tool-title">Photo spacing colour</p><label>Custom colour <input type="color" data-v14-color value="#ffffff" aria-label="Choose photo gap colour"></label><button type="button" data-v14-white>White</button><button type="button" data-v14-black>Black</button></div>';
  // V14.4: Keep the underlying duplicate workflow and quality estimator available
  // to existing code, but remove their customer-facing controls and panel.
  // The photo-quality information can still power existing order safety warnings.
  const pp144CleanStyle = document.createElement('style');
  pp144CleanStyle.textContent = `
    #pp-collage-v1 .ppc-v143-duplicate,
    #pp-collage-v1 [data-v14-copy],
    #pp-collage-v1 .ppc-quality-panel,
    #pp-collage-v1 .ppc-quality-chip { display:none!important; }
  `;
  // V14.3: Put spacing colours alongside the actual spacing presets,
  // and place the large editor button in the live-preview header.
  const pp14Editor=$('[data-editor]');
  const pp14SpacingGroup=pp14Toolbar.querySelectorAll('.ppc-v14-tool-group')[1];
  const pp14MainGroup=pp14Toolbar.querySelectorAll('.ppc-v14-tool-group')[0];
  const pp14GapRow=v11Panel.querySelector('.ppc-v11-gap-row');
  if(pp14GapRow && pp14SpacingGroup){
    pp14GapRow.after(pp14SpacingGroup);
    pp14SpacingGroup.classList.add('ppc-v143-spacing-colours');
    pp14SpacingGroup.querySelector('.ppc-v14-tool-title').textContent='Photo spacing colour';
  }
  const pp14DuplicateButton=pp14MainGroup.querySelector('[data-v14-copy]');
  if(pp14SpacingGroup && pp14DuplicateButton){
    const pp14DuplicateRow=make('div','ppc-v143-duplicate');
    pp14DuplicateRow.appendChild(pp14DuplicateButton);
    pp14SpacingGroup.after(pp14DuplicateRow);
  }
  const pp14OriginalPreviewExpand=root.querySelector('[data-action="preview-size"]');
  const pp14FullTrigger=pp14MainGroup.querySelector('[data-v14-full]');
  if(pp14OriginalPreviewExpand && pp14FullTrigger){
    pp14OriginalPreviewExpand.hidden=true;
    pp14OriginalPreviewExpand.style.setProperty('display','none','important');
    pp14OriginalPreviewExpand.after(pp14FullTrigger);
    pp14FullTrigger.classList.add('ppc-v143-preview-full-button');
    pp14FullTrigger.textContent = 'Edit in Large View';
    pp14FullTrigger.setAttribute('aria-label','Edit collage in Large View');
    pp14FullTrigger.style.setProperty('display','inline-flex','important');
    pp14FullTrigger.style.setProperty('align-items','center','important');
    pp14FullTrigger.style.setProperty('justify-content','center','important');
    pp14FullTrigger.style.setProperty('color','#ffffff','important');
    pp14FullTrigger.style.setProperty('font-size','13px','important');
    pp14FullTrigger.style.setProperty('text-align','center','important');
    pp14FullTrigger.style.setProperty('min-width','130px','important');
    pp14FullTrigger.style.setProperty('white-space','normal','important');
  }
  // V14.9.43: Mobile themes hide the old preview-size button container.
  // Place the actual full-view control in the visible preview header instead.
  if (pp14FullTrigger && window.matchMedia('(max-width: 767px)').matches) {
    const previewHead = root.querySelector('[data-editor] .ppc-workspace-head') ||
      root.querySelector('[data-editor] .ppc-workspace');
    if (previewHead) {
      previewHead.appendChild(pp14FullTrigger);
      pp14FullTrigger.hidden = false;
      pp14FullTrigger.textContent = '⛶ Edit in Large View';
      pp14FullTrigger.style.setProperty('display','inline-flex','important');
    }
  }
  if (pp14FullTrigger) {
    pp14FullTrigger.textContent='⛶ Large View';
    pp14FullTrigger.style.setProperty('color','#ffffff','important');
    pp14FullTrigger.style.setProperty('-webkit-text-fill-color','#ffffff','important');
    pp14FullTrigger.style.setProperty('background-color','#174fa4','important');
    pp14FullTrigger.style.setProperty('visibility','visible','important');
    pp14FullTrigger.setAttribute('aria-label','Open collage in Large View');
  }
  // No old floating toolbar should remain on the left.
  pp14Toolbar.remove();
  const pp143Style=document.createElement('style');
  pp143Style.textContent=`
    #pp-collage-v1 .ppc-v143-spacing-colours,
    #pp-collage-v1 .ppc-v143-duplicate {display:none!important;}
    #pp-collage-v1 .ppc-v11-layouts.ppc-v13-collapsed .ppc-v143-spacing-colours,
    #pp-collage-v1 .ppc-v11-layouts.ppc-v13-collapsed .ppc-v143-duplicate {display:none!important;}
    #pp-collage-v1.ppc-v14-ready:not(.ppc-review-mode) .ppc-v143-spacing-colours {display:flex!important;flex-direction:row;flex-wrap:wrap;gap:8px;align-items:center;margin-top:16px;padding:14px 0 0;border-top:1px solid #d8e5f8;border-left:0;min-width:0;}
    #pp-collage-v1.ppc-v14-ready:not(.ppc-review-mode) .ppc-v143-duplicate {display:block!important;margin-top:13px;}
    #pp-collage-v1 .ppc-v143-spacing-colours .ppc-v14-tool-title {flex-basis:100%;font-size:14px;font-weight:800;margin:0 0 3px;color:#17345c;}
    #pp-collage-v1 .ppc-v143-spacing-colours label {display:flex;align-items:center;flex-wrap:wrap;gap:8px;min-width:0;color:#17345c;font-weight:650;font-size:13px;}
    #pp-collage-v1 .ppc-v143-spacing-colours input[type=color]{width:42px;height:38px;padding:2px;border:1px solid #b7cde8;border-radius:8px;background:#fff;cursor:pointer;}
    #pp-collage-v1 .ppc-v143-spacing-colours button,
    #pp-collage-v1 .ppc-v143-duplicate button{min-height:42px;padding:9px 13px;border:1px solid #b7cde8;border-radius:10px;background:#fff;color:#123c70;font-weight:750;cursor:pointer;max-width:100%;white-space:normal;}
    #pp-collage-v1 .ppc-v143-preview-full-button{min-height:44px;padding:10px 15px;border:1px solid #174fa4;border-radius:10px;background:#174fa4;color:#fff;font-weight:800;cursor:pointer;white-space:normal;}
    #pp-collage-v1 .ppc-v143-preview-full-button:focus-visible,
    #pp-collage-v1 .ppc-v143-spacing-colours button:focus-visible{outline:3px solid #1265ee;outline-offset:2px;}
    #pp-collage-v1 [data-action="preview-size"]{display:none!important;}
    #pp-collage-v1.ppc-review-mode .ppc-v143-preview-full-button,
    #pp-collage-v1:not(.ppc-v14-ready) .ppc-v143-preview-full-button{display:none!important;}
    @media(max-width:640px){#pp-collage-v1 .ppc-v143-preview-full-button{font-size:12px;min-height:40px;padding:8px 10px;}#pp-collage-v1 .ppc-v143-spacing-colours{gap:7px!important;}}
  `;
  const pp143MobileLargeView = document.createElement('style');
  pp143MobileLargeView.textContent = `
    @media(max-width:767px){
      #pp-collage-v1.ppc-v14-ready:not(.ppc-review-mode) .ppc-workspace-head .ppc-v143-preview-full-button,
      #pp-collage-v1.ppc-v14-ready:not(.ppc-review-mode) .ppc-workspace > .ppc-v143-preview-full-button{
        display:inline-flex!important;visibility:visible!important;opacity:1!important;
        align-items:center!important;justify-content:center!important;
        width:auto!important;min-width:155px!important;max-width:100%!important;
        margin:8px 0!important;padding:11px 14px!important;
        color:#fff!important;background:#174fa4!important;border:1px solid #174fa4!important;
        font-size:14px!important;line-height:1.3!important;white-space:normal!important;
        position:relative!important;z-index:2!important;
      }
    }
  `;
  document.head.appendChild(pp143MobileLargeView);
  document.head.appendChild(pp143Style);
  document.head.appendChild(pp144CleanStyle);
  root.classList.toggle('ppc-v14-ready', !state.reviewMode && state.photos.length > 0);
  // V14.9.80: Match both native custom-colour pickers to the preset swatch cards.
  const pp1479ColourCards=document.createElement('style');
  pp1479ColourCards.textContent=`
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-custom-colour{
      display:flex!important;flex-direction:column!important;align-items:center!important;
      justify-content:center!important;gap:5px!important;margin:0!important;
      width:100%!important;min-height:83px!important;padding:8px 4px!important;
      border:2px solid #d8e4f5!important;border-radius:13px!important;
      background:#fff!important;box-sizing:border-box!important;cursor:pointer!important;
      color:#193c6a!important;font-size:11px!important;font-weight:700!important;text-align:center!important;
    }
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-custom-colour input[type=color]{
      display:block!important;width:40px!important;height:37px!important;min-height:37px!important;
      border-radius:9px!important;padding:2px!important;margin:0!important;
      border:1px solid #9aafc9!important;cursor:pointer!important;
    }
    #pp-collage-v1 .ppc-v1498-colour-group .ppc-v149-custom-colour small{font-size:11px!important;line-height:1.1!important;}
    #pp-collage-v1 .ppc-v143-spacing-colours > label:has([data-v14-color]){
      display:flex!important;flex-direction:column!important;align-items:center!important;
      justify-content:center!important;gap:7px!important;min-height:104px!important;
      padding:7px!important;margin:0!important;border:2px solid #d8e4f5!important;
      border-radius:13px!important;background:#fff!important;color:#193c6a!important;
      font-size:12px!important;font-weight:750!important;box-sizing:border-box!important;
      cursor:pointer!important;min-width:0!important;
    }
    #pp-collage-v1 .ppc-v143-spacing-colours > label:has([data-v14-color]) input[type=color]{
      display:block!important;width:100%!important;height:57px!important;
      min-height:57px!important;border-radius:8px!important;padding:2px!important;
      border:1px solid #d9e2f0!important;background:#fff!important;cursor:pointer!important;
    }
    #pp-collage-v1 .ppc-v143-spacing-colours{display:flex!important;flex-wrap:wrap!important;gap:9px!important;align-items:stretch!important;}
    #pp-collage-v1 .ppc-v143-spacing-colours > label:has([data-v14-color]){flex:1 1 110px!important;max-width:190px!important;}
    #pp-collage-v1 .ppc-v143-spacing-colours > button{min-height:45px!important;}
  `;
  document.head.appendChild(pp1479ColourCards);
  const pp14Colour=pp14SpacingGroup.querySelector('[data-v14-color]');
  // Preserve colours when controls are restored by My Designs or local drafts.
  window.__pp14GapColour = '#ffffff';
  pp14Colour.addEventListener('input',()=>{pp1498SetBackground('solid',false);window.__pp14GapColour=pp14Colour.value;const legacy=root.querySelector('[data-bg]');if(legacy)legacy.value=window.__pp14GapColour;safeRender();});
  pp14SpacingGroup.querySelector('[data-v14-white]').addEventListener('click',()=>{pp1498SetBackground('solid',false);pp14SetGapColour('#ffffff');});
  pp14SpacingGroup.querySelector('[data-v14-black]').addEventListener('click',()=>{pp1498SetBackground('solid',false);pp14SetGapColour('#000000');});
  // V14.9.14: Decorative background choices removed at customer request.
  pp1498SetBackground('solid',false);
  pp14DuplicateButton.addEventListener('click',()=>{
    if(!state.photos.length){status('Add photographs before making a copy.');return;}
    saveAsNewButton.click(); // Existing account-backed Save As New flow.
  });
  const pp14BackDrop=make('div','ppc-v14-backdrop');pp14BackDrop.hidden=true;
  const pp14FullHead=make('div','ppc-v14-full-head');pp14FullHead.hidden=true;
  pp14FullHead.innerHTML='<span>Large collage editor — tap a photo to edit or drag to swap</span><button type="button">Close large view ✕</button>';
  document.body.append(pp14BackDrop,pp14FullHead);
  const pp14FullButton=pp14FullTrigger;
  // V14.9.44: Optional landscape hint. Orientation lock may be unavailable
  // on iOS and in embedded browsers, so do not require orientation changes.
  const pp144RotateHint=document.createElement('div');
  pp144RotateHint.className='ppc-v144-rotate-hint';
  pp144RotateHint.hidden=true;
  pp144RotateHint.setAttribute('role','dialog');
  pp144RotateHint.setAttribute('aria-modal','true');
  pp144RotateHint.setAttribute('aria-label','Landscape viewing tip');
  pp144RotateHint.innerHTML=`<div class="ppc-v144-rotate-panel">
    <div class="ppc-v144-phone-diagram" aria-hidden="true">
      <span class="ppc-v144-phone"><span class="ppc-v144-phone-screen"></span></span>
      <svg viewBox="0 0 48 48" width="46" height="46" aria-hidden="true"><path d="M12 26a14 14 0 0 1 24-10M36 16v-9m0 9h-9" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
      <span class="ppc-v144-phone ppc-v144-phone-landscape"><span class="ppc-v144-phone-screen"></span></span>
    </div>
    <h2>Turn your phone 90°</h2>
    <p>For the best view of your landscape collage, turn your phone sideways.</p>
    <p class="ppc-v144-muted">Rotation locked? You can still use Large View.</p>
    <button type="button" class="ppc-v144-continue">Continue Anyway</button>
  </div>`;
  document.body.appendChild(pp144RotateHint);
  const pp144HintStyle=document.createElement('style');
  pp144HintStyle.textContent=`
    .ppc-v144-rotate-hint[hidden]{display:none!important}
    .ppc-v144-rotate-hint{position:fixed!important;inset:0!important;z-index:2147483600!important;background:rgba(13,23,40,.85)!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:auto!important;box-sizing:border-box!important}
    .ppc-v144-rotate-panel{width:min(100%,400px)!important;max-height:calc(100dvh - 40px)!important;overflow-y:auto!important;background:white!important;color:#172033!important;border-radius:22px!important;padding:26px 20px!important;text-align:center!important;box-sizing:border-box!important;font-family:inherit!important}
    .ppc-v144-rotate-panel h2{font-size:24px!important;line-height:1.2!important;margin:8px 0 12px!important;color:#172033!important}
    .ppc-v144-rotate-panel p{font-size:15px!important;line-height:1.45!important;margin:0 0 15px!important}
    .ppc-v144-muted{color:#64748b!important;font-size:13px!important}
    .ppc-v144-phone-diagram{display:flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;color:#2468d8!important;height:110px!important}
    .ppc-v144-phone{display:block!important;position:relative!important;width:49px!important;height:90px!important;border:5px solid #1b55b2!important;border-radius:12px!important;box-sizing:border-box!important;transform:rotate(0deg)!important}
    .ppc-v144-phone-screen{position:absolute!important;inset:7px 4px!important;border-radius:3px!important;background:linear-gradient(135deg,#d5e7ff,#85b5f5)!important}
    .ppc-v144-phone-landscape{transform:rotate(90deg)!important;margin:0 18px!important}
    .ppc-v144-continue{display:block!important;width:100%!important;border:0!important;background:#1768d6!important;color:#fff!important;border-radius:12px!important;font-weight:700!important;font-size:16px!important;padding:14px!important;cursor:pointer!important}
  `;
  document.head.appendChild(pp144HintStyle);
  function pp144IsPortraitMobile(){
    return window.matchMedia('(max-width: 767px) and (orientation: portrait)').matches;
  }
  function pp144IsLandscapeCanvas(){
    if(!selectedProduct)return false;
    if(selectedProduct.orientation==='landscape')return true;
    if(selectedProduct.orientation==='portrait'||selectedProduct.orientation==='square')return false;
    const w=Number(selectedProduct.widthIn),h=Number(selectedProduct.heightIn);
    return Number.isFinite(w)&&Number.isFinite(h)&&w>h;
  }
  function pp144DismissHint(){pp144RotateHint.hidden=true;}
  pp144RotateHint.querySelector('.ppc-v144-continue').addEventListener('click',pp144DismissHint);
  const pp144OnOrientationChange=()=>{
    if(!pp144IsPortraitMobile())pp144DismissHint();
  };
  window.addEventListener('resize',pp144OnOrientationChange,{passive:true});
  window.addEventListener('orientationchange',pp144OnOrientationChange,{passive:true});
  function pp14CloseFull(){
    pp144DismissHint();
    root.classList.remove('ppc-v14-full');
    document.body.classList.remove('ppc-v147-immersive');
    pp14BackDrop.hidden=true;pp14FullHead.hidden=true;
    document.body.style.overflow=pp14PrevOverflow||'';
    pp14FullButton.textContent='Edit in Large View';
    safeRender();
    pp14FullButton.focus();
  }
  let pp14PrevOverflow='';
  pp14FullButton.addEventListener('click',()=>{
    if(!state.photos.length){status('Upload some photos to open the large editor.');return;}
    if(root.classList.contains('ppc-v14-full')){pp14CloseFull();return;}
    pp14PrevOverflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
    root.classList.add('ppc-v14-full');
    document.body.classList.add('ppc-v147-immersive');
    pp14BackDrop.hidden=false;pp14FullHead.hidden=false;
    pp14FullButton.textContent='Close Large View';
    safeRender();
    if(pp144IsPortraitMobile() && pp144IsLandscapeCanvas()){
      pp144RotateHint.hidden=false;
      pp144RotateHint.querySelector('.ppc-v144-continue').focus();
    }
    pp14FullHead.querySelector('button').focus();
  });
  pp14FullHead.querySelector('button').addEventListener('click',pp14CloseFull);
  pp14BackDrop.addEventListener('click',pp14CloseFull);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&root.classList.contains('ppc-v14-full')&&!state.activeCrop){e.preventDefault();pp14CloseFull();}});
  // Add a preview to the existing confirmed order review. It uses a bitmap
  // generated by the same browser canvas renderer used for saved thumbnails.
  const pp14ReviewImg=make('img','ppc-v14-review-preview');
  pp14ReviewImg.alt='Your finished photo collage preview';
  pp14ReviewImg.hidden=true;
  const pp14ReviewDetails=ppReviewOverlay.querySelector('[data-v13-details]');
  pp14ReviewDetails?.before(pp14ReviewImg);
  const pp14ReviewButton=ppReviewOverlay.querySelector('[data-v13-back]');
  pp14ReviewButton?.addEventListener('click',()=>{pp14ReviewImg.removeAttribute('src');pp14ReviewImg.hidden=true;});
  // V14.9.1: Generate review artwork from the *visible collage tiles* directly,
  // independent of html2canvas/CSS transforms. This is a review preview only;
  // the paid print file continues to come from the server renderer.
  async function ppMakeReliableReviewImage(){
    const board=$('[data-board]');
    if(!board)throw new Error('Collage not ready');
    const rect=board.getBoundingClientRect();
    if(rect.width<2||rect.height<2)throw new Error('Collage has no visible size');
    const w=1100,h=Math.max(1,Math.round(w*rect.height/rect.width));
    const canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;
    const ctx=canvas.getContext('2d');
    ctx.fillStyle=getComputedStyle(board).backgroundColor||'#ffffff';
    ctx.fillRect(0,0,w,h);
    const tiles=[...board.querySelectorAll('[data-ppc-photo]')];
    for(const tile of tiles){
      const image=tile.querySelector('img');
      if(!image)continue;
      const r=tile.getBoundingClientRect();
      const x=(r.left-rect.left)/rect.width*w,y=(r.top-rect.top)/rect.height*h;
      const tw=r.width/rect.width*w,th=r.height/rect.height*h;
      if(tw<=0||th<=0)continue;
      if(!image.complete)await new Promise(resolve=>{image.addEventListener('load',resolve,{once:true});image.addEventListener('error',resolve,{once:true});setTimeout(resolve,1800);});
      if(!image.naturalWidth)continue;
      const naturalW=image.naturalWidth,naturalH=image.naturalHeight;
      const fit=getComputedStyle(image).objectFit;
      const scale=fit==='contain'?Math.min(tw/naturalW,th/naturalH):Math.max(tw/naturalW,th/naturalH);
      const dw=naturalW*scale,dh=naturalH*scale;
      ctx.save();ctx.beginPath();ctx.rect(x,y,tw,th);ctx.clip();
      ctx.fillStyle=getComputedStyle(tile).backgroundColor||getComputedStyle(board).backgroundColor||'#fff';ctx.fillRect(x,y,tw,th);
      ctx.filter=getComputedStyle(image).filter||'none';
      ctx.drawImage(image,x+(tw-dw)/2,y+(th-dh)/2,dw,dh);
      ctx.restore();
    }
    // Any text band/overlay is captured when html2canvas is available;
    // this fallback prioritises displaying all actual photo tiles.
    return canvas.toDataURL('image/jpeg',.85);
  }
  let ppReviewGeneration=0;
  async function ppPopulateReviewPreview(){
    const generation=++ppReviewGeneration;
    pp14ReviewImg.hidden=true;
    pp14ReviewImg.removeAttribute('src');
    if(ppReviewOverlay.hidden)return;
    try{
      // Preferred method includes reserved text and decorations.
      const blob=await Promise.race([
        createFinishedCollageThumbnail(),
        new Promise((_,reject)=>setTimeout(()=>reject(new Error('capture timeout')),3500))
      ]);
      if(generation!==ppReviewGeneration||ppReviewOverlay.hidden)return;
      const url=URL.createObjectURL(blob);
      pp14ReviewImg.onload=()=>URL.revokeObjectURL(url);
      pp14ReviewImg.onerror=()=>{URL.revokeObjectURL(url);pp14ReviewImg.hidden=true;};
      pp14ReviewImg.src=url;
      pp14ReviewImg.hidden=false;
    }catch(error){
      try{
        const src=await ppMakeReliableReviewImage();
        if(generation!==ppReviewGeneration||ppReviewOverlay.hidden)return;
        pp14ReviewImg.src=src;
        pp14ReviewImg.hidden=false;
      }catch(fallbackError){console.warn('Review preview unavailable',error,fallbackError);}
    }
  }
  // Capture phase: after the original click handler opens the review,
  // start generation on the next microtask, rather than relying on a second
  // normal-phase click listener that might be bypassed by stopImmediatePropagation.
  cartButton.addEventListener('click',()=>{
    queueMicrotask(()=>{if(!ppReviewOverlay.hidden)ppPopulateReviewPreview();});
  },true);
  // Also populate when confirmed modal is shown by keyboard/other code.
  const ppReviewPreviewObserver=new MutationObserver(()=>{
    if(!ppReviewOverlay.hidden&&!pp14ReviewImg.src)ppPopulateReviewPreview();
  });
  ppReviewPreviewObserver.observe(ppReviewOverlay,{attributes:true,attributeFilter:['hidden']});
  ppReviewButton?.addEventListener('click',()=>{++ppReviewGeneration;});


})();
